import { baseApi as api } from '../../store/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    appControllerGetHello: build.query<
      AppControllerGetHelloApiResponse,
      AppControllerGetHelloApiArg
    >({
      query: () => ({ url: `/` }),
    }),
    metricsControllerWebhook: build.query<
      MetricsControllerWebhookApiResponse,
      MetricsControllerWebhookApiArg
    >({
      query: () => ({ url: `/metrics` }),
    }),
    refreshTokensControllerRefreshTokenUser: build.mutation<
      RefreshTokensControllerRefreshTokenUserApiResponse,
      RefreshTokensControllerRefreshTokenUserApiArg
    >({
      query: () => ({ url: `/v1/user/refresh-token`, method: 'POST' }),
    }),
    refreshTokensControllerRefreshTokenAdmin: build.mutation<
      RefreshTokensControllerRefreshTokenAdminApiResponse,
      RefreshTokensControllerRefreshTokenAdminApiArg
    >({
      query: () => ({ url: `/v1/admin/refresh-token`, method: 'POST' }),
    }),
    signInControllerSignInUser: build.mutation<
      SignInControllerSignInUserApiResponse,
      SignInControllerSignInUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/user/sign-in`,
        method: 'POST',
        body: queryArg.signInRequestDto,
      }),
    }),
    signInControllerSignInAdmin: build.mutation<
      SignInControllerSignInAdminApiResponse,
      SignInControllerSignInAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/admin/sign-in`,
        method: 'POST',
        body: queryArg.signInRequestDto,
      }),
    }),
    signOutControllerSignOutUser: build.mutation<
      SignOutControllerSignOutUserApiResponse,
      SignOutControllerSignOutUserApiArg
    >({
      query: () => ({ url: `/v1/user/sign-out`, method: 'POST' }),
    }),
    signOutControllerSignOutAdmin: build.mutation<
      SignOutControllerSignOutAdminApiResponse,
      SignOutControllerSignOutAdminApiArg
    >({
      query: () => ({ url: `/v1/admin/sign-out`, method: 'POST' }),
    }),
    apiKeyControllerGetSystemApiKeyInfo: build.query<
      ApiKeyControllerGetSystemApiKeyInfoApiResponse,
      ApiKeyControllerGetSystemApiKeyInfoApiArg
    >({
      query: (queryArg) => ({ url: `/v1/system/api-keys/${queryArg.jti}` }),
    }),
    oidcLoginStartControllerAuthorize: build.query<
      OidcLoginStartControllerAuthorizeApiResponse,
      OidcLoginStartControllerAuthorizeApiArg
    >({
      query: () => ({ url: `/v1/auth/oidc/authorize` }),
    }),
    oidcLoginCompleteControllerCallback: build.query<
      OidcLoginCompleteControllerCallbackApiResponse,
      OidcLoginCompleteControllerCallbackApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/auth/oidc/callback`,
        params: {
          state: queryArg.state,
          code: queryArg.code,
          error: queryArg.error,
          error_description: queryArg.errorDescription,
        },
      }),
    }),
    forgotPasswordControllerForgotPassword: build.mutation<
      ForgotPasswordControllerForgotPasswordApiResponse,
      ForgotPasswordControllerForgotPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/user/forgot-password`,
        method: 'POST',
        body: queryArg.forgotPasswordRequestDto,
      }),
    }),
    resetPasswordControllerResetPassword: build.mutation<
      ResetPasswordControllerResetPasswordApiResponse,
      ResetPasswordControllerResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/user/reset-password`,
        method: 'POST',
        body: queryArg.resetPasswordRequestDto,
      }),
    }),
    userMeControllerUserMe: build.query<
      UserMeControllerUserMeApiResponse,
      UserMeControllerUserMeApiArg
    >({
      query: () => ({ url: `/v1/users/me` }),
    }),
    userListControllerList: build.query<
      UserListControllerListApiResponse,
      UserListControllerListApiArg
    >({
      query: () => ({ url: `/v2/users` }),
    }),
    userListControllerListForManager: build.query<
      UserListControllerListForManagerApiResponse,
      UserListControllerListForManagerApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/companies/${queryArg.id}/users` }),
    }),
    userCreateControllerCreateUser: build.mutation<
      UserCreateControllerCreateUserApiResponse,
      UserCreateControllerCreateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/users`,
        method: 'POST',
        body: queryArg.userCreateRequestDto,
      }),
    }),
    userUpdateControllerUpdate: build.mutation<
      UserUpdateControllerUpdateApiResponse,
      UserUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/users/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.userUpdateRequestDto,
      }),
    }),
    adminMeControllerAdminMe: build.query<
      AdminMeControllerAdminMeApiResponse,
      AdminMeControllerAdminMeApiArg
    >({
      query: () => ({ url: `/v1/admins/me` }),
    }),
    permissionGroupCreateControllerCreate: build.mutation<
      PermissionGroupCreateControllerCreateApiResponse,
      PermissionGroupCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/permission-groups`,
        method: 'POST',
        body: queryArg.permissionGroupCreateRequestDto,
      }),
    }),
    permissionGroupListControllerList: build.query<
      PermissionGroupListControllerListApiResponse,
      PermissionGroupListControllerListApiArg
    >({
      query: () => ({ url: `/v2/permission-groups` }),
    }),
    permissionGroupCreateControllerCreateForManager: build.mutation<
      PermissionGroupCreateControllerCreateForManagerApiResponse,
      PermissionGroupCreateControllerCreateForManagerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/permission-groups`,
        method: 'POST',
        body: queryArg.permissionGroupCreateRequestDto,
      }),
    }),
    permissionGroupListControllerListForManager: build.query<
      PermissionGroupListControllerListForManagerApiResponse,
      PermissionGroupListControllerListForManagerApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/companies/${queryArg.id}/permission-groups` }),
    }),
    permissionGroupUpdateControllerUpdate: build.mutation<
      PermissionGroupUpdateControllerUpdateApiResponse,
      PermissionGroupUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/permission-groups/${queryArg.groupId}`,
        method: 'PATCH',
        body: queryArg.permissionGroupUpdateRequestDto,
      }),
    }),
    permissionGroupDeleteControllerDelete: build.mutation<
      PermissionGroupDeleteControllerDeleteApiResponse,
      PermissionGroupDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/v2/permission-groups/${queryArg.groupId}`, method: 'DELETE' }),
    }),
    permissionGroupUpdateControllerUpdateForManager: build.mutation<
      PermissionGroupUpdateControllerUpdateForManagerApiResponse,
      PermissionGroupUpdateControllerUpdateForManagerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/permission-groups/${queryArg.groupId}`,
        method: 'PATCH',
        body: queryArg.permissionGroupUpdateRequestDto,
      }),
    }),
    permissionGroupDeleteControllerDeleteForManager: build.mutation<
      PermissionGroupDeleteControllerDeleteForManagerApiResponse,
      PermissionGroupDeleteControllerDeleteForManagerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/permission-groups/${queryArg.groupId}`,
        method: 'DELETE',
      }),
    }),
    userPermissionGroupAttachControllerAttach: build.mutation<
      UserPermissionGroupAttachControllerAttachApiResponse,
      UserPermissionGroupAttachControllerAttachApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/permission-groups/${queryArg.groupId}`,
        method: 'POST',
      }),
    }),
    userPermissionGroupDetachControllerDetach: build.mutation<
      UserPermissionGroupDetachControllerDetachApiResponse,
      UserPermissionGroupDetachControllerDetachApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/permission-groups/${queryArg.groupId}`,
        method: 'DELETE',
      }),
    }),
    userPermissionGroupAttachControllerAttachForManager: build.mutation<
      UserPermissionGroupAttachControllerAttachForManagerApiResponse,
      UserPermissionGroupAttachControllerAttachForManagerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/users/${queryArg.userId}/permission-groups/${queryArg.groupId}`,
        method: 'POST',
      }),
    }),
    userPermissionGroupDetachControllerDetachForManager: build.mutation<
      UserPermissionGroupDetachControllerDetachForManagerApiResponse,
      UserPermissionGroupDetachControllerDetachForManagerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/users/${queryArg.userId}/permission-groups/${queryArg.groupId}`,
        method: 'DELETE',
      }),
    }),
    userPermissionGroupListControllerList: build.query<
      UserPermissionGroupListControllerListApiResponse,
      UserPermissionGroupListControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/users/${queryArg.userId}/permission-groups` }),
    }),
    userPermissionGroupListControllerListForManager: build.query<
      UserPermissionGroupListControllerListForManagerApiResponse,
      UserPermissionGroupListControllerListForManagerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/users/${queryArg.userId}/permission-groups`,
      }),
    }),
    analysisStaleSweepControllerSystemAnalysisStaleSweep: build.mutation<
      AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiResponse,
      AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiArg
    >({
      query: () => ({ url: `/v2/system/analyses/sweep`, method: 'POST' }),
    }),
    callAnalysisCreateControllerSystemCreateCallAnalysis: build.mutation<
      CallAnalysisCreateControllerSystemCreateCallAnalysisApiResponse,
      CallAnalysisCreateControllerSystemCreateCallAnalysisApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/analyses`,
        method: 'POST',
        body: queryArg.callAnalysisCreateRequestDto,
      }),
    }),
    callSentimentCreateControllerCreateCallSentiment: build.mutation<
      CallSentimentCreateControllerCreateCallSentimentApiResponse,
      CallSentimentCreateControllerCreateCallSentimentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/sentiments`,
        method: 'POST',
        body: queryArg.sentimentRequestDto,
      }),
    }),
    callUpdateControllerSystemCallUpdate: build.mutation<
      CallUpdateControllerSystemCallUpdateApiResponse,
      CallUpdateControllerSystemCallUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.callRequestDto,
      }),
    }),
    callControllerSystemGetCallById: build.query<
      CallControllerSystemGetCallByIdApiResponse,
      CallControllerSystemGetCallByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}`,
        params: { relations: queryArg.relations },
      }),
    }),
    callSupervisorModeControllerSetSupervisorMode: build.mutation<
      CallSupervisorModeControllerSetSupervisorModeApiResponse,
      CallSupervisorModeControllerSetSupervisorModeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/calls/${queryArg.id}/supervisor/mode`,
        method: 'PATCH',
        body: queryArg.callSupervisorModeRequestDto,
      }),
    }),
    callStaleSweepControllerSystemStaleSweep: build.mutation<
      CallStaleSweepControllerSystemStaleSweepApiResponse,
      CallStaleSweepControllerSystemStaleSweepApiArg
    >({
      query: () => ({ url: `/v2/system/calls/stale-sweep`, method: 'POST' }),
    }),
    campaignTestCallCreateControllerTestCallCreate: build.mutation<
      CampaignTestCallCreateControllerTestCallCreateApiResponse,
      CampaignTestCallCreateControllerTestCallCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls`,
        method: 'POST',
        body: queryArg.campaignTestCallCreateRequestDto,
      }),
    }),
    campaignCallListControllerCallList: build.query<
      CampaignCallListControllerCallListApiResponse,
      CampaignCallListControllerCallListApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls`,
        params: {
          statuses: queryArg.statuses,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          types: queryArg.types,
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
        },
      }),
    }),
    campaignTestCallCreateControllerExternalTestCallCreate: build.mutation<
      CampaignTestCallCreateControllerExternalTestCallCreateApiResponse,
      CampaignTestCallCreateControllerExternalTestCallCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external/campaigns/${queryArg.id}/calls`,
        method: 'POST',
        body: queryArg.campaignTestCallCreateRequestDto,
      }),
    }),
    callCreateExternalControllerCampaignOutboundCall: build.mutation<
      CallCreateExternalControllerCampaignOutboundCallApiResponse,
      CallCreateExternalControllerCampaignOutboundCallApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external/campaigns/${queryArg.id}/outbound-calls`,
        method: 'POST',
        body: queryArg.callCreateExternalRequestDto,
      }),
    }),
    campaignCallHangupControllerCampaignCallHangup: build.mutation<
      CampaignCallHangupControllerCampaignCallHangupApiResponse,
      CampaignCallHangupControllerCampaignCallHangupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls/${queryArg.callId}/hangup`,
        method: 'POST',
      }),
    }),
    campaignCallHangupControllerExternalCampaignCallHangup: build.mutation<
      CampaignCallHangupControllerExternalCampaignCallHangupApiResponse,
      CampaignCallHangupControllerExternalCampaignCallHangupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external/campaigns/${queryArg.id}/calls/${queryArg.callId}/hangup`,
        method: 'POST',
      }),
    }),
    campaignCloneSystemControllerCloneCampaign: build.mutation<
      CampaignCloneSystemControllerCloneCampaignApiResponse,
      CampaignCloneSystemControllerCloneCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.campaignId}/clone`,
        method: 'POST',
        body: queryArg.campaignCloneRequestDto,
      }),
    }),
    campaignCreateControllerCampaignCreate: build.mutation<
      CampaignCreateControllerCampaignCreateApiResponse,
      CampaignCreateControllerCampaignCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns`,
        method: 'POST',
        body: queryArg.campaignCreateRequestDto,
      }),
    }),
    campaignListControllerCampaignList: build.query<
      CampaignListControllerCampaignListApiResponse,
      CampaignListControllerCampaignListApiArg
    >({
      query: () => ({ url: `/v2/campaigns` }),
    }),
    campaignDeleteControllerDeleteCampaign: build.mutation<
      CampaignDeleteControllerDeleteCampaignApiResponse,
      CampaignDeleteControllerDeleteCampaignApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}`, method: 'DELETE' }),
    }),
    campaignUpdateControllerCampaignUpdate: build.mutation<
      CampaignUpdateControllerCampaignUpdateApiResponse,
      CampaignUpdateControllerCampaignUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.campaignUpdateRequestDto,
      }),
    }),
    campaignControllerCampaign: build.query<
      CampaignControllerCampaignApiResponse,
      CampaignControllerCampaignApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}` }),
    }),
    campaignIntegrationSchedulerRunControllerSystemRunIntegrationScheduler: build.mutation<
      CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiResponse,
      CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiArg
    >({
      query: () => ({ url: `/v2/system/campaigns/run-integration-scheduler`, method: 'POST' }),
    }),
    campaignAnalysisBatchRunControllerSystemRunAnalysisBatch: build.mutation<
      CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiResponse,
      CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.id}/run-analysis-batch`,
        method: 'POST',
      }),
    }),
    campaignStructuredOutputGenerateControllerGenerate: build.mutation<
      CampaignStructuredOutputGenerateControllerGenerateApiResponse,
      CampaignStructuredOutputGenerateControllerGenerateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/structured-output/generate`,
        method: 'POST',
      }),
    }),
    campaignOutboundCallsProcessControllerSystemOutboundCallsProcess: build.mutation<
      CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiResponse,
      CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiArg
    >({
      query: () => ({ url: `/v2/system/campaigns/outbound-calls-process`, method: 'POST' }),
    }),
    campaignRunControllerCampaignRun: build.mutation<
      CampaignRunControllerCampaignRunApiResponse,
      CampaignRunControllerCampaignRunApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/run`, method: 'POST' }),
    }),
    campaignSipTrunkCreateControllerCampaignCreate: build.mutation<
      CampaignSipTrunkCreateControllerCampaignCreateApiResponse,
      CampaignSipTrunkCreateControllerCampaignCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/sip-trunk`,
        method: 'POST',
        body: queryArg.campaignSipTrunkCreateRequestDto,
      }),
    }),
    campaignSipTrunkControllerGetSipTrunk: build.query<
      CampaignSipTrunkControllerGetSipTrunkApiResponse,
      CampaignSipTrunkControllerGetSipTrunkApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/sip-trunk` }),
    }),
    campaignStopControllerCampaignStop: build.mutation<
      CampaignStopControllerCampaignStopApiResponse,
      CampaignStopControllerCampaignStopApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/stop`, method: 'POST' }),
    }),
    campaignsStopExceededLimitsControllerStopExceededLimits: build.mutation<
      CampaignsStopExceededLimitsControllerStopExceededLimitsApiResponse,
      CampaignsStopExceededLimitsControllerStopExceededLimitsApiArg
    >({
      query: () => ({ url: `/v2/system/campaigns/stop-exceeded-limits`, method: 'POST' }),
    }),
    customerUpdateControllerUpdateCustomer: build.mutation<
      CustomerUpdateControllerUpdateCustomerApiResponse,
      CustomerUpdateControllerUpdateCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customers/${queryArg.customerId}`,
        method: 'PATCH',
        body: queryArg.customerUpdateRequestDto,
      }),
    }),
    campaignAgentCreateControllerExecute: build.mutation<
      CampaignAgentCreateControllerExecuteApiResponse,
      CampaignAgentCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/agents`,
        method: 'POST',
        body: queryArg.agentRequestDto,
      }),
    }),
    campaignAgentListControllerList: build.query<
      CampaignAgentListControllerListApiResponse,
      CampaignAgentListControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/agents` }),
    }),
    campaignAgentUpdateControllerExecute: build.mutation<
      CampaignAgentUpdateControllerExecuteApiResponse,
      CampaignAgentUpdateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'PUT',
        body: queryArg.agentRequestDto,
      }),
    }),
    campaignAgentDeleteControllerExecute: build.mutation<
      CampaignAgentDeleteControllerExecuteApiResponse,
      CampaignAgentDeleteControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'DELETE',
      }),
    }),
    callActionCreateControllerSystemCallActionCreate: build.mutation<
      CallActionCreateControllerSystemCallActionCreateApiResponse,
      CallActionCreateControllerSystemCallActionCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/actions`,
        method: 'POST',
        body: queryArg.callActionRequestDto,
      }),
    }),
    callCreateSystemControllerSystemCampaignCallCreate: build.mutation<
      CallCreateSystemControllerSystemCampaignCallCreateApiResponse,
      CallCreateSystemControllerSystemCampaignCallCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.id}/calls`,
        method: 'POST',
        body: queryArg.callCreateSystemRequestDto,
      }),
    }),
    callControllerGetCallById: build.query<
      CallControllerGetCallByIdApiResponse,
      CallControllerGetCallByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/calls/${queryArg.id}`,
        params: { relations: queryArg.relations },
      }),
    }),
    campaignControllerSystemCampaign: build.query<
      CampaignControllerSystemCampaignApiResponse,
      CampaignControllerSystemCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.id}`,
        params: { relations: queryArg.relations },
      }),
    }),
    campaignCallControllerCall: build.query<
      CampaignCallControllerCallApiResponse,
      CampaignCallControllerCallApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/calls/${queryArg.callId}` }),
    }),
    campaignCallListPaginatedControllerCallListPaginated: build.query<
      CampaignCallListPaginatedControllerCallListPaginatedApiResponse,
      CampaignCallListPaginatedControllerCallListPaginatedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/calls/paginated`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          sortOrder: queryArg.sortOrder,
          statuses: queryArg.statuses,
          sortBy: queryArg.sortBy,
          types: queryArg.types,
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          withTotal: queryArg.withTotal,
        },
      }),
    }),
    campaignFileListControllerList: build.query<
      CampaignFileListControllerListApiResponse,
      CampaignFileListControllerListApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/files`,
        params: { search: queryArg.search },
      }),
    }),
    campaignListControllerExternalCampaignList: build.query<
      CampaignListControllerExternalCampaignListApiResponse,
      CampaignListControllerExternalCampaignListApiArg
    >({
      query: () => ({ url: `/v2/external/campaigns` }),
    }),
    campaignListPaginatedControllerGetCampaignListPaginated: build.query<
      CampaignListPaginatedControllerGetCampaignListPaginatedApiResponse,
      CampaignListPaginatedControllerGetCampaignListPaginatedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/paginated`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          sortOrder: queryArg.sortOrder,
          sortBy: queryArg.sortBy,
          withTotal: queryArg.withTotal,
          search: queryArg.search,
        },
      }),
    }),
    campaignMetricCallDurationControllerCalculateCallDurationIqr: build.query<
      CampaignMetricCallDurationControllerCalculateCallDurationIqrApiResponse,
      CampaignMetricCallDurationControllerCalculateCallDurationIqrApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/metrics/call-duration/interquartile-range`,
      }),
    }),
    campaignReportControllerUserCampaignsReport: build.query<
      CampaignReportControllerUserCampaignsReportApiResponse,
      CampaignReportControllerUserCampaignsReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    campaignReportControllerUserCampaignReport: build.query<
      CampaignReportControllerUserCampaignReportApiResponse,
      CampaignReportControllerUserCampaignReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    campaignReportControllerAdminCampaignsReport: build.query<
      CampaignReportControllerAdminCampaignsReportApiResponse,
      CampaignReportControllerAdminCampaignsReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/campaigns/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    campaignReportControllerAdminCampaignReport: build.query<
      CampaignReportControllerAdminCampaignReportApiResponse,
      CampaignReportControllerAdminCampaignReportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/campaigns/${queryArg.id}/reports`,
        params: {
          start: queryArg.start,
          end: queryArg.end,
          numberSearch: queryArg.numberSearch,
          callIdSearch: queryArg.callIdSearch,
          endedReason: queryArg.endedReason,
          types: queryArg.types,
          statuses: queryArg.statuses,
          additionalColumns: queryArg.additionalColumns,
          separatedAnalysisSummary: queryArg.separatedAnalysisSummary,
        },
      }),
    }),
    callAccessTokenControllerGetCallAccessToken: build.query<
      CallAccessTokenControllerGetCallAccessTokenApiResponse,
      CallAccessTokenControllerGetCallAccessTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/calls/${queryArg.id}/access-token`,
        params: { mode: queryArg.mode },
      }),
    }),
    callAccessTokenControllerGetExternalCallAccessToken: build.query<
      CallAccessTokenControllerGetExternalCallAccessTokenApiResponse,
      CallAccessTokenControllerGetExternalCallAccessTokenApiArg
    >({
      query: (queryArg) => ({ url: `/v2/external/calls/${queryArg.id}/access-token` }),
    }),
    callRecordingControllerGetCallRecording: build.query<
      CallRecordingControllerGetCallRecordingApiResponse,
      CallRecordingControllerGetCallRecordingApiArg
    >({
      query: (queryArg) => ({ url: `/v2/calls/${queryArg.id}/recording` }),
    }),
    campaignActiveCallPollControllerExternalCampaignActiveCallPoll: build.query<
      CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiResponse,
      CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiArg
    >({
      query: (queryArg) => ({ url: `/v2/external/campaigns/${queryArg.id}/poll-active-call` }),
    }),
    callNotAnalyzedListControllerSystemGetNotAnalyzedCalls: build.query<
      CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiResponse,
      CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiArg
    >({
      query: () => ({ url: `/v2/system/calls-not-analyzed` }),
    }),
    customerListPaginatedControllerGetCustomerListPaginated: build.query<
      CustomerListPaginatedControllerGetCustomerListPaginatedApiResponse,
      CustomerListPaginatedControllerGetCustomerListPaginatedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customers/paginated`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          sortOrder: queryArg.sortOrder,
          campaignId: queryArg.campaignId,
          sortBy: queryArg.sortBy,
        },
      }),
    }),
    customerListExportControllerGetCustomerListForExport: build.query<
      CustomerListExportControllerGetCustomerListForExportApiResponse,
      CustomerListExportControllerGetCustomerListForExportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/customers/export`,
        params: { sortBy: queryArg.sortBy, sortOrder: queryArg.sortOrder },
      }),
    }),
    backgroundSoundAgentSettingsUpdateControllerExecute: build.mutation<
      BackgroundSoundAgentSettingsUpdateControllerExecuteApiResponse,
      BackgroundSoundAgentSettingsUpdateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.agentId}/background-sounds`,
        method: 'PATCH',
        body: queryArg.agentBackgroundSoundsRequestDto,
      }),
    }),
    backgroundSoundCreateControllerCreate: build.mutation<
      BackgroundSoundCreateControllerCreateApiResponse,
      BackgroundSoundCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds`,
        method: 'POST',
        body: queryArg.backgroundSoundCreateRequestDto,
      }),
    }),
    backgroundSoundListControllerAdminList: build.query<
      BackgroundSoundListControllerAdminListApiResponse,
      BackgroundSoundListControllerAdminListApiArg
    >({
      query: () => ({ url: `/v2/admin/background-sounds` }),
    }),
    backgroundSoundDeleteControllerDelete: build.mutation<
      BackgroundSoundDeleteControllerDeleteApiResponse,
      BackgroundSoundDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    backgroundSoundUpdateControllerUpdate: build.mutation<
      BackgroundSoundUpdateControllerUpdateApiResponse,
      BackgroundSoundUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.backgroundSoundUpdateRequestDto,
      }),
    }),
    backgroundSoundUploadUrlControllerCreateUploadUrl: build.mutation<
      BackgroundSoundUploadUrlControllerCreateUploadUrlApiResponse,
      BackgroundSoundUploadUrlControllerCreateUploadUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/background-sounds/upload-url`,
        method: 'POST',
        body: queryArg.backgroundSoundUploadUrlRequestDto,
      }),
    }),
    backgroundSoundListControllerList: build.query<
      BackgroundSoundListControllerListApiResponse,
      BackgroundSoundListControllerListApiArg
    >({
      query: () => ({ url: `/v2/background-sounds` }),
    }),
    voiceListControllerVoiceList: build.query<
      VoiceListControllerVoiceListApiResponse,
      VoiceListControllerVoiceListApiArg
    >({
      query: () => ({ url: `/v2/voices` }),
    }),
    voiceListSystemControllerGetAllVoices: build.query<
      VoiceListSystemControllerGetAllVoicesApiResponse,
      VoiceListSystemControllerGetAllVoicesApiArg
    >({
      query: () => ({ url: `/v1/system/voices` }),
    }),
    voiceControllerGetVoice: build.query<
      VoiceControllerGetVoiceApiResponse,
      VoiceControllerGetVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/voices/${queryArg.id}` }),
    }),
    voiceDeleteControllerDeleteVoice: build.mutation<
      VoiceDeleteControllerDeleteVoiceApiResponse,
      VoiceDeleteControllerDeleteVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/voices/${queryArg.id}`, method: 'DELETE' }),
    }),
    voiceEditControllerEditVoice: build.mutation<
      VoiceEditControllerEditVoiceApiResponse,
      VoiceEditControllerEditVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/voices/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceSystemControllerGetVoice: build.query<
      VoiceSystemControllerGetVoiceApiResponse,
      VoiceSystemControllerGetVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v1/system/voices/${queryArg.id}` }),
    }),
    voiceEditSystemControllerEditVoice: build.mutation<
      VoiceEditSystemControllerEditVoiceApiResponse,
      VoiceEditSystemControllerEditVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/system/voices/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceCreateControllerCreateVoice: build.mutation<
      VoiceCreateControllerCreateVoiceApiResponse,
      VoiceCreateControllerCreateVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/voices`,
        method: 'POST',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceCreateSystemControllerCreateVoice: build.mutation<
      VoiceCreateSystemControllerCreateVoiceApiResponse,
      VoiceCreateSystemControllerCreateVoiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/voice`,
        method: 'POST',
        body: queryArg.voiceRequestDto,
      }),
    }),
    voiceDeleteSystemControllerDeleteVoice: build.mutation<
      VoiceDeleteSystemControllerDeleteVoiceApiResponse,
      VoiceDeleteSystemControllerDeleteVoiceApiArg
    >({
      query: (queryArg) => ({ url: `/v1/system/voice/${queryArg.id}`, method: 'DELETE' }),
    }),
    customTranscriberEditControllerEditTranscriber: build.mutation<
      CustomTranscriberEditControllerEditTranscriberApiResponse,
      CustomTranscriberEditControllerEditTranscriberApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/custom-transcribers/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.customTranscriberRequestDto,
      }),
    }),
    customTranscriberCreateControllerCreateTranscriber: build.mutation<
      CustomTranscriberCreateControllerCreateTranscriberApiResponse,
      CustomTranscriberCreateControllerCreateTranscriberApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/custom-transcribers`,
        method: 'POST',
        body: queryArg.customTranscriberRequestDto,
      }),
    }),
    transcriberListControllerTranscriberList: build.query<
      TranscriberListControllerTranscriberListApiResponse,
      TranscriberListControllerTranscriberListApiArg
    >({
      query: () => ({ url: `/v2/transcribers` }),
    }),
    transcriberListControllerGetTranscriber: build.query<
      TranscriberListControllerGetTranscriberApiResponse,
      TranscriberListControllerGetTranscriberApiArg
    >({
      query: (queryArg) => ({ url: `/v2/transcribers/${queryArg.id}` }),
    }),
    transcriberListControllerAdminTranscriberList: build.query<
      TranscriberListControllerAdminTranscriberListApiResponse,
      TranscriberListControllerAdminTranscriberListApiArg
    >({
      query: () => ({ url: `/v2/admin/transcribers` }),
    }),
    transcriberCreateControllerCreateTranscriber: build.mutation<
      TranscriberCreateControllerCreateTranscriberApiResponse,
      TranscriberCreateControllerCreateTranscriberApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/transcribers`,
        method: 'POST',
        body: queryArg.transcriberRequestDto,
      }),
    }),
    transcriberControllerGetTranscriber: build.query<
      TranscriberControllerGetTranscriberApiResponse,
      TranscriberControllerGetTranscriberApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/transcribers/${queryArg.id}` }),
    }),
    transcriberDeleteControllerDeleteTranscriber: build.mutation<
      TranscriberDeleteControllerDeleteTranscriberApiResponse,
      TranscriberDeleteControllerDeleteTranscriberApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/transcribers/${queryArg.id}`, method: 'DELETE' }),
    }),
    transcriberEditControllerEditTranscriber: build.mutation<
      TranscriberEditControllerEditTranscriberApiResponse,
      TranscriberEditControllerEditTranscriberApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/transcribers/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.transcriberRequestDto,
      }),
    }),
    createCompanyControllerCreateCompany: build.mutation<
      CreateCompanyControllerCreateCompanyApiResponse,
      CreateCompanyControllerCreateCompanyApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/companies`,
        method: 'POST',
        body: queryArg.createCompanyRequestDto,
      }),
    }),
    companyControllerGetCompany: build.query<
      CompanyControllerGetCompanyApiResponse,
      CompanyControllerGetCompanyApiArg
    >({
      query: (queryArg) => ({ url: `/v2/companies/${queryArg.id}` }),
    }),
    companyControllerGetCompanyAsAdmin: build.query<
      CompanyControllerGetCompanyAsAdminApiResponse,
      CompanyControllerGetCompanyAsAdminApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/companies/${queryArg.id}` }),
    }),
    editCompanyControllerEditCompany: build.mutation<
      EditCompanyControllerEditCompanyApiResponse,
      EditCompanyControllerEditCompanyApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/companies/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.editCompanyRequestDto,
      }),
    }),
    getAllCompanyIdsControllerGetAllCompanyIds: build.query<
      GetAllCompanyIdsControllerGetAllCompanyIdsApiResponse,
      GetAllCompanyIdsControllerGetAllCompanyIdsApiArg
    >({
      query: () => ({ url: `/v1/system/companies/only-ids` }),
    }),
    companyApiKeyCreateControllerApiKeyCreate: build.mutation<
      CompanyApiKeyCreateControllerApiKeyCreateApiResponse,
      CompanyApiKeyCreateControllerApiKeyCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/companies/${queryArg.id}/api-keys`,
        method: 'POST',
      }),
    }),
    companyApiKeyRevokeControllerApiKeyRevoke: build.mutation<
      CompanyApiKeyRevokeControllerApiKeyRevokeApiResponse,
      CompanyApiKeyRevokeControllerApiKeyRevokeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/companies/${queryArg.id}/api-keys/${queryArg.apiKeyId}`,
        method: 'DELETE',
      }),
    }),
    agentProfileCreateControllerAgentProfileCreateForUsers: build.mutation<
      AgentProfileCreateControllerAgentProfileCreateForUsersApiResponse,
      AgentProfileCreateControllerAgentProfileCreateForUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agent-profiles`,
        method: 'POST',
        body: queryArg.agentProfileCreateRequestDto,
      }),
    }),
    agentProfileListControllerAgentProfileListForUsers: build.query<
      AgentProfileListControllerAgentProfileListForUsersApiResponse,
      AgentProfileListControllerAgentProfileListForUsersApiArg
    >({
      query: (queryArg) => ({ url: `/v2/agent-profiles`, params: { filter: queryArg.filter } }),
    }),
    agentProfileCreateControllerAgentProfileCreateForManagers: build.mutation<
      AgentProfileCreateControllerAgentProfileCreateForManagersApiResponse,
      AgentProfileCreateControllerAgentProfileCreateForManagersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles`,
        method: 'POST',
        body: queryArg.agentProfileCreateAdminRequestDto,
      }),
    }),
    agentProfileListControllerAgentProfileListForAdmins: build.query<
      AgentProfileListControllerAgentProfileListForAdminsApiResponse,
      AgentProfileListControllerAgentProfileListForAdminsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles`,
        params: { filter: queryArg.filter },
      }),
    }),
    agentProfileEditControllerAgentProfileEditForUsers: build.mutation<
      AgentProfileEditControllerAgentProfileEditForUsersApiResponse,
      AgentProfileEditControllerAgentProfileEditForUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agent-profiles/${queryArg.profileId}`,
        method: 'PATCH',
        body: queryArg.agentProfileEditRequestDto,
      }),
    }),
    agentProfileDeleteControllerAgentProfileDeleteForUsers: build.mutation<
      AgentProfileDeleteControllerAgentProfileDeleteForUsersApiResponse,
      AgentProfileDeleteControllerAgentProfileDeleteForUsersApiArg
    >({
      query: (queryArg) => ({ url: `/v2/agent-profiles/${queryArg.profileId}`, method: 'DELETE' }),
    }),
    agentProfileEditControllerAgentProfileEditForManagers: build.mutation<
      AgentProfileEditControllerAgentProfileEditForManagersApiResponse,
      AgentProfileEditControllerAgentProfileEditForManagersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles/${queryArg.profileId}`,
        method: 'PATCH',
        body: queryArg.agentProfileEditRequestDto,
      }),
    }),
    agentProfileDeleteControllerAgentProfileDeleteForManagers: build.mutation<
      AgentProfileDeleteControllerAgentProfileDeleteForManagersApiResponse,
      AgentProfileDeleteControllerAgentProfileDeleteForManagersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/agent-profiles/${queryArg.profileId}`,
        method: 'DELETE',
      }),
    }),
    companyOverviewControllerGetCompanyOverview: build.query<
      CompanyOverviewControllerGetCompanyOverviewApiResponse,
      CompanyOverviewControllerGetCompanyOverviewApiArg
    >({
      query: () => ({ url: `/v2/company-overview` }),
    }),
    companyListControllerCompanyList: build.query<
      CompanyListControllerCompanyListApiResponse,
      CompanyListControllerCompanyListApiArg
    >({
      query: () => ({ url: `/v2/admin/companies` }),
    }),
    usageLimitControllerUsageLimits: build.query<
      UsageLimitControllerUsageLimitsApiResponse,
      UsageLimitControllerUsageLimitsApiArg
    >({
      query: () => ({ url: `/v2/usage-limits` }),
    }),
    usageLimitControllerAdminUsageLimits: build.query<
      UsageLimitControllerAdminUsageLimitsApiResponse,
      UsageLimitControllerAdminUsageLimitsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/companies/${queryArg.id}/usage-limits` }),
    }),
    usageLimitSetControllerSetLimits: build.mutation<
      UsageLimitSetControllerSetLimitsApiResponse,
      UsageLimitSetControllerSetLimitsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/usage-limits`,
        method: 'PATCH',
        body: queryArg.usageLimitSetRequestDto,
      }),
    }),
    usageLimitControllerSystemUsageLimits: build.query<
      UsageLimitControllerSystemUsageLimitsApiResponse,
      UsageLimitControllerSystemUsageLimitsApiArg
    >({
      query: (queryArg) => ({ url: `/v2/system/companies/${queryArg.id}/usage-limits` }),
    }),
    companyVoicesSetControllerSetCompanyVoices: build.mutation<
      CompanyVoicesSetControllerSetCompanyVoicesApiResponse,
      CompanyVoicesSetControllerSetCompanyVoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/voices`,
        method: 'PUT',
        body: queryArg.companyVoicesSetRequestDto,
      }),
    }),
    companyTranscribersSetControllerSetCompanyTranscribers: build.mutation<
      CompanyTranscribersSetControllerSetCompanyTranscribersApiResponse,
      CompanyTranscribersSetControllerSetCompanyTranscribersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/transcribers`,
        method: 'PUT',
        body: queryArg.companyTranscribersSetRequestDto,
      }),
    }),
    companyLlmProvidersSetControllerSetCompanyLlmProviders: build.mutation<
      CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiResponse,
      CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/llm-providers`,
        method: 'PUT',
        body: queryArg.companyLlmProvidersSetRequestDto,
      }),
    }),
    concurrentLimitSetControllerSetConcurrentLimit: build.mutation<
      ConcurrentLimitSetControllerSetConcurrentLimitApiResponse,
      ConcurrentLimitSetControllerSetConcurrentLimitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.id}/concurrent-limit`,
        method: 'PATCH',
        body: queryArg.concurrentLimitSetRequestDto,
      }),
    }),
    unitWeightsControllerGetUnitWeights: build.query<
      UnitWeightsControllerGetUnitWeightsApiResponse,
      UnitWeightsControllerGetUnitWeightsApiArg
    >({
      query: () => ({ url: `/v2/admin/unit-weights` }),
    }),
    unitWeightsSetControllerSetUnitWeights: build.mutation<
      UnitWeightsSetControllerSetUnitWeightsApiResponse,
      UnitWeightsSetControllerSetUnitWeightsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/unit-weights`,
        method: 'PATCH',
        body: queryArg.unitWeightsSetRequestDto,
      }),
    }),
    livekitControllerWebhook: build.mutation<
      LivekitControllerWebhookApiResponse,
      LivekitControllerWebhookApiArg
    >({
      query: () => ({ url: `/v1/webhooks/livekit`, method: 'POST' }),
    }),
    campaignPostCallMessageCreateControllerCreate: build.mutation<
      CampaignPostCallMessageCreateControllerCreateApiResponse,
      CampaignPostCallMessageCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages`,
        method: 'POST',
        body: queryArg.campaignPostCallMessageCreateRequestDto,
      }),
    }),
    campaignPostCallMessagesControllerList: build.query<
      CampaignPostCallMessagesControllerListApiResponse,
      CampaignPostCallMessagesControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages` }),
    }),
    campaignPostCallMessageUpdateControllerUpdate: build.mutation<
      CampaignPostCallMessageUpdateControllerUpdateApiResponse,
      CampaignPostCallMessageUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages/${queryArg.messageId}`,
        method: 'PATCH',
        body: queryArg.campaignPostCallMessageUpdateRequestDto,
      }),
    }),
    campaignPostCallMessageDeleteControllerDelete: build.mutation<
      CampaignPostCallMessageDeleteControllerDeleteApiResponse,
      CampaignPostCallMessageDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/post-call-messages/${queryArg.messageId}`,
        method: 'DELETE',
      }),
    }),
    messageDeliverySweepControllerSystemDeliverySweep: build.mutation<
      MessageDeliverySweepControllerSystemDeliverySweepApiResponse,
      MessageDeliverySweepControllerSystemDeliverySweepApiArg
    >({
      query: () => ({ url: `/v2/system/messages/deliveries/sweep`, method: 'POST' }),
    }),
    messageDeliveryUpdateControllerWebhook: build.mutation<
      MessageDeliveryUpdateControllerWebhookApiResponse,
      MessageDeliveryUpdateControllerWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/webhooks/wassenger`,
        method: 'POST',
        params: { token: queryArg.token },
      }),
    }),
    fileCreateControllerCreate: build.mutation<
      FileCreateControllerCreateApiResponse,
      FileCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/files`,
        method: 'POST',
        body: queryArg.fileCreateRequestDto,
      }),
    }),
    fileListControllerList: build.query<
      FileListControllerListApiResponse,
      FileListControllerListApiArg
    >({
      query: () => ({ url: `/v2/files` }),
    }),
    fileDeleteControllerDelete: build.mutation<
      FileDeleteControllerDeleteApiResponse,
      FileDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/v2/files/${queryArg.id}`, method: 'DELETE' }),
    }),
    fileControllerGet: build.query<FileControllerGetApiResponse, FileControllerGetApiArg>({
      query: (queryArg) => ({ url: `/v2/files/${queryArg.id}` }),
    }),
    campaignFileAvailabilityUpdateControllerUpdate: build.mutation<
      CampaignFileAvailabilityUpdateControllerUpdateApiResponse,
      CampaignFileAvailabilityUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/files/${queryArg.fileId}/availability`,
        method: 'PATCH',
        body: queryArg.campaignFileAvailabilityUpdateRequestDto,
      }),
    }),
    campaignFileAgentsSetControllerReplace: build.mutation<
      CampaignFileAgentsSetControllerReplaceApiResponse,
      CampaignFileAgentsSetControllerReplaceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/files/${queryArg.fileId}/assignments`,
        method: 'PUT',
        body: queryArg.campaignFileAgentsSetRequestDto,
      }),
    }),
    campaignFileDeleteControllerRemove: build.mutation<
      CampaignFileDeleteControllerRemoveApiResponse,
      CampaignFileDeleteControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/files/${queryArg.fileId}`,
        method: 'DELETE',
      }),
    }),
    fileOriginalControllerGet: build.query<
      FileOriginalControllerGetApiResponse,
      FileOriginalControllerGetApiArg
    >({
      query: (queryArg) => ({ url: `/v2/files/${queryArg.fileId}/original` }),
    }),
    campaignFileSearchControllerSearch: build.query<
      CampaignFileSearchControllerSearchApiResponse,
      CampaignFileSearchControllerSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/files/${queryArg.fileId}/search`,
        params: { query: queryArg.query },
      }),
    }),
    fileReindexControllerReindex: build.mutation<
      FileReindexControllerReindexApiResponse,
      FileReindexControllerReindexApiArg
    >({
      query: (queryArg) => ({ url: `/v2/files/${queryArg.fileId}/reindex`, method: 'POST' }),
    }),
    squadCreateControllerExecute: build.mutation<
      SquadCreateControllerExecuteApiResponse,
      SquadCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/squads`,
        method: 'POST',
        body: queryArg.squadCreateRequestDto,
      }),
    }),
    squadDeleteControllerExecute: build.mutation<
      SquadDeleteControllerExecuteApiResponse,
      SquadDeleteControllerExecuteApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/squads`, method: 'DELETE' }),
    }),
    squadAgentCreateControllerExecute: build.mutation<
      SquadAgentCreateControllerExecuteApiResponse,
      SquadAgentCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/agents`,
        method: 'POST',
        body: queryArg.agentRequestDto,
      }),
    }),
    squadAgentUpdateControllerExecute: build.mutation<
      SquadAgentUpdateControllerExecuteApiResponse,
      SquadAgentUpdateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'PUT',
        body: queryArg.squadAgentUpdateRequestDto,
      }),
    }),
    squadAgentDeleteControllerExecute: build.mutation<
      SquadAgentDeleteControllerExecuteApiResponse,
      SquadAgentDeleteControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/agents/${queryArg.agentId}`,
        method: 'DELETE',
      }),
    }),
    handoffRuleCreateControllerExecute: build.mutation<
      HandoffRuleCreateControllerExecuteApiResponse,
      HandoffRuleCreateControllerExecuteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/squads/${queryArg.id}/handoff-rules`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    structuredOutputCreateControllerCreate: build.mutation<
      StructuredOutputCreateControllerCreateApiResponse,
      StructuredOutputCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structured-outputs`,
        method: 'POST',
        body: queryArg.structuredOutputCreateRequestDto,
      }),
    }),
    structuredOutputListControllerList: build.query<
      StructuredOutputListControllerListApiResponse,
      StructuredOutputListControllerListApiArg
    >({
      query: () => ({ url: `/v2/structured-outputs` }),
    }),
    structuredOutputUpdateControllerUpdate: build.mutation<
      StructuredOutputUpdateControllerUpdateApiResponse,
      StructuredOutputUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/structured-outputs/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.structuredOutputUpdateRequestDto,
      }),
    }),
    structuredOutputDeleteControllerDelete: build.mutation<
      StructuredOutputDeleteControllerDeleteApiResponse,
      StructuredOutputDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/v2/structured-outputs/${queryArg.id}`, method: 'DELETE' }),
    }),
    structuredOutputControllerGet: build.query<
      StructuredOutputControllerGetApiResponse,
      StructuredOutputControllerGetApiArg
    >({
      query: (queryArg) => ({ url: `/v2/structured-outputs/${queryArg.id}` }),
    }),
    structuredOutputTemplateListControllerList: build.query<
      StructuredOutputTemplateListControllerListApiResponse,
      StructuredOutputTemplateListControllerListApiArg
    >({
      query: () => ({ url: `/v2/structured-output-templates` }),
    }),
    structuredOutputTemplateControllerGet: build.query<
      StructuredOutputTemplateControllerGetApiResponse,
      StructuredOutputTemplateControllerGetApiArg
    >({
      query: (queryArg) => ({ url: `/v2/structured-output-templates/${queryArg.id}` }),
    }),
    campaignStructuredOutputAttachControllerAttach: build.mutation<
      CampaignStructuredOutputAttachControllerAttachApiResponse,
      CampaignStructuredOutputAttachControllerAttachApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/structured-outputs`,
        method: 'POST',
        body: queryArg.campaignStructuredOutputAttachRequestDto,
      }),
    }),
    campaignStructuredOutputListControllerList: build.query<
      CampaignStructuredOutputListControllerListApiResponse,
      CampaignStructuredOutputListControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/structured-outputs` }),
    }),
    campaignStructuredOutputDetachControllerDetach: build.mutation<
      CampaignStructuredOutputDetachControllerDetachApiResponse,
      CampaignStructuredOutputDetachControllerDetachApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/structured-outputs/${queryArg.outputId}`,
        method: 'DELETE',
      }),
    }),
    toolCreateControllerCreateCampaignTool: build.mutation<
      ToolCreateControllerCreateCampaignToolApiResponse,
      ToolCreateControllerCreateCampaignToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/tools`,
        method: 'POST',
        body: queryArg.toolRequestDto,
      }),
    }),
    toolListControllerCampaignToolList: build.query<
      ToolListControllerCampaignToolListApiResponse,
      ToolListControllerCampaignToolListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.id}/tools` }),
    }),
    toolCreateControllerCreateAgentTool: build.mutation<
      ToolCreateControllerCreateAgentToolApiResponse,
      ToolCreateControllerCreateAgentToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.id}/tools`,
        method: 'POST',
        body: queryArg.toolRequestDto,
      }),
    }),
    toolListControllerAgentTollList: build.query<
      ToolListControllerAgentTollListApiResponse,
      ToolListControllerAgentTollListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/agents/${queryArg.id}/tools` }),
    }),
    toolUpdateControllerCreateCampaignTool: build.mutation<
      ToolUpdateControllerCreateCampaignToolApiResponse,
      ToolUpdateControllerCreateCampaignToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'PUT',
        body: queryArg.toolUpdateRequestDto,
      }),
    }),
    toolDeleteControllerCreateCampaignTool: build.mutation<
      ToolDeleteControllerCreateCampaignToolApiResponse,
      ToolDeleteControllerCreateCampaignToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'DELETE',
      }),
    }),
    toolUpdateControllerCreateAgentTool: build.mutation<
      ToolUpdateControllerCreateAgentToolApiResponse,
      ToolUpdateControllerCreateAgentToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'PUT',
        body: queryArg.toolUpdateRequestDto,
      }),
    }),
    toolDeleteControllerCreateAgentTool: build.mutation<
      ToolDeleteControllerCreateAgentToolApiResponse,
      ToolDeleteControllerCreateAgentToolApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/agents/${queryArg.id}/tools/${queryArg.toolId}`,
        method: 'DELETE',
      }),
    }),
    llmProviderListControllerProviderList: build.query<
      LlmProviderListControllerProviderListApiResponse,
      LlmProviderListControllerProviderListApiArg
    >({
      query: () => ({ url: `/v2/llm-providers` }),
    }),
    llmProviderListControllerAdminProviderList: build.query<
      LlmProviderListControllerAdminProviderListApiResponse,
      LlmProviderListControllerAdminProviderListApiArg
    >({
      query: () => ({ url: `/v2/admin/llm-providers` }),
    }),
    llmModelListControllerModelList: build.query<
      LlmModelListControllerModelListApiResponse,
      LlmModelListControllerModelListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/llm-providers/${queryArg.id}/models` }),
    }),
    llmModelListControllerAdminModelList: build.query<
      LlmModelListControllerAdminModelListApiResponse,
      LlmModelListControllerAdminModelListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/llm-providers/${queryArg.id}/models` }),
    }),
    campaignWebhookCreateControllerCreate: build.mutation<
      CampaignWebhookCreateControllerCreateApiResponse,
      CampaignWebhookCreateControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/webhooks`,
        method: 'POST',
        body: queryArg.campaignWebhookCreateRequestDto,
      }),
    }),
    campaignWebhooksControllerList: build.query<
      CampaignWebhooksControllerListApiResponse,
      CampaignWebhooksControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/campaigns/${queryArg.campaignId}/webhooks` }),
    }),
    campaignWebhookUpdateControllerUpdate: build.mutation<
      CampaignWebhookUpdateControllerUpdateApiResponse,
      CampaignWebhookUpdateControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/webhooks/${queryArg.webhookId}`,
        method: 'PATCH',
        body: queryArg.campaignWebhookUpdateRequestDto,
      }),
    }),
    campaignWebhookDeleteControllerDelete: build.mutation<
      CampaignWebhookDeleteControllerDeleteApiResponse,
      CampaignWebhookDeleteControllerDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/webhooks/${queryArg.webhookId}`,
        method: 'DELETE',
      }),
    }),
    campaignWebhookDispatchControllerManualDispatch: build.mutation<
      CampaignWebhookDispatchControllerManualDispatchApiResponse,
      CampaignWebhookDispatchControllerManualDispatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/campaigns/${queryArg.campaignId}/calls/${queryArg.callId}/webhooks/dispatch`,
        method: 'POST',
      }),
    }),
    campaignWebhookDispatchControllerSystemDispatch: build.mutation<
      CampaignWebhookDispatchControllerSystemDispatchApiResponse,
      CampaignWebhookDispatchControllerSystemDispatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/campaigns/${queryArg.campaignId}/calls/${queryArg.callId}/webhooks/dispatch`,
        method: 'POST',
      }),
    }),
    webhookDeliverySweepControllerSystemDeliverySweep: build.mutation<
      WebhookDeliverySweepControllerSystemDeliverySweepApiResponse,
      WebhookDeliverySweepControllerSystemDeliverySweepApiArg
    >({
      query: () => ({ url: `/v2/system/webhooks/deliveries/sweep`, method: 'POST' }),
    }),
    healthControllerCheck: build.query<
      HealthControllerCheckApiResponse,
      HealthControllerCheckApiArg
    >({
      query: () => ({ url: `/health` }),
    }),
    usageMonitoringControllerGetUsage: build.query<
      UsageMonitoringControllerGetUsageApiResponse,
      UsageMonitoringControllerGetUsageApiArg
    >({
      query: () => ({ url: `/v2/admin/usage-models` }),
    }),
    billingControllerOffers: build.query<
      BillingControllerOffersApiResponse,
      BillingControllerOffersApiArg
    >({
      query: (queryArg) => ({ url: `/v2/companies/${queryArg.companyId}/billing/catalog` }),
    }),
    billingControllerCompany: build.query<
      BillingControllerCompanyApiResponse,
      BillingControllerCompanyApiArg
    >({
      query: (queryArg) => ({ url: `/v2/companies/${queryArg.companyId}/billing` }),
    }),
    billingControllerManager: build.query<
      BillingControllerManagerApiResponse,
      BillingControllerManagerApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/companies/${queryArg.companyId}/billing` }),
    }),
    billingControllerPublishPolicy: build.mutation<
      BillingControllerPublishPolicyApiResponse,
      BillingControllerPublishPolicyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/enrollment-policies`,
        method: 'POST',
        body: queryArg.publishEnrollmentPolicyDto,
      }),
    }),
    billingControllerEnroll: build.mutation<
      BillingControllerEnrollApiResponse,
      BillingControllerEnrollApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.companyId}/billing/enrollment`,
        method: 'POST',
        body: queryArg.billingEnrollmentDto,
      }),
    }),
    billingControllerAdmission: build.mutation<
      BillingControllerAdmissionApiResponse,
      BillingControllerAdmissionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.companyId}/billing/admission`,
        method: 'POST',
        body: queryArg.billingAdmissionControlDto,
      }),
    }),
    billingControllerAdjust: build.mutation<
      BillingControllerAdjustApiResponse,
      BillingControllerAdjustApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.companyId}/billing/adjustments`,
        method: 'POST',
        body: queryArg.billingAdjustmentDto,
      }),
    }),
    stripeBillingControllerStartCheckout: build.mutation<
      StripeBillingControllerStartCheckoutApiResponse,
      StripeBillingControllerStartCheckoutApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/checkout`,
        method: 'POST',
        body: queryArg.stripeCheckoutRequestDto,
      }),
    }),
    stripePortalControllerOpen: build.mutation<
      StripePortalControllerOpenApiResponse,
      StripePortalControllerOpenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/portal`,
        method: 'POST',
      }),
    }),
    stripeSynchronizationControllerRead: build.query<
      StripeSynchronizationControllerReadApiResponse,
      StripeSynchronizationControllerReadApiArg
    >({
      query: (queryArg) => ({ url: `/v2/companies/${queryArg.companyId}/billing/synchronization` }),
    }),
    stripeSynchronizationControllerRequest: build.mutation<
      StripeSynchronizationControllerRequestApiResponse,
      StripeSynchronizationControllerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/synchronization`,
        method: 'POST',
      }),
    }),
    stripeSynchronizationControllerRequestManager: build.mutation<
      StripeSynchronizationControllerRequestManagerApiResponse,
      StripeSynchronizationControllerRequestManagerApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.companyId}/billing/synchronization`,
        method: 'POST',
      }),
    }),
    stripeUpgradeControllerApply: build.mutation<
      StripeUpgradeControllerApplyApiResponse,
      StripeUpgradeControllerApplyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/upgrades/apply`,
        method: 'POST',
        body: queryArg.stripeUpgradeApplyRequestDto,
      }),
    }),
    stripeUpgradeControllerPreview: build.mutation<
      StripeUpgradeControllerPreviewApiResponse,
      StripeUpgradeControllerPreviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/upgrades/preview`,
        method: 'POST',
        body: queryArg.stripeUpgradePreviewRequestDto,
      }),
    }),
    stripeUpgradeControllerPayment: build.query<
      StripeUpgradeControllerPaymentApiResponse,
      StripeUpgradeControllerPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/upgrades/${queryArg.intentId}/payment`,
      }),
    }),
    stripeScheduledChangeControllerRequest: build.mutation<
      StripeScheduledChangeControllerRequestApiResponse,
      StripeScheduledChangeControllerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/scheduled-changes`,
        method: 'POST',
        body: queryArg.stripeScheduledChangeRequestDto,
      }),
    }),
    billingControllerOptions: build.query<
      BillingControllerOptionsApiResponse,
      BillingControllerOptionsApiArg
    >({
      query: () => ({ url: `/v2/admin/billing/enrollment-options` }),
    }),
    billingControllerPaymentExceptions: build.query<
      BillingControllerPaymentExceptionsApiResponse,
      BillingControllerPaymentExceptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.companyId}/billing/payment-exceptions`,
      }),
    }),
    billingControllerResolvePaymentException: build.mutation<
      BillingControllerResolvePaymentExceptionApiResponse,
      BillingControllerResolvePaymentExceptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/companies/${queryArg.companyId}/billing/payment-exceptions/${queryArg.exceptionId}/resolution`,
        method: 'POST',
        body: queryArg.resolveBillingPaymentExceptionDto,
      }),
    }),
    workspaceControllerList: build.query<
      WorkspaceControllerListApiResponse,
      WorkspaceControllerListApiArg
    >({
      query: (queryArg) => ({ url: `/v2/workspace/missions`, params: { after: queryArg.after } }),
    }),
    workspaceControllerCreate: build.mutation<
      WorkspaceControllerCreateApiResponse,
      WorkspaceControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions`,
        method: 'POST',
        body: queryArg.workspaceCreateMissionDto,
      }),
    }),
    workspaceControllerDetail: build.query<
      WorkspaceControllerDetailApiResponse,
      WorkspaceControllerDetailApiArg
    >({
      query: (queryArg) => ({ url: `/v2/workspace/missions/${queryArg.id}` }),
    }),
    workspaceControllerSave: build.mutation<
      WorkspaceControllerSaveApiResponse,
      WorkspaceControllerSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.workspaceSaveMissionDto,
      }),
    }),
    workspaceControllerRemove: build.mutation<
      WorkspaceControllerRemoveApiResponse,
      WorkspaceControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/${queryArg.id}`,
        method: 'DELETE',
        body: queryArg.workspaceRevisionDto,
      }),
    }),
    workspaceControllerPublish: build.mutation<
      WorkspaceControllerPublishApiResponse,
      WorkspaceControllerPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/${queryArg.id}/publish`,
        method: 'POST',
        body: queryArg.workspaceRevisionDto,
      }),
    }),
    workspaceControllerPause: build.mutation<
      WorkspaceControllerPauseApiResponse,
      WorkspaceControllerPauseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/${queryArg.id}/pause`,
        method: 'POST',
        body: queryArg.workspacePauseDto,
      }),
    }),
    workspaceControllerRun: build.mutation<
      WorkspaceControllerRunApiResponse,
      WorkspaceControllerRunApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/${queryArg.id}/run`,
        method: 'POST',
        body: queryArg.workspaceRunDto,
      }),
    }),
    workspaceControllerRuns: build.query<
      WorkspaceControllerRunsApiResponse,
      WorkspaceControllerRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/operations`,
        params: { missionId: queryArg.missionId, before: queryArg.before },
      }),
    }),
    workspaceControllerConfirm: build.mutation<
      WorkspaceControllerConfirmApiResponse,
      WorkspaceControllerConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/operations/${queryArg.id}/confirm`,
        method: 'POST',
      }),
    }),
    workspaceControllerCancel: build.mutation<
      WorkspaceControllerCancelApiResponse,
      WorkspaceControllerCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/operations/${queryArg.id}/cancel`,
        method: 'POST',
      }),
    }),
    workspaceControllerModels: build.query<
      WorkspaceControllerModelsApiResponse,
      WorkspaceControllerModelsApiArg
    >({
      query: () => ({ url: `/v2/workspace/models` }),
    }),
    workspaceControllerAsk: build.mutation<
      WorkspaceControllerAskApiResponse,
      WorkspaceControllerAskApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/ask`,
        method: 'POST',
        body: queryArg.workspaceAskDto,
      }),
    }),
    workspaceControllerCheckConfiguration: build.mutation<
      WorkspaceControllerCheckConfigurationApiResponse,
      WorkspaceControllerCheckConfigurationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/check-configuration`,
        method: 'POST',
        body: queryArg.workspaceCheckConfigurationDto,
      }),
    }),
    workspaceControllerJobsUsage: build.query<
      WorkspaceControllerJobsUsageApiResponse,
      WorkspaceControllerJobsUsageApiArg
    >({
      query: () => ({ url: `/v2/workspace/job-usage` }),
    }),
    workspaceControllerJobUsageDetail: build.query<
      WorkspaceControllerJobUsageDetailApiResponse,
      WorkspaceControllerJobUsageDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/jobs/${queryArg.id}/usage`,
        params: { after: queryArg.after },
      }),
    }),
    workspaceStudioControllerDetail: build.query<
      WorkspaceStudioControllerDetailApiResponse,
      WorkspaceStudioControllerDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}`,
      }),
    }),
    workspaceStudioControllerInitialize: build.mutation<
      WorkspaceStudioControllerInitializeApiResponse,
      WorkspaceStudioControllerInitializeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    workspaceStudioControllerVersions: build.query<
      WorkspaceStudioControllerVersionsApiResponse,
      WorkspaceStudioControllerVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}/versions`,
        params: { before: queryArg.before },
      }),
    }),
    workspaceStudioControllerBranch: build.mutation<
      WorkspaceStudioControllerBranchApiResponse,
      WorkspaceStudioControllerBranchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}/branches`,
        method: 'POST',
        body: queryArg.studioCreateBranchDto,
      }),
    }),
    workspaceStudioControllerSave: build.mutation<
      WorkspaceStudioControllerSaveApiResponse,
      WorkspaceStudioControllerSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}/branches/${queryArg.branchId}`,
        method: 'PATCH',
        body: queryArg.studioSaveDto,
      }),
    }),
    workspaceStudioControllerRemove: build.mutation<
      WorkspaceStudioControllerRemoveApiResponse,
      WorkspaceStudioControllerRemoveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}/branches/${queryArg.branchId}`,
        method: 'DELETE',
        body: queryArg.studioRevisionDto,
      }),
    }),
    workspaceStudioControllerSync: build.mutation<
      WorkspaceStudioControllerSyncApiResponse,
      WorkspaceStudioControllerSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}/branches/${queryArg.branchId}/sync`,
        method: 'POST',
        body: queryArg.studioRevisionDto,
      }),
    }),
    workspaceStudioControllerRestore: build.mutation<
      WorkspaceStudioControllerRestoreApiResponse,
      WorkspaceStudioControllerRestoreApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}/branches/${queryArg.branchId}/restore`,
        method: 'POST',
        body: queryArg.studioRestoreDto,
      }),
    }),
    workspaceStudioControllerPublish: build.mutation<
      WorkspaceStudioControllerPublishApiResponse,
      WorkspaceStudioControllerPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/studios/${queryArg.campaignId}/${queryArg.agentId}/branches/${queryArg.branchId}/publish`,
        method: 'POST',
        body: queryArg.studioPublishDto,
      }),
    }),
    workspaceControllerRecordConfigurationCheck: build.mutation<
      WorkspaceControllerRecordConfigurationCheckApiResponse,
      WorkspaceControllerRecordConfigurationCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/${queryArg.id}/check-configuration`,
        method: 'POST',
        body: queryArg.workspaceRecordConfigurationCheckDto,
      }),
    }),
    workspaceControllerConfigurationChecks: build.query<
      WorkspaceControllerConfigurationChecksApiResponse,
      WorkspaceControllerConfigurationChecksApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/${queryArg.id}/checks`,
        params: { before: queryArg.before },
      }),
    }),
    workspaceControllerPreviewEvent: build.mutation<
      WorkspaceControllerPreviewEventApiResponse,
      WorkspaceControllerPreviewEventApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/missions/preview-event`,
        method: 'POST',
        body: queryArg.workspacePreviewEventDto,
      }),
    }),
    privateRuntimeConfigControllerPublish: build.mutation<
      PrivateRuntimeConfigControllerPublishApiResponse,
      PrivateRuntimeConfigControllerPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.callId}/runtime-config`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    privateRuntimeConfigControllerResolve: build.query<
      PrivateRuntimeConfigControllerResolveApiResponse,
      PrivateRuntimeConfigControllerResolveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.callId}/runtime-config/${queryArg.id}`,
        headers: { 'x-callevate-runtime-consumer': queryArg['x-callevate-runtime-consumer'] },
        params: { executionAttemptId: queryArg.executionAttemptId },
      }),
    }),
    widgetControllerGet: build.query<WidgetControllerGetApiResponse, WidgetControllerGetApiArg>({
      query: (queryArg) => ({
        url: `/v2/workspace/widgets/${queryArg.campaignId}/${queryArg.agentId}`,
      }),
    }),
    widgetControllerSave: build.mutation<
      WidgetControllerSaveApiResponse,
      WidgetControllerSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/widgets/${queryArg.campaignId}/${queryArg.agentId}`,
        method: 'PUT',
        body: queryArg.body,
      }),
    }),
    widgetControllerPublish: build.mutation<
      WidgetControllerPublishApiResponse,
      WidgetControllerPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/widgets/${queryArg.id}/publish`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    widgetControllerDisable: build.mutation<
      WidgetControllerDisableApiResponse,
      WidgetControllerDisableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/widgets/${queryArg.id}/disable`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    publicWidgetControllerConfig: build.query<
      PublicWidgetControllerConfigApiResponse,
      PublicWidgetControllerConfigApiArg
    >({
      query: (queryArg) => ({ url: `/v2/public/widgets/${queryArg.id}` }),
    }),
    publicWidgetControllerSession: build.mutation<
      PublicWidgetControllerSessionApiResponse,
      PublicWidgetControllerSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/public/widgets/${queryArg.id}/sessions`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    workspaceControllerAcknowledgeReview: build.mutation<
      WorkspaceControllerAcknowledgeReviewApiResponse,
      WorkspaceControllerAcknowledgeReviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/workspace/operations/${queryArg.id}/acknowledge-review`,
        method: 'POST',
        body: queryArg.workspaceRunDto,
      }),
    }),
    conversationFinalizationControllerPublish: build.mutation<
      ConversationFinalizationControllerPublishApiResponse,
      ConversationFinalizationControllerPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/conversation-finalization`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    preCallContextControllerLookup: build.mutation<
      PreCallContextControllerLookupApiResponse,
      PreCallContextControllerLookupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/system/calls/${queryArg.id}/pre-call-context`,
        method: 'POST',
        body: queryArg.body,
        headers: { 'x-callevate-runtime-consumer': queryArg['x-callevate-runtime-consumer'] },
      }),
    }),
    stripeTopUpControllerCatalog: build.query<
      StripeTopUpControllerCatalogApiResponse,
      StripeTopUpControllerCatalogApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/top-ups`,
        params: { from: queryArg['from'], to: queryArg.to, after: queryArg.after },
      }),
    }),
    stripeTopUpControllerCheckout: build.mutation<
      StripeTopUpControllerCheckoutApiResponse,
      StripeTopUpControllerCheckoutApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/top-ups/checkout`,
        method: 'POST',
        body: queryArg.stripeTopUpRequestDto,
      }),
    }),
    stripeAutoTopUpControllerRead: build.query<
      StripeAutoTopUpControllerReadApiResponse,
      StripeAutoTopUpControllerReadApiArg
    >({
      query: (queryArg) => ({ url: `/v2/companies/${queryArg.companyId}/billing/auto-top-up` }),
    }),
    stripeAutoTopUpControllerSetup: build.mutation<
      StripeAutoTopUpControllerSetupApiResponse,
      StripeAutoTopUpControllerSetupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/auto-top-up/setup`,
        method: 'POST',
        body: queryArg.autoTopUpSetupDto,
      }),
    }),
    stripeAutoTopUpControllerEnable: build.mutation<
      StripeAutoTopUpControllerEnableApiResponse,
      StripeAutoTopUpControllerEnableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/auto-top-up/enable`,
        method: 'POST',
        body: queryArg.autoTopUpConfirmDto,
      }),
    }),
    stripeAutoTopUpControllerDisable: build.mutation<
      StripeAutoTopUpControllerDisableApiResponse,
      StripeAutoTopUpControllerDisableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/auto-top-up/disable`,
        method: 'POST',
        body: queryArg.autoTopUpRequestDto,
      }),
    }),
    stripeAutoTopUpControllerPayment: build.mutation<
      StripeAutoTopUpControllerPaymentApiResponse,
      StripeAutoTopUpControllerPaymentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/auto-top-up/purchases/${queryArg.purchaseId}/payment`,
        method: 'POST',
      }),
    }),
    stripeAutoTopUpControllerCancel: build.mutation<
      StripeAutoTopUpControllerCancelApiResponse,
      StripeAutoTopUpControllerCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/auto-top-up/purchases/${queryArg.purchaseId}/cancel`,
        method: 'POST',
        body: queryArg.autoTopUpRequestDto,
      }),
    }),
    stripeBillingHistoryControllerRead: build.query<
      StripeBillingHistoryControllerReadApiResponse,
      StripeBillingHistoryControllerReadApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/history`,
        params: { from: queryArg['from'], to: queryArg.to, after: queryArg.after },
      }),
    }),
    billingUsageControllerRead: build.query<
      BillingUsageControllerReadApiResponse,
      BillingUsageControllerReadApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/usage`,
        params: {
          campaignId: queryArg.campaignId,
          agentId: queryArg.agentId,
          from: queryArg['from'],
          to: queryArg.to,
        },
      }),
    }),
    stripeBillingHistoryControllerDocument: build.query<
      StripeBillingHistoryControllerDocumentApiResponse,
      StripeBillingHistoryControllerDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/history/top-ups/${queryArg.purchaseId}/document`,
      }),
    }),
    stripeAutoTopUpControllerUpdate: build.mutation<
      StripeAutoTopUpControllerUpdateApiResponse,
      StripeAutoTopUpControllerUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/auto-top-up/settings`,
        method: 'POST',
        body: queryArg.autoTopUpUpdateDto,
      }),
    }),
    billingInsightsControllerRead: build.query<
      BillingInsightsControllerReadApiResponse,
      BillingInsightsControllerReadApiArg
    >({
      query: (queryArg) => ({ url: `/v2/companies/${queryArg.companyId}/billing/insights` }),
    }),
    billingUsageControllerCalls: build.query<
      BillingUsageControllerCallsApiResponse,
      BillingUsageControllerCallsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/companies/${queryArg.companyId}/billing/usage/calls`,
        params: {
          campaignId: queryArg.campaignId,
          agentId: queryArg.agentId,
          from: queryArg['from'],
          to: queryArg.to,
          after: queryArg.after,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as apiService };
export type AppControllerGetHelloApiResponse = /** status 200  */ string;
export type AppControllerGetHelloApiArg = void;
export type MetricsControllerWebhookApiResponse = unknown;
export type MetricsControllerWebhookApiArg = void;
export type RefreshTokensControllerRefreshTokenUserApiResponse =
  /** status 201  */ AccessTokenResponseDto;
export type RefreshTokensControllerRefreshTokenUserApiArg = void;
export type RefreshTokensControllerRefreshTokenAdminApiResponse =
  /** status 201  */ AccessTokenResponseDto;
export type RefreshTokensControllerRefreshTokenAdminApiArg = void;
export type SignInControllerSignInUserApiResponse = /** status 201  */ AccessTokenResponseDto;
export type SignInControllerSignInUserApiArg = {
  signInRequestDto: SignInRequestDto;
};
export type SignInControllerSignInAdminApiResponse = /** status 201  */ AccessTokenResponseDto;
export type SignInControllerSignInAdminApiArg = {
  signInRequestDto: SignInRequestDto;
};
export type SignOutControllerSignOutUserApiResponse = unknown;
export type SignOutControllerSignOutUserApiArg = void;
export type SignOutControllerSignOutAdminApiResponse = unknown;
export type SignOutControllerSignOutAdminApiArg = void;
export type ApiKeyControllerGetSystemApiKeyInfoApiResponse = /** status 200  */ ApiKeyDto;
export type ApiKeyControllerGetSystemApiKeyInfoApiArg = {
  jti: string;
};
export type OidcLoginStartControllerAuthorizeApiResponse = unknown;
export type OidcLoginStartControllerAuthorizeApiArg = void;
export type OidcLoginCompleteControllerCallbackApiResponse = unknown;
export type OidcLoginCompleteControllerCallbackApiArg = {
  state: string;
  /** Present on success */
  code?: string;
  /** Present when the provider refused the sign-in */
  error?: string;
  errorDescription?: string;
};
export type ForgotPasswordControllerForgotPasswordApiResponse =
  /** status 201  */ ForgotPasswordResponseDto;
export type ForgotPasswordControllerForgotPasswordApiArg = {
  forgotPasswordRequestDto: ForgotPasswordRequestDto;
};
export type ResetPasswordControllerResetPasswordApiResponse =
  /** status 201  */ ResetPasswordResponseDto;
export type ResetPasswordControllerResetPasswordApiArg = {
  resetPasswordRequestDto: ResetPasswordRequestDto;
};
export type UserMeControllerUserMeApiResponse = /** status 200  */ UserMeResponseDto;
export type UserMeControllerUserMeApiArg = void;
export type UserListControllerListApiResponse = /** status 200  */ UserListItemResponseDto[];
export type UserListControllerListApiArg = void;
export type UserListControllerListForManagerApiResponse =
  /** status 200  */ UserListItemResponseDto[];
export type UserListControllerListForManagerApiArg = {
  id: string;
};
export type UserCreateControllerCreateUserApiResponse = /** status 201  */ UserDto;
export type UserCreateControllerCreateUserApiArg = {
  userCreateRequestDto: UserCreateRequestDto;
};
export type UserUpdateControllerUpdateApiResponse = /** status 200  */ UserDto;
export type UserUpdateControllerUpdateApiArg = {
  id: string;
  userUpdateRequestDto: UserUpdateRequestDto;
};
export type AdminMeControllerAdminMeApiResponse = /** status 200  */ AdminDto;
export type AdminMeControllerAdminMeApiArg = void;
export type PermissionGroupCreateControllerCreateApiResponse =
  /** status 201  */ PermissionGroupDto;
export type PermissionGroupCreateControllerCreateApiArg = {
  permissionGroupCreateRequestDto: PermissionGroupCreateRequestDto;
};
export type PermissionGroupListControllerListApiResponse = /** status 200  */ PermissionGroupDto[];
export type PermissionGroupListControllerListApiArg = void;
export type PermissionGroupCreateControllerCreateForManagerApiResponse =
  /** status 201  */ PermissionGroupDto;
export type PermissionGroupCreateControllerCreateForManagerApiArg = {
  id: string;
  permissionGroupCreateRequestDto: PermissionGroupCreateRequestDto;
};
export type PermissionGroupListControllerListForManagerApiResponse =
  /** status 200  */ PermissionGroupDto[];
export type PermissionGroupListControllerListForManagerApiArg = {
  id: string;
};
export type PermissionGroupUpdateControllerUpdateApiResponse =
  /** status 200  */ PermissionGroupDto;
export type PermissionGroupUpdateControllerUpdateApiArg = {
  groupId: string;
  permissionGroupUpdateRequestDto: PermissionGroupUpdateRequestDto;
};
export type PermissionGroupDeleteControllerDeleteApiResponse = /** status 200  */ BaseOkResponseDto;
export type PermissionGroupDeleteControllerDeleteApiArg = {
  groupId: string;
};
export type PermissionGroupUpdateControllerUpdateForManagerApiResponse =
  /** status 200  */ PermissionGroupDto;
export type PermissionGroupUpdateControllerUpdateForManagerApiArg = {
  id: string;
  groupId: string;
  permissionGroupUpdateRequestDto: PermissionGroupUpdateRequestDto;
};
export type PermissionGroupDeleteControllerDeleteForManagerApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type PermissionGroupDeleteControllerDeleteForManagerApiArg = {
  id: string;
  groupId: string;
};
export type UserPermissionGroupAttachControllerAttachApiResponse =
  /** status 201  */ BaseOkResponseDto;
export type UserPermissionGroupAttachControllerAttachApiArg = {
  userId: string;
  groupId: string;
};
export type UserPermissionGroupDetachControllerDetachApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type UserPermissionGroupDetachControllerDetachApiArg = {
  userId: string;
  groupId: string;
};
export type UserPermissionGroupAttachControllerAttachForManagerApiResponse =
  /** status 201  */ BaseOkResponseDto;
export type UserPermissionGroupAttachControllerAttachForManagerApiArg = {
  id: string;
  userId: string;
  groupId: string;
};
export type UserPermissionGroupDetachControllerDetachForManagerApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type UserPermissionGroupDetachControllerDetachForManagerApiArg = {
  id: string;
  userId: string;
  groupId: string;
};
export type UserPermissionGroupListControllerListApiResponse =
  /** status 200  */ UserPermissionGroupDto[];
export type UserPermissionGroupListControllerListApiArg = {
  userId: string;
};
export type UserPermissionGroupListControllerListForManagerApiResponse =
  /** status 200  */ UserPermissionGroupDto[];
export type UserPermissionGroupListControllerListForManagerApiArg = {
  id: string;
  userId: string;
};
export type AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiResponse =
  /** status 201  */ object;
export type AnalysisStaleSweepControllerSystemAnalysisStaleSweepApiArg = void;
export type CallAnalysisCreateControllerSystemCreateCallAnalysisApiResponse =
  /** status 201  */ Analysis;
export type CallAnalysisCreateControllerSystemCreateCallAnalysisApiArg = {
  id: string;
  /** Accepts legacy completed payloads without status and explicit completed/failed callbacks from the analysis service. */
  callAnalysisCreateRequestDto: CallAnalysisCreateRequestDto;
};
export type CallSentimentCreateControllerCreateCallSentimentApiResponse =
  /** status 201  */ SentimentDto;
export type CallSentimentCreateControllerCreateCallSentimentApiArg = {
  id: string;
  sentimentRequestDto: SentimentRequestDto;
};
export type CallUpdateControllerSystemCallUpdateApiResponse = /** status 200  */ CallDto;
export type CallUpdateControllerSystemCallUpdateApiArg = {
  id: string;
  callRequestDto: CallRequestDto;
};
export type CallControllerSystemGetCallByIdApiResponse = /** status 200  */ CallDto;
export type CallControllerSystemGetCallByIdApiArg = {
  id: string;
  relations?:
    | 'customer'
    | 'customer.campaign'
    | 'agent'
    | 'company'
    | 'analysis'
    | 'agent.profile'
    | 'agent.voice'
    | 'agent.transcriber'
    | 'agent.analysisPlan'
    | 'agent.toolSettings'
    | 'agent.toolSettings.tool'
    | 'squad'
    | 'squad.handoffRules'
    | 'squad.agents'
    | 'squad.agents.agent'
    | 'squad.agents.agent.profile'
    | 'squad.agents.agent.voice'
    | 'squad.agents.agent.transcriber'
    | 'squad.agents.agent.analysisPlan'
    | 'squad.agents.agent.toolSettings'
    | 'squad.agents.agent.toolSettings.tool';
};
export type CallSupervisorModeControllerSetSupervisorModeApiResponse =
  /** status 200  */ CallSupervisorModeDto;
export type CallSupervisorModeControllerSetSupervisorModeApiArg = {
  id: string;
  callSupervisorModeRequestDto: CallSupervisorModeRequestDto;
};
export type CallStaleSweepControllerSystemStaleSweepApiResponse = /** status 201  */ object;
export type CallStaleSweepControllerSystemStaleSweepApiArg = void;
export type CampaignTestCallCreateControllerTestCallCreateApiResponse =
  /** status 201  */ CampaignTestCallCreateResponseDto;
export type CampaignTestCallCreateControllerTestCallCreateApiArg = {
  id: string;
  campaignTestCallCreateRequestDto: CampaignTestCallCreateRequestDto;
};
export type CampaignCallListControllerCallListApiResponse = /** status 200  */ CallDto[];
export type CampaignCallListControllerCallListApiArg = {
  id: string;
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  sortBy?: 'phoneNumber' | 'createdAt' | 'startDate' | 'endedAt' | 'callDuration' | 'sentiments';
  sortOrder?: 'ASC' | 'DESC';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
};
export type CampaignTestCallCreateControllerExternalTestCallCreateApiResponse =
  /** status 201  */ CampaignTestCallCreateResponseDto;
export type CampaignTestCallCreateControllerExternalTestCallCreateApiArg = {
  id: string;
  campaignTestCallCreateRequestDto: CampaignTestCallCreateRequestDto;
};
export type CallCreateExternalControllerCampaignOutboundCallApiResponse =
  /** status 201  */ CustomerDto[];
export type CallCreateExternalControllerCampaignOutboundCallApiArg = {
  id: string;
  callCreateExternalRequestDto: CallCreateExternalRequestDto;
};
export type CampaignCallHangupControllerCampaignCallHangupApiResponse = /** status 201  */ CallDto;
export type CampaignCallHangupControllerCampaignCallHangupApiArg = {
  id: string;
  callId: string;
};
export type CampaignCallHangupControllerExternalCampaignCallHangupApiResponse =
  /** status 201  */ CallDto;
export type CampaignCallHangupControllerExternalCampaignCallHangupApiArg = {
  id: string;
  callId: string;
};
export type CampaignCloneSystemControllerCloneCampaignApiResponse = unknown;
export type CampaignCloneSystemControllerCloneCampaignApiArg = {
  campaignId: string;
  campaignCloneRequestDto: CampaignCloneRequestDto;
};
export type CampaignCreateControllerCampaignCreateApiResponse = /** status 201  */ CampaignDto;
export type CampaignCreateControllerCampaignCreateApiArg = {
  campaignCreateRequestDto: CampaignCreateRequestDto;
};
export type CampaignListControllerCampaignListApiResponse = /** status 200  */ CampaignDto[];
export type CampaignListControllerCampaignListApiArg = void;
export type CampaignDeleteControllerDeleteCampaignApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignDeleteControllerDeleteCampaignApiArg = {
  id: string;
};
export type CampaignUpdateControllerCampaignUpdateApiResponse = /** status 200  */ CampaignDto;
export type CampaignUpdateControllerCampaignUpdateApiArg = {
  id: string;
  campaignUpdateRequestDto: CampaignUpdateRequestDto;
};
export type CampaignControllerCampaignApiResponse = /** status 200  */ CampaignDto;
export type CampaignControllerCampaignApiArg = {
  id: string;
};
export type CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiResponse =
  /** status 201  */ object[];
export type CampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerApiArg = void;
export type CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiResponse =
  /** status 200  */ CampaignAnalysisBatchRunResponseDto;
export type CampaignAnalysisBatchRunControllerSystemRunAnalysisBatchApiArg = {
  id: string;
};
export type CampaignStructuredOutputGenerateControllerGenerateApiResponse =
  /** status 200  */ CampaignStructuredOutputGenerateResponseDto;
export type CampaignStructuredOutputGenerateControllerGenerateApiArg = {
  id: string;
};
export type CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiResponse =
  /** status 201  */ string[];
export type CampaignOutboundCallsProcessControllerSystemOutboundCallsProcessApiArg = void;
export type CampaignRunControllerCampaignRunApiResponse = /** status 201  */ CampaignDto;
export type CampaignRunControllerCampaignRunApiArg = {
  id: string;
};
export type CampaignSipTrunkCreateControllerCampaignCreateApiResponse =
  /** status 201  */ SipTrunkDto;
export type CampaignSipTrunkCreateControllerCampaignCreateApiArg = {
  id: string;
  campaignSipTrunkCreateRequestDto: CampaignSipTrunkCreateRequestDto;
};
export type CampaignSipTrunkControllerGetSipTrunkApiResponse =
  /** status 200  */ SipTrunkResponseDto;
export type CampaignSipTrunkControllerGetSipTrunkApiArg = {
  id: string;
};
export type CampaignStopControllerCampaignStopApiResponse = /** status 201  */ CampaignDto;
export type CampaignStopControllerCampaignStopApiArg = {
  id: string;
};
export type CampaignsStopExceededLimitsControllerStopExceededLimitsApiResponse =
  /** status 201  */ CampaignsStopExceededLimitsResponseDto;
export type CampaignsStopExceededLimitsControllerStopExceededLimitsApiArg = void;
export type CustomerUpdateControllerUpdateCustomerApiResponse = /** status 200  */ CustomerDto;
export type CustomerUpdateControllerUpdateCustomerApiArg = {
  customerId: string;
  customerUpdateRequestDto: CustomerUpdateRequestDto;
};
export type CampaignAgentCreateControllerExecuteApiResponse = /** status 201  */ AgentDto;
export type CampaignAgentCreateControllerExecuteApiArg = {
  id: string;
  agentRequestDto: AgentRequestDto;
};
export type CampaignAgentListControllerListApiResponse = /** status 200  */ AgentDto[];
export type CampaignAgentListControllerListApiArg = {
  id: string;
};
export type CampaignAgentUpdateControllerExecuteApiResponse = /** status 200  */ AgentDto;
export type CampaignAgentUpdateControllerExecuteApiArg = {
  id: string;
  agentId: string;
  agentRequestDto: AgentRequestDto;
};
export type CampaignAgentDeleteControllerExecuteApiResponse = /** status 200  */ BaseOkResponseDto;
export type CampaignAgentDeleteControllerExecuteApiArg = {
  id: string;
  agentId: string;
};
export type CallActionCreateControllerSystemCallActionCreateApiResponse =
  /** status 201  */ CallActionDto;
export type CallActionCreateControllerSystemCallActionCreateApiArg = {
  id: string;
  callActionRequestDto: CallActionRequestDto;
};
export type CallCreateSystemControllerSystemCampaignCallCreateApiResponse =
  /** status 201  */ CallDto;
export type CallCreateSystemControllerSystemCampaignCallCreateApiArg = {
  id: string;
  callCreateSystemRequestDto: CallCreateSystemRequestDto;
};
export type CallControllerGetCallByIdApiResponse = /** status 200  */ CallDto;
export type CallControllerGetCallByIdApiArg = {
  id: string;
  relations?:
    | 'customer'
    | 'customer.campaign'
    | 'agent'
    | 'company'
    | 'analysis'
    | 'agent.profile'
    | 'agent.voice'
    | 'agent.transcriber'
    | 'agent.analysisPlan'
    | 'agent.toolSettings'
    | 'agent.toolSettings.tool'
    | 'squad'
    | 'squad.handoffRules'
    | 'squad.agents'
    | 'squad.agents.agent'
    | 'squad.agents.agent.profile'
    | 'squad.agents.agent.voice'
    | 'squad.agents.agent.transcriber'
    | 'squad.agents.agent.analysisPlan'
    | 'squad.agents.agent.toolSettings'
    | 'squad.agents.agent.toolSettings.tool';
};
export type CampaignControllerSystemCampaignApiResponse = /** status 200  */ SystemCampaignDto;
export type CampaignControllerSystemCampaignApiArg = {
  id: string;
  relations?:
    | 'ambientSoundSetting'
    | 'ambientSoundSetting.sound'
    | 'thinkingSoundSettings'
    | 'thinkingSoundSettings.sound'
    | 'campaignAgents'
    | 'campaignAgents.agent'
    | 'campaignAgents.agent.idleState'
    | 'campaignAgents.agent.llmModel'
    | 'campaignAgents.agent.llmProvider'
    | 'campaignAgents.agent.profile'
    | 'campaignAgents.agent.voice'
    | 'campaignAgents.agent.transcriber'
    | 'campaignAgents.agent.toolSettings'
    | 'campaignAgents.agent.toolSettings.tool'
    | 'campaignAgents.agent.ambientSoundSetting'
    | 'campaignAgents.agent.ambientSoundSetting.sound'
    | 'campaignAgents.agent.thinkingSoundSettings'
    | 'campaignAgents.agent.thinkingSoundSettings.sound'
    | 'callSchedule'
    | 'sipTrunks'
    | 'analysisPlan'
    | 'campaignStructuredOutputs.structuredOutput'
    | 'toolSettings.tool'
    | 'campaignFiles'
    | 'campaignFiles.file'
    | 'campaignFiles.agents'
    | 'campaignFiles.agents.agent'
    | 'files'
    | 'files.file'
    | 'customers'
    | 'squad'
    | 'squad.handoffRules'
    | 'squad.agents'
    | 'squad.agents.agent'
    | 'squad.agents.agent.idleState'
    | 'squad.agents.agent.llmModel'
    | 'squad.agents.agent.llmProvider'
    | 'squad.agents.agent.profile'
    | 'squad.agents.agent.voice'
    | 'squad.agents.agent.transcriber'
    | 'squad.agents.agent.analysisPlan'
    | 'squad.agents.agent.toolSettings'
    | 'squad.agents.agent.toolSettings.tool'
    | 'squad.agents.agent.ambientSoundSetting'
    | 'squad.agents.agent.ambientSoundSetting.sound'
    | 'squad.agents.agent.thinkingSoundSettings'
    | 'squad.agents.agent.thinkingSoundSettings.sound';
};
export type CampaignCallControllerCallApiResponse = /** status 200  */ CallDto;
export type CampaignCallControllerCallApiArg = {
  id: string;
  callId: string;
};
export type CampaignCallListPaginatedControllerCallListPaginatedApiResponse =
  /** status 200  */ CampaignCallListPaginatedDto;
export type CampaignCallListPaginatedControllerCallListPaginatedApiArg = {
  id: string;
  limit?: number;
  cursor?: string;
  sortOrder?: 'ASC' | 'DESC';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  sortBy?: 'phoneNumber' | 'createdAt' | 'startDate' | 'endedAt' | 'callDuration' | 'sentiments';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  /** Include total calls count in response meta */
  withTotal?: boolean;
};
export type CampaignFileListControllerListApiResponse =
  /** status 200  */ CampaignFileResponseDto[];
export type CampaignFileListControllerListApiArg = {
  id: string;
  search?: string;
};
export type CampaignListControllerExternalCampaignListApiResponse =
  /** status 200  */ ExternalCampaignDto[];
export type CampaignListControllerExternalCampaignListApiArg = void;
export type CampaignListPaginatedControllerGetCampaignListPaginatedApiResponse =
  /** status 200  */ CampaignListPaginatedDto;
export type CampaignListPaginatedControllerGetCampaignListPaginatedApiArg = {
  limit?: number;
  cursor?: string;
  sortOrder?: 'ASC' | 'DESC';
  sortBy?: 'title' | 'createdAt';
  /** Include total campaigns count in response meta */
  withTotal?: boolean;
  /** Filter campaigns by title (case-insensitive substring) */
  search?: string;
};
export type CampaignMetricCallDurationControllerCalculateCallDurationIqrApiResponse =
  /** status 200  */ CampaignMetricCallDurationResponseDto;
export type CampaignMetricCallDurationControllerCalculateCallDurationIqrApiArg = {
  id: string;
};
export type CampaignReportControllerUserCampaignsReportApiResponse = unknown;
export type CampaignReportControllerUserCampaignsReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
};
export type CampaignReportControllerUserCampaignReportApiResponse = unknown;
export type CampaignReportControllerUserCampaignReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
  id: string;
};
export type CampaignReportControllerAdminCampaignsReportApiResponse = unknown;
export type CampaignReportControllerAdminCampaignsReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
};
export type CampaignReportControllerAdminCampaignReportApiResponse = unknown;
export type CampaignReportControllerAdminCampaignReportApiArg = {
  start?: string;
  end?: string;
  numberSearch?: string;
  callIdSearch?: string;
  endedReason?:
    | 'agent-detected-end-call-phrase'
    | 'agent-join-timed-out'
    | 'customer-busy'
    | 'customer-unavailable'
    | 'customer-ended-call'
    | 'manually-canceled'
    | 'internal-error'
    | 'unknown-reason'
    | 'error-sip-telephony-provider-failed-to-connect-call'
    | 'error-sip-provider-declined'
    | 'usage-limits-exceeded'
    | 'concurrent-limit-reached'
    | 'agent-forwarded-call'
    | 'transfer-failed'
    | 'participant-removed'
    | 'customer-did-not-join'
    | 'worker-crashed'
    | 'stale-timeout';
  types?: 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
  statuses?:
    | 'pending'
    | 'scheduled'
    | 'ended'
    | 'queued'
    | 'initializing'
    | 'ringing'
    | 'in-progress';
  /** CSV of optional columns. Mandatory columns are always included: phoneNumber,startDate,endDate,status,endReason. */
  additionalColumns?:
    | 'callId'
    | 'callDuration'
    | 'retries'
    | 'whatsappFollowUp'
    | 'whatsappDelivered'
    | 'generateWhatsappMessage'
    | 'generatedWhatsappMessageDelivered'
    | 'agentNameAndAccent'
    | 'sentiments'
    | 'analysisSummary'
    | 'analysisDetailedSummary'
    | 'parentCallId'
    | 'campaignName'
    | 'campaignId'
    | 'recordingUrl'
    | 'transcriptUrl';
  separatedAnalysisSummary?: boolean;
  id: string;
};
export type CallAccessTokenControllerGetCallAccessTokenApiResponse =
  /** status 200  */ CallAccessTokenDto;
export type CallAccessTokenControllerGetCallAccessTokenApiArg = {
  id: string;
  /** Omit for the passive viewer token (Admin and Viewer). Supplying it opens a supervisor session and requires the call.supervise privilege. */
  mode?: 'listen' | 'barge';
};
export type CallAccessTokenControllerGetExternalCallAccessTokenApiResponse =
  /** status 200  */ CallAccessTokenDto;
export type CallAccessTokenControllerGetExternalCallAccessTokenApiArg = {
  id: string;
};
export type CallRecordingControllerGetCallRecordingApiResponse =
  /** status 200  */ CallRecordingDto;
export type CallRecordingControllerGetCallRecordingApiArg = {
  id: string;
};
export type CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiResponse =
  /** status 200  */ object;
export type CampaignActiveCallPollControllerExternalCampaignActiveCallPollApiArg = {
  id: string;
};
export type CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiResponse =
  /** status 200  */ CallNotAnalyzedListDto[];
export type CallNotAnalyzedListControllerSystemGetNotAnalyzedCallsApiArg = void;
export type CustomerListPaginatedControllerGetCustomerListPaginatedApiResponse =
  /** status 200  */ CustomerListPaginatedDto;
export type CustomerListPaginatedControllerGetCustomerListPaginatedApiArg = {
  limit?: number;
  cursor?: string;
  sortOrder?: 'ASC' | 'DESC';
  campaignId: string;
  sortBy?: 'name' | 'createdAt';
};
export type CustomerListExportControllerGetCustomerListForExportApiResponse =
  /** status 200  */ CustomerListExportResponseDto;
export type CustomerListExportControllerGetCustomerListForExportApiArg = {
  campaignId: string;
  sortBy?: 'name' | 'createdAt';
  sortOrder?: 'ASC' | 'DESC';
};
export type BackgroundSoundAgentSettingsUpdateControllerExecuteApiResponse =
  /** status 200  */ AgentBackgroundSoundsResponseDto;
export type BackgroundSoundAgentSettingsUpdateControllerExecuteApiArg = {
  agentId: string;
  agentBackgroundSoundsRequestDto: AgentBackgroundSoundsRequestDto;
};
export type BackgroundSoundCreateControllerCreateApiResponse =
  /** status 201  */ BackgroundSoundResponseDto;
export type BackgroundSoundCreateControllerCreateApiArg = {
  backgroundSoundCreateRequestDto: BackgroundSoundCreateRequestDto;
};
export type BackgroundSoundListControllerAdminListApiResponse =
  /** status 200  */ BackgroundSoundResponseDto[];
export type BackgroundSoundListControllerAdminListApiArg = void;
export type BackgroundSoundDeleteControllerDeleteApiResponse = /** status 200  */ BaseOkResponseDto;
export type BackgroundSoundDeleteControllerDeleteApiArg = {
  id: string;
};
export type BackgroundSoundUpdateControllerUpdateApiResponse =
  /** status 200  */ BackgroundSoundResponseDto;
export type BackgroundSoundUpdateControllerUpdateApiArg = {
  id: string;
  backgroundSoundUpdateRequestDto: BackgroundSoundUpdateRequestDto;
};
export type BackgroundSoundUploadUrlControllerCreateUploadUrlApiResponse =
  /** status 201  */ BackgroundSoundUploadUrlResponseDto;
export type BackgroundSoundUploadUrlControllerCreateUploadUrlApiArg = {
  backgroundSoundUploadUrlRequestDto: BackgroundSoundUploadUrlRequestDto;
};
export type BackgroundSoundListControllerListApiResponse =
  /** status 200  */ BackgroundSoundResponseDto[];
export type BackgroundSoundListControllerListApiArg = void;
export type VoiceListControllerVoiceListApiResponse = /** status 200  */ VoiceDto[];
export type VoiceListControllerVoiceListApiArg = void;
export type VoiceListSystemControllerGetAllVoicesApiResponse = unknown;
export type VoiceListSystemControllerGetAllVoicesApiArg = void;
export type VoiceControllerGetVoiceApiResponse = /** status 200  */ VoiceDto;
export type VoiceControllerGetVoiceApiArg = {
  id: string;
};
export type VoiceDeleteControllerDeleteVoiceApiResponse = /** status 200  */ BaseOkResponseDto;
export type VoiceDeleteControllerDeleteVoiceApiArg = {
  id: string;
};
export type VoiceEditControllerEditVoiceApiResponse = /** status 200  */ VoiceDto;
export type VoiceEditControllerEditVoiceApiArg = {
  id: string;
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceSystemControllerGetVoiceApiResponse = unknown;
export type VoiceSystemControllerGetVoiceApiArg = {
  id: string;
};
export type VoiceEditSystemControllerEditVoiceApiResponse = unknown;
export type VoiceEditSystemControllerEditVoiceApiArg = {
  id: string;
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceCreateControllerCreateVoiceApiResponse = /** status 201  */ VoiceDto;
export type VoiceCreateControllerCreateVoiceApiArg = {
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceCreateSystemControllerCreateVoiceApiResponse = unknown;
export type VoiceCreateSystemControllerCreateVoiceApiArg = {
  voiceRequestDto: VoiceRequestDto;
};
export type VoiceDeleteSystemControllerDeleteVoiceApiResponse = unknown;
export type VoiceDeleteSystemControllerDeleteVoiceApiArg = {
  id: string;
};
export type CustomTranscriberEditControllerEditTranscriberApiResponse =
  /** status 200  */ TranscriberResponseDto;
export type CustomTranscriberEditControllerEditTranscriberApiArg = {
  id: string;
  customTranscriberRequestDto: CustomTranscriberRequestDto;
};
export type CustomTranscriberCreateControllerCreateTranscriberApiResponse =
  /** status 201  */ TranscriberResponseDto;
export type CustomTranscriberCreateControllerCreateTranscriberApiArg = {
  customTranscriberRequestDto: CustomTranscriberRequestDto;
};
export type TranscriberListControllerTranscriberListApiResponse =
  /** status 200  */ TranscriberResponseDto[];
export type TranscriberListControllerTranscriberListApiArg = void;
export type TranscriberListControllerGetTranscriberApiResponse =
  /** status 200  */ TranscriberResponseDto;
export type TranscriberListControllerGetTranscriberApiArg = {
  id: string;
};
export type TranscriberListControllerAdminTranscriberListApiResponse =
  /** status 200  */ TranscriberResponseDto[];
export type TranscriberListControllerAdminTranscriberListApiArg = void;
export type TranscriberCreateControllerCreateTranscriberApiResponse =
  /** status 201  */ TranscriberResponseDto;
export type TranscriberCreateControllerCreateTranscriberApiArg = {
  transcriberRequestDto: TranscriberRequestDto;
};
export type TranscriberControllerGetTranscriberApiResponse =
  /** status 200  */ TranscriberResponseDto;
export type TranscriberControllerGetTranscriberApiArg = {
  id: string;
};
export type TranscriberDeleteControllerDeleteTranscriberApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type TranscriberDeleteControllerDeleteTranscriberApiArg = {
  id: string;
};
export type TranscriberEditControllerEditTranscriberApiResponse =
  /** status 200  */ TranscriberResponseDto;
export type TranscriberEditControllerEditTranscriberApiArg = {
  id: string;
  transcriberRequestDto: TranscriberRequestDto;
};
export type CreateCompanyControllerCreateCompanyApiResponse = /** status 201  */ CompanyDto;
export type CreateCompanyControllerCreateCompanyApiArg = {
  createCompanyRequestDto: CreateCompanyRequestDto;
};
export type CompanyControllerGetCompanyApiResponse = /** status 200  */ CompanyDto;
export type CompanyControllerGetCompanyApiArg = {
  id: string;
};
export type CompanyControllerGetCompanyAsAdminApiResponse = /** status 200  */ CompanyDto;
export type CompanyControllerGetCompanyAsAdminApiArg = {
  id: string;
};
export type EditCompanyControllerEditCompanyApiResponse = /** status 200  */ CompanyDto;
export type EditCompanyControllerEditCompanyApiArg = {
  id: string;
  editCompanyRequestDto: EditCompanyRequestDto;
};
export type GetAllCompanyIdsControllerGetAllCompanyIdsApiResponse = /** status 200  */ string[];
export type GetAllCompanyIdsControllerGetAllCompanyIdsApiArg = void;
export type CompanyApiKeyCreateControllerApiKeyCreateApiResponse =
  /** status 201  */ CompanyApiKeyCreateResponseDto;
export type CompanyApiKeyCreateControllerApiKeyCreateApiArg = {
  id: string;
};
export type CompanyApiKeyRevokeControllerApiKeyRevokeApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CompanyApiKeyRevokeControllerApiKeyRevokeApiArg = {
  id: string;
  apiKeyId: string;
};
export type AgentProfileCreateControllerAgentProfileCreateForUsersApiResponse =
  /** status 201  */ AgentProfileResponseDto;
export type AgentProfileCreateControllerAgentProfileCreateForUsersApiArg = {
  agentProfileCreateRequestDto: AgentProfileCreateRequestDto;
};
export type AgentProfileListControllerAgentProfileListForUsersApiResponse =
  /** status 200  */ AgentProfileResponseDto[];
export type AgentProfileListControllerAgentProfileListForUsersApiArg = {
  /** Filter agent profiles by type. Can be a single value (system, custom, customer-template) or comma-separated values (e.g., system,custom). If not specified, returns all profiles. */
  filter?: string;
};
export type AgentProfileCreateControllerAgentProfileCreateForManagersApiResponse =
  /** status 201  */ AgentProfileResponseDto;
export type AgentProfileCreateControllerAgentProfileCreateForManagersApiArg = {
  id: string;
  agentProfileCreateAdminRequestDto: AgentProfileCreateAdminRequestDto;
};
export type AgentProfileListControllerAgentProfileListForAdminsApiResponse =
  /** status 200  */ AgentProfileResponseDto[];
export type AgentProfileListControllerAgentProfileListForAdminsApiArg = {
  id: string;
  /** Filter agent profiles by type. Can be a single value (system, custom, customer-template) or comma-separated values (e.g., system,custom). If not specified, returns all profiles. */
  filter?: string;
};
export type AgentProfileEditControllerAgentProfileEditForUsersApiResponse =
  /** status 200  */ AgentProfileResponseDto;
export type AgentProfileEditControllerAgentProfileEditForUsersApiArg = {
  profileId: string;
  agentProfileEditRequestDto: AgentProfileEditRequestDto;
};
export type AgentProfileDeleteControllerAgentProfileDeleteForUsersApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type AgentProfileDeleteControllerAgentProfileDeleteForUsersApiArg = {
  profileId: string;
};
export type AgentProfileEditControllerAgentProfileEditForManagersApiResponse =
  /** status 200  */ AgentProfileResponseDto;
export type AgentProfileEditControllerAgentProfileEditForManagersApiArg = {
  id: string;
  profileId: string;
  agentProfileEditRequestDto: AgentProfileEditRequestDto;
};
export type AgentProfileDeleteControllerAgentProfileDeleteForManagersApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type AgentProfileDeleteControllerAgentProfileDeleteForManagersApiArg = {
  id: string;
  profileId: string;
};
export type CompanyOverviewControllerGetCompanyOverviewApiResponse =
  /** status 200  */ CompanyOverviewResponseDto;
export type CompanyOverviewControllerGetCompanyOverviewApiArg = void;
export type CompanyListControllerCompanyListApiResponse = /** status 200  */ CompanyDto[];
export type CompanyListControllerCompanyListApiArg = void;
export type UsageLimitControllerUsageLimitsApiResponse =
  /** status 200  */ RemainingLimitResponseDto;
export type UsageLimitControllerUsageLimitsApiArg = void;
export type UsageLimitControllerAdminUsageLimitsApiResponse =
  /** status 200  */ RemainingLimitResponseDto;
export type UsageLimitControllerAdminUsageLimitsApiArg = {
  id: string;
};
export type UsageLimitSetControllerSetLimitsApiResponse =
  /** status 200  */ UsageLimitResponseDto[];
export type UsageLimitSetControllerSetLimitsApiArg = {
  id: string;
  usageLimitSetRequestDto: UsageLimitSetRequestDto;
};
export type UsageLimitControllerSystemUsageLimitsApiResponse =
  /** status 200  */ RemainingLimitResponseDto;
export type UsageLimitControllerSystemUsageLimitsApiArg = {
  id: string;
};
export type CompanyVoicesSetControllerSetCompanyVoicesApiResponse = /** status 200  */ CompanyDto;
export type CompanyVoicesSetControllerSetCompanyVoicesApiArg = {
  id: string;
  companyVoicesSetRequestDto: CompanyVoicesSetRequestDto;
};
export type CompanyTranscribersSetControllerSetCompanyTranscribersApiResponse =
  /** status 200  */ CompanyDto;
export type CompanyTranscribersSetControllerSetCompanyTranscribersApiArg = {
  id: string;
  companyTranscribersSetRequestDto: CompanyTranscribersSetRequestDto;
};
export type CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiResponse =
  /** status 200  */ CompanyDto;
export type CompanyLlmProvidersSetControllerSetCompanyLlmProvidersApiArg = {
  id: string;
  companyLlmProvidersSetRequestDto: CompanyLlmProvidersSetRequestDto;
};
export type ConcurrentLimitSetControllerSetConcurrentLimitApiResponse =
  /** status 200  */ ConcurrentLimitSetResponseDto;
export type ConcurrentLimitSetControllerSetConcurrentLimitApiArg = {
  id: string;
  concurrentLimitSetRequestDto: ConcurrentLimitSetRequestDto;
};
export type UnitWeightsControllerGetUnitWeightsApiResponse =
  /** status 200  */ UnitWeightsResponseDto[];
export type UnitWeightsControllerGetUnitWeightsApiArg = void;
export type UnitWeightsSetControllerSetUnitWeightsApiResponse =
  /** status 200  */ UnitWeightsResponseDto[];
export type UnitWeightsSetControllerSetUnitWeightsApiArg = {
  unitWeightsSetRequestDto: UnitWeightsSetRequestDto;
};
export type LivekitControllerWebhookApiResponse = unknown;
export type LivekitControllerWebhookApiArg = void;
export type CampaignPostCallMessageCreateControllerCreateApiResponse =
  /** status 201  */ CampaignPostCallMessageResponseDto;
export type CampaignPostCallMessageCreateControllerCreateApiArg = {
  campaignId: string;
  campaignPostCallMessageCreateRequestDto: CampaignPostCallMessageCreateRequestDto;
};
export type CampaignPostCallMessagesControllerListApiResponse =
  /** status 200  */ CampaignPostCallMessageResponseDto[];
export type CampaignPostCallMessagesControllerListApiArg = {
  campaignId: string;
};
export type CampaignPostCallMessageUpdateControllerUpdateApiResponse =
  /** status 200  */ CampaignPostCallMessageResponseDto;
export type CampaignPostCallMessageUpdateControllerUpdateApiArg = {
  campaignId: string;
  messageId: string;
  campaignPostCallMessageUpdateRequestDto: CampaignPostCallMessageUpdateRequestDto;
};
export type CampaignPostCallMessageDeleteControllerDeleteApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignPostCallMessageDeleteControllerDeleteApiArg = {
  campaignId: string;
  messageId: string;
};
export type MessageDeliverySweepControllerSystemDeliverySweepApiResponse =
  /** status 201  */ object;
export type MessageDeliverySweepControllerSystemDeliverySweepApiArg = void;
export type MessageDeliveryUpdateControllerWebhookApiResponse = /** status 201  */ string[];
export type MessageDeliveryUpdateControllerWebhookApiArg = {
  token: string;
};
export type FileCreateControllerCreateApiResponse = /** status 201  */ FileResponseDto;
export type FileCreateControllerCreateApiArg = {
  fileCreateRequestDto: FileCreateRequestDto;
};
export type FileListControllerListApiResponse = /** status 200  */ FileResponseDto[];
export type FileListControllerListApiArg = void;
export type FileDeleteControllerDeleteApiResponse = /** status 200  */ BaseOkResponseDto;
export type FileDeleteControllerDeleteApiArg = {
  id: string;
};
export type FileControllerGetApiResponse = /** status 200  */ FileResponseDto;
export type FileControllerGetApiArg = {
  id: string;
};
export type CampaignFileAvailabilityUpdateControllerUpdateApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignFileAvailabilityUpdateControllerUpdateApiArg = {
  campaignId: string;
  fileId: string;
  campaignFileAvailabilityUpdateRequestDto: CampaignFileAvailabilityUpdateRequestDto;
};
export type CampaignFileAgentsSetControllerReplaceApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignFileAgentsSetControllerReplaceApiArg = {
  campaignId: string;
  fileId: string;
  campaignFileAgentsSetRequestDto: CampaignFileAgentsSetRequestDto;
};
export type CampaignFileDeleteControllerRemoveApiResponse = /** status 200  */ BaseOkResponseDto;
export type CampaignFileDeleteControllerRemoveApiArg = {
  campaignId: string;
  fileId: string;
};
export type FileOriginalControllerGetApiResponse = /** status 200  */ FileOriginalResponseDto;
export type FileOriginalControllerGetApiArg = {
  fileId: string;
};
export type CampaignFileSearchControllerSearchApiResponse =
  /** status 200  */ CampaignFileSearchResponseDto[];
export type CampaignFileSearchControllerSearchApiArg = {
  campaignId: string;
  fileId: string;
  query: string;
};
export type FileReindexControllerReindexApiResponse = /** status 201  */ BaseOkResponseDto;
export type FileReindexControllerReindexApiArg = {
  fileId: string;
};
export type SquadCreateControllerExecuteApiResponse = /** status 201  */ SquadDto;
export type SquadCreateControllerExecuteApiArg = {
  id: string;
  squadCreateRequestDto: SquadCreateRequestDto;
};
export type SquadDeleteControllerExecuteApiResponse = unknown;
export type SquadDeleteControllerExecuteApiArg = {
  id: string;
};
export type SquadAgentCreateControllerExecuteApiResponse = /** status 201  */ SquadAgentResponseDto;
export type SquadAgentCreateControllerExecuteApiArg = {
  id: string;
  agentRequestDto: AgentRequestDto;
};
export type SquadAgentUpdateControllerExecuteApiResponse = /** status 200  */ SquadAgentResponseDto;
export type SquadAgentUpdateControllerExecuteApiArg = {
  id: string;
  agentId: string;
  squadAgentUpdateRequestDto: SquadAgentUpdateRequestDto;
};
export type SquadAgentDeleteControllerExecuteApiResponse =
  /** status 200  */ SquadAgentDeleteResponseDto;
export type SquadAgentDeleteControllerExecuteApiArg = {
  id: string;
  agentId: string;
};
export type HandoffRuleCreateControllerExecuteApiResponse =
  /** status 201  */ HandoffRuleResponseDto[];
export type HandoffRuleCreateControllerExecuteApiArg = {
  id: string;
  body: HandoffRuleRequestDto[];
};
export type StructuredOutputCreateControllerCreateApiResponse =
  /** status 201  */ StructuredOutputDto;
export type StructuredOutputCreateControllerCreateApiArg = {
  structuredOutputCreateRequestDto: StructuredOutputCreateRequestDto;
};
export type StructuredOutputListControllerListApiResponse =
  /** status 200  */ StructuredOutputDto[];
export type StructuredOutputListControllerListApiArg = void;
export type StructuredOutputUpdateControllerUpdateApiResponse =
  /** status 200  */ StructuredOutputDto;
export type StructuredOutputUpdateControllerUpdateApiArg = {
  id: string;
  structuredOutputUpdateRequestDto: StructuredOutputUpdateRequestDto;
};
export type StructuredOutputDeleteControllerDeleteApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type StructuredOutputDeleteControllerDeleteApiArg = {
  id: string;
};
export type StructuredOutputControllerGetApiResponse = /** status 200  */ StructuredOutputDto;
export type StructuredOutputControllerGetApiArg = {
  id: string;
};
export type StructuredOutputTemplateListControllerListApiResponse =
  /** status 200  */ StructuredOutputDto[];
export type StructuredOutputTemplateListControllerListApiArg = void;
export type StructuredOutputTemplateControllerGetApiResponse =
  /** status 200  */ StructuredOutputDto;
export type StructuredOutputTemplateControllerGetApiArg = {
  id: string;
};
export type CampaignStructuredOutputAttachControllerAttachApiResponse =
  /** status 201  */ StructuredOutputDto[];
export type CampaignStructuredOutputAttachControllerAttachApiArg = {
  id: string;
  campaignStructuredOutputAttachRequestDto: CampaignStructuredOutputAttachRequestDto;
};
export type CampaignStructuredOutputListControllerListApiResponse =
  /** status 200  */ StructuredOutputDto[];
export type CampaignStructuredOutputListControllerListApiArg = {
  id: string;
};
export type CampaignStructuredOutputDetachControllerDetachApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type CampaignStructuredOutputDetachControllerDetachApiArg = {
  id: string;
  outputId: string;
};
export type ToolCreateControllerCreateCampaignToolApiResponse = /** status 201  */ ToolDto;
export type ToolCreateControllerCreateCampaignToolApiArg = {
  id: string;
  toolRequestDto: ToolRequestDto;
};
export type ToolListControllerCampaignToolListApiResponse = /** status 200  */ ToolDto[];
export type ToolListControllerCampaignToolListApiArg = {
  id: string;
};
export type ToolCreateControllerCreateAgentToolApiResponse = /** status 201  */ ToolDto;
export type ToolCreateControllerCreateAgentToolApiArg = {
  id: string;
  toolRequestDto: ToolRequestDto;
};
export type ToolListControllerAgentTollListApiResponse = /** status 200  */ ToolDto[];
export type ToolListControllerAgentTollListApiArg = {
  id: string;
};
export type ToolUpdateControllerCreateCampaignToolApiResponse = /** status 200  */ ToolDto;
export type ToolUpdateControllerCreateCampaignToolApiArg = {
  id: string;
  toolId: string;
  toolUpdateRequestDto: ToolUpdateRequestDto;
};
export type ToolDeleteControllerCreateCampaignToolApiResponse =
  /** status 200  */ BaseOkResponseDto;
export type ToolDeleteControllerCreateCampaignToolApiArg = {
  id: string;
  toolId: string;
};
export type ToolUpdateControllerCreateAgentToolApiResponse = /** status 200  */ ToolDto;
export type ToolUpdateControllerCreateAgentToolApiArg = {
  id: string;
  toolId: string;
  toolUpdateRequestDto: ToolUpdateRequestDto;
};
export type ToolDeleteControllerCreateAgentToolApiResponse = /** status 200  */ BaseOkResponseDto;
export type ToolDeleteControllerCreateAgentToolApiArg = {
  id: string;
  toolId: string;
};
export type LlmProviderListControllerProviderListApiResponse = /** status 200  */ LlmProviderDto[];
export type LlmProviderListControllerProviderListApiArg = void;
export type LlmProviderListControllerAdminProviderListApiResponse =
  /** status 200  */ LlmProviderDto[];
export type LlmProviderListControllerAdminProviderListApiArg = void;
export type LlmModelListControllerModelListApiResponse = /** status 200  */ LlmModelDto[];
export type LlmModelListControllerModelListApiArg = {
  id: string;
};
export type LlmModelListControllerAdminModelListApiResponse = /** status 200  */ LlmModelDto[];
export type LlmModelListControllerAdminModelListApiArg = {
  id: string;
};
export type CampaignWebhookCreateControllerCreateApiResponse =
  /** status 201  */ CampaignWebhookResponseDto;
export type CampaignWebhookCreateControllerCreateApiArg = {
  campaignId: string;
  campaignWebhookCreateRequestDto: CampaignWebhookCreateRequestDto;
};
export type CampaignWebhooksControllerListApiResponse =
  /** status 200  */ CampaignWebhookResponseDto[];
export type CampaignWebhooksControllerListApiArg = {
  campaignId: string;
};
export type CampaignWebhookUpdateControllerUpdateApiResponse =
  /** status 200  */ CampaignWebhookResponseDto;
export type CampaignWebhookUpdateControllerUpdateApiArg = {
  campaignId: string;
  webhookId: string;
  campaignWebhookUpdateRequestDto: CampaignWebhookUpdateRequestDto;
};
export type CampaignWebhookDeleteControllerDeleteApiResponse = /** status 200  */ BaseOkResponseDto;
export type CampaignWebhookDeleteControllerDeleteApiArg = {
  campaignId: string;
  webhookId: string;
};
export type CampaignWebhookDispatchControllerManualDispatchApiResponse = /** status 201  */ object;
export type CampaignWebhookDispatchControllerManualDispatchApiArg = {
  campaignId: string;
  callId: string;
};
export type CampaignWebhookDispatchControllerSystemDispatchApiResponse = /** status 201  */ object;
export type CampaignWebhookDispatchControllerSystemDispatchApiArg = {
  campaignId: string;
  callId: string;
};
export type WebhookDeliverySweepControllerSystemDeliverySweepApiResponse =
  /** status 201  */ object;
export type WebhookDeliverySweepControllerSystemDeliverySweepApiArg = void;
export type HealthControllerCheckApiResponse = /** status 200 The Health Check is successful */ {
  status?: string;
  info?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  } | null;
  error?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  } | null;
  details?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  };
};
export type HealthControllerCheckApiArg = void;
export type UsageMonitoringControllerGetUsageApiResponse = /** status 200  */ UsageResponseDto;
export type UsageMonitoringControllerGetUsageApiArg = void;
export type BillingControllerOffersApiResponse = /** status 200  */ BillingCatalogDto;
export type BillingControllerOffersApiArg = {
  companyId: string;
};
export type BillingControllerCompanyApiResponse = /** status 200  */ CompanyBillingSummaryDto;
export type BillingControllerCompanyApiArg = {
  companyId: string;
};
export type BillingControllerManagerApiResponse = /** status 200  */ CompanyBillingSummaryDto;
export type BillingControllerManagerApiArg = {
  companyId: string;
};
export type BillingControllerPublishPolicyApiResponse = /** status 201  */ BillingPolicyResultDto;
export type BillingControllerPublishPolicyApiArg = {
  publishEnrollmentPolicyDto: PublishEnrollmentPolicyDto;
};
export type BillingControllerEnrollApiResponse = /** status 201  */ BillingEnrollmentResultDto;
export type BillingControllerEnrollApiArg = {
  companyId: string;
  billingEnrollmentDto: BillingEnrollmentDto;
};
export type BillingControllerAdmissionApiResponse =
  /** status 201  */ BillingAdmissionControlResultDto;
export type BillingControllerAdmissionApiArg = {
  companyId: string;
  billingAdmissionControlDto: BillingAdmissionControlDto;
};
export type BillingControllerAdjustApiResponse = /** status 201  */ BillingAdjustmentResultDto;
export type BillingControllerAdjustApiArg = {
  companyId: string;
  billingAdjustmentDto: BillingAdjustmentDto;
};
export type StripeBillingControllerStartCheckoutApiResponse =
  /** status 201  */ StripeCheckoutResultDto;
export type StripeBillingControllerStartCheckoutApiArg = {
  companyId: string;
  stripeCheckoutRequestDto: StripeCheckoutRequestDto;
};
export type StripePortalControllerOpenApiResponse = /** status 201  */ StripePortalResultDto;
export type StripePortalControllerOpenApiArg = {
  companyId: string;
};
export type StripeSynchronizationControllerReadApiResponse =
  /** status 200  */ StripeSynchronizationDto;
export type StripeSynchronizationControllerReadApiArg = {
  companyId: string;
};
export type StripeSynchronizationControllerRequestApiResponse =
  /** status 202  */ StripeSynchronizationDto;
export type StripeSynchronizationControllerRequestApiArg = {
  companyId: string;
};
export type StripeSynchronizationControllerRequestManagerApiResponse =
  /** status 202  */ StripeSynchronizationDto;
export type StripeSynchronizationControllerRequestManagerApiArg = {
  companyId: string;
};
export type StripeUpgradeControllerApplyApiResponse = /** status 201  */ StripeUpgradeOutcomeDto;
export type StripeUpgradeControllerApplyApiArg = {
  companyId: string;
  stripeUpgradeApplyRequestDto: StripeUpgradeApplyRequestDto;
};
export type StripeUpgradeControllerPreviewApiResponse = /** status 201  */ StripeUpgradePreviewDto;
export type StripeUpgradeControllerPreviewApiArg = {
  companyId: string;
  stripeUpgradePreviewRequestDto: StripeUpgradePreviewRequestDto;
};
export type StripeUpgradeControllerPaymentApiResponse = /** status 200  */ StripeUpgradePaymentDto;
export type StripeUpgradeControllerPaymentApiArg = {
  companyId: string;
  intentId: string;
};
export type StripeScheduledChangeControllerRequestApiResponse =
  /** status 201  */ StripeScheduledChangeOutcomeDto;
export type StripeScheduledChangeControllerRequestApiArg = {
  companyId: string;
  stripeScheduledChangeRequestDto: StripeScheduledChangeRequestDto;
};
export type BillingControllerOptionsApiResponse = /** status 200  */ BillingEnrollmentOptionsDto;
export type BillingControllerOptionsApiArg = void;
export type BillingControllerPaymentExceptionsApiResponse =
  /** status 200  */ BillingPaymentExceptionsDto;
export type BillingControllerPaymentExceptionsApiArg = {
  companyId: string;
};
export type BillingControllerResolvePaymentExceptionApiResponse =
  /** status 201  */ BillingPaymentExceptionResolutionDto;
export type BillingControllerResolvePaymentExceptionApiArg = {
  companyId: string;
  exceptionId: string;
  resolveBillingPaymentExceptionDto: ResolveBillingPaymentExceptionDto;
};
export type WorkspaceControllerListApiResponse = /** status 200  */ WorkspaceMissionDto[];
export type WorkspaceControllerListApiArg = {
  after?: string;
};
export type WorkspaceControllerCreateApiResponse = /** status 201  */ WorkspaceMissionDto;
export type WorkspaceControllerCreateApiArg = {
  workspaceCreateMissionDto: WorkspaceCreateMissionDto;
};
export type WorkspaceControllerDetailApiResponse = /** status 200  */ WorkspaceMissionDetailDto;
export type WorkspaceControllerDetailApiArg = {
  id: string;
};
export type WorkspaceControllerSaveApiResponse = /** status 200  */ WorkspaceMissionDto;
export type WorkspaceControllerSaveApiArg = {
  id: string;
  workspaceSaveMissionDto: WorkspaceSaveMissionDto;
};
export type WorkspaceControllerRemoveApiResponse = unknown;
export type WorkspaceControllerRemoveApiArg = {
  id: string;
  workspaceRevisionDto: WorkspaceRevisionDto;
};
export type WorkspaceControllerPublishApiResponse = /** status 201  */ WorkspaceMissionDto;
export type WorkspaceControllerPublishApiArg = {
  id: string;
  workspaceRevisionDto: WorkspaceRevisionDto;
};
export type WorkspaceControllerPauseApiResponse = /** status 201  */ WorkspaceMissionDto;
export type WorkspaceControllerPauseApiArg = {
  id: string;
  workspacePauseDto: WorkspacePauseDto;
};
export type WorkspaceControllerRunApiResponse = /** status 201  */ WorkspaceOperationDto;
export type WorkspaceControllerRunApiArg = {
  id: string;
  workspaceRunDto: WorkspaceRunDto;
};
export type WorkspaceControllerRunsApiResponse = /** status 200  */ WorkspaceOperationDto[];
export type WorkspaceControllerRunsApiArg = {
  missionId?: string;
  before?: string;
};
export type WorkspaceControllerConfirmApiResponse = /** status 201  */ WorkspaceOperationDto;
export type WorkspaceControllerConfirmApiArg = {
  id: string;
};
export type WorkspaceControllerCancelApiResponse = /** status 201  */ WorkspaceOperationDto;
export type WorkspaceControllerCancelApiArg = {
  id: string;
};
export type WorkspaceControllerModelsApiResponse = /** status 200  */ WorkspaceProviderDto[];
export type WorkspaceControllerModelsApiArg = void;
export type WorkspaceControllerAskApiResponse = /** status 201  */ WorkspaceAskResponseDto;
export type WorkspaceControllerAskApiArg = {
  workspaceAskDto: WorkspaceAskDto;
};
export type WorkspaceControllerCheckConfigurationApiResponse =
  /** status 200  */ WorkspaceConfigurationCheckDto;
export type WorkspaceControllerCheckConfigurationApiArg = {
  workspaceCheckConfigurationDto: WorkspaceCheckConfigurationDto;
};
export type WorkspaceControllerJobsUsageApiResponse = /** status 200  */ WorkspaceJobUsageDto[];
export type WorkspaceControllerJobsUsageApiArg = void;
export type WorkspaceControllerJobUsageDetailApiResponse =
  /** status 200  */ WorkspaceJobUsagePageDto;
export type WorkspaceControllerJobUsageDetailApiArg = {
  id: string;
  after?: string;
};
export type WorkspaceStudioControllerDetailApiResponse = /** status 200  */ StudioDetailDto;
export type WorkspaceStudioControllerDetailApiArg = {
  campaignId: string;
  agentId: string;
};
export type WorkspaceStudioControllerInitializeApiResponse = /** status 201  */ StudioDetailDto;
export type WorkspaceStudioControllerInitializeApiArg = {
  campaignId: string;
  agentId: string;
  body: object;
};
export type WorkspaceStudioControllerVersionsApiResponse = /** status 200  */ StudioVersionsDto;
export type WorkspaceStudioControllerVersionsApiArg = {
  campaignId: string;
  agentId: string;
  before?: string;
};
export type WorkspaceStudioControllerBranchApiResponse = /** status 201  */ StudioDetailDto;
export type WorkspaceStudioControllerBranchApiArg = {
  campaignId: string;
  agentId: string;
  studioCreateBranchDto: StudioCreateBranchDto;
};
export type WorkspaceStudioControllerSaveApiResponse = /** status 200  */ StudioDetailDto;
export type WorkspaceStudioControllerSaveApiArg = {
  campaignId: string;
  agentId: string;
  branchId: string;
  studioSaveDto: StudioSaveDto;
};
export type WorkspaceStudioControllerRemoveApiResponse = /** status 200  */ StudioDetailDto;
export type WorkspaceStudioControllerRemoveApiArg = {
  campaignId: string;
  agentId: string;
  branchId: string;
  studioRevisionDto: StudioRevisionDto;
};
export type WorkspaceStudioControllerSyncApiResponse = /** status 201  */ StudioDetailDto;
export type WorkspaceStudioControllerSyncApiArg = {
  campaignId: string;
  agentId: string;
  branchId: string;
  studioRevisionDto: StudioRevisionDto;
};
export type WorkspaceStudioControllerRestoreApiResponse = /** status 201  */ StudioDetailDto;
export type WorkspaceStudioControllerRestoreApiArg = {
  campaignId: string;
  agentId: string;
  branchId: string;
  studioRestoreDto: StudioRestoreDto;
};
export type WorkspaceStudioControllerPublishApiResponse = /** status 201  */ StudioPublishResultDto;
export type WorkspaceStudioControllerPublishApiArg = {
  campaignId: string;
  agentId: string;
  branchId: string;
  studioPublishDto: StudioPublishDto;
};
export type WorkspaceControllerRecordConfigurationCheckApiResponse =
  /** status 201  */ WorkspaceConfigurationCheckRecordDto;
export type WorkspaceControllerRecordConfigurationCheckApiArg = {
  id: string;
  workspaceRecordConfigurationCheckDto: WorkspaceRecordConfigurationCheckDto;
};
export type WorkspaceControllerConfigurationChecksApiResponse =
  /** status 200  */ WorkspaceConfigurationChecksDto;
export type WorkspaceControllerConfigurationChecksApiArg = {
  id: string;
  before?: string;
};
export type WorkspaceControllerPreviewEventApiResponse =
  /** status 200  */ WorkspaceEventPreviewDto;
export type WorkspaceControllerPreviewEventApiArg = {
  workspacePreviewEventDto: WorkspacePreviewEventDto;
};
export type PrivateRuntimeConfigControllerPublishApiResponse = /** status 200  */ {
  schemaVersion: 1;
  id: string;
  callId: string;
  roomName: string;
  executionAttemptId: string;
  /** SHA-256 of exact payloadJson UTF-8 bytes; authenticated only, never public room metadata. */
  digest: string;
  payloadBytes: number;
  createdAt: string;
  /** Exactly 300 seconds after original creation; retries never extend. */
  expiresAt: string;
};
export type PrivateRuntimeConfigControllerPublishApiArg = {
  callId: string;
  body: {
    schemaVersion: 1;
    roomName: string;
    executionAttemptId: string;
    /** Exact valid UTF-8 JSON string, at most 262144 UTF-8 bytes. Must contain native type and context.callId/companyId. No reserialization permitted. */
    payloadJson: string;
  };
};
export type PrivateRuntimeConfigControllerResolveApiResponse = /** status 200  */ {
  schemaVersion: 1;
  id: string;
  callId: string;
  roomName: string;
  executionAttemptId: string;
  /** SHA-256 of exact payloadJson UTF-8 bytes; authenticated only, never public room metadata. */
  digest: string;
  payloadBytes: number;
  createdAt: string;
  /** Exactly 300 seconds after original creation; retries never extend. */
  expiresAt: string;
  payloadJson: string;
};
export type PrivateRuntimeConfigControllerResolveApiArg = {
  callId: string;
  id: string;
  'x-callevate-runtime-consumer': string;
  executionAttemptId: string;
};
export type WidgetControllerGetApiResponse = /** status 200  */ {
  widget: {
    id: string;
    campaignId: string;
    agentId: string;
    revision: number;
    configuration: {
      enabled: boolean;
      allowedOrigins: string[];
      budget: {
        /** Positive exact decimal in native credit precision; no commercial default. */
        creditsPerSession: string;
        /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
        creditsPerDay: string;
        maxConcurrentSessions: number;
        /** Hard duration of this anonymous session; separate from Mission drain budgets. */
        maxSessionSeconds: number;
      };
      appearance: {
        mode: 'chat' | 'voice';
        size: 'full' | 'compact' | 'tiny';
        placement: 'bottom-right' | 'bottom-left';
        colors: {
          background?: string;
          accent?: string;
          messageBackground?: string;
          accentText?: string;
          text?: string;
          secondaryText?: string;
        };
        title: string;
        cta: string;
        start: string;
        end: string;
        placeholder: string;
        /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
        avatar: string | null;
        termsEnabled: boolean;
        termsUrl: string | null;
      };
    };
    published: {
      versionId: string;
      configuration: {
        enabled: boolean;
        allowedOrigins: string[];
        budget: {
          /** Positive exact decimal in native credit precision; no commercial default. */
          creditsPerSession: string;
          /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
          creditsPerDay: string;
          maxConcurrentSessions: number;
          /** Hard duration of this anonymous session; separate from Mission drain budgets. */
          maxSessionSeconds: number;
        };
        appearance: {
          mode: 'chat' | 'voice';
          size: 'full' | 'compact' | 'tiny';
          placement: 'bottom-right' | 'bottom-left';
          colors: {
            background?: string;
            accent?: string;
            messageBackground?: string;
            accentText?: string;
            text?: string;
            secondaryText?: string;
          };
          title: string;
          cta: string;
          start: string;
          end: string;
          placeholder: string;
          /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
          avatar: string | null;
          termsEnabled: boolean;
          termsUrl: string | null;
        };
      };
      publishedAt: string;
    } | null;
    available: boolean;
  } | null;
};
export type WidgetControllerGetApiArg = {
  campaignId: string;
  agentId: string;
};
export type WidgetControllerSaveApiResponse = /** status 200  */ {
  id: string;
  campaignId: string;
  agentId: string;
  revision: number;
  configuration: {
    enabled: boolean;
    allowedOrigins: string[];
    budget: {
      /** Positive exact decimal in native credit precision; no commercial default. */
      creditsPerSession: string;
      /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
      creditsPerDay: string;
      maxConcurrentSessions: number;
      /** Hard duration of this anonymous session; separate from Mission drain budgets. */
      maxSessionSeconds: number;
    };
    appearance: {
      mode: 'chat' | 'voice';
      size: 'full' | 'compact' | 'tiny';
      placement: 'bottom-right' | 'bottom-left';
      colors: {
        background?: string;
        accent?: string;
        messageBackground?: string;
        accentText?: string;
        text?: string;
        secondaryText?: string;
      };
      title: string;
      cta: string;
      start: string;
      end: string;
      placeholder: string;
      /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
      avatar: string | null;
      termsEnabled: boolean;
      termsUrl: string | null;
    };
  };
  published: {
    versionId: string;
    configuration: {
      enabled: boolean;
      allowedOrigins: string[];
      budget: {
        /** Positive exact decimal in native credit precision; no commercial default. */
        creditsPerSession: string;
        /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
        creditsPerDay: string;
        maxConcurrentSessions: number;
        /** Hard duration of this anonymous session; separate from Mission drain budgets. */
        maxSessionSeconds: number;
      };
      appearance: {
        mode: 'chat' | 'voice';
        size: 'full' | 'compact' | 'tiny';
        placement: 'bottom-right' | 'bottom-left';
        colors: {
          background?: string;
          accent?: string;
          messageBackground?: string;
          accentText?: string;
          text?: string;
          secondaryText?: string;
        };
        title: string;
        cta: string;
        start: string;
        end: string;
        placeholder: string;
        /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
        avatar: string | null;
        termsEnabled: boolean;
        termsUrl: string | null;
      };
    };
    publishedAt: string;
  } | null;
  available: boolean;
};
export type WidgetControllerSaveApiArg = {
  campaignId: string;
  agentId: string;
  body: {
    revision: number | null;
    configuration: {
      enabled: boolean;
      allowedOrigins: string[];
      budget: {
        /** Positive exact decimal in native credit precision; no commercial default. */
        creditsPerSession: string;
        /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
        creditsPerDay: string;
        maxConcurrentSessions: number;
        /** Hard duration of this anonymous session; separate from Mission drain budgets. */
        maxSessionSeconds: number;
      };
      appearance: {
        mode: 'chat' | 'voice';
        size: 'full' | 'compact' | 'tiny';
        placement: 'bottom-right' | 'bottom-left';
        colors: {
          background?: string;
          accent?: string;
          messageBackground?: string;
          accentText?: string;
          text?: string;
          secondaryText?: string;
        };
        title: string;
        cta: string;
        start: string;
        end: string;
        placeholder: string;
        /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
        avatar: string | null;
        termsEnabled: boolean;
        termsUrl: string | null;
      };
    };
  };
};
export type WidgetControllerPublishApiResponse = /** status 200  */ {
  id: string;
  campaignId: string;
  agentId: string;
  revision: number;
  configuration: {
    enabled: boolean;
    allowedOrigins: string[];
    budget: {
      /** Positive exact decimal in native credit precision; no commercial default. */
      creditsPerSession: string;
      /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
      creditsPerDay: string;
      maxConcurrentSessions: number;
      /** Hard duration of this anonymous session; separate from Mission drain budgets. */
      maxSessionSeconds: number;
    };
    appearance: {
      mode: 'chat' | 'voice';
      size: 'full' | 'compact' | 'tiny';
      placement: 'bottom-right' | 'bottom-left';
      colors: {
        background?: string;
        accent?: string;
        messageBackground?: string;
        accentText?: string;
        text?: string;
        secondaryText?: string;
      };
      title: string;
      cta: string;
      start: string;
      end: string;
      placeholder: string;
      /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
      avatar: string | null;
      termsEnabled: boolean;
      termsUrl: string | null;
    };
  };
  published: {
    versionId: string;
    configuration: {
      enabled: boolean;
      allowedOrigins: string[];
      budget: {
        /** Positive exact decimal in native credit precision; no commercial default. */
        creditsPerSession: string;
        /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
        creditsPerDay: string;
        maxConcurrentSessions: number;
        /** Hard duration of this anonymous session; separate from Mission drain budgets. */
        maxSessionSeconds: number;
      };
      appearance: {
        mode: 'chat' | 'voice';
        size: 'full' | 'compact' | 'tiny';
        placement: 'bottom-right' | 'bottom-left';
        colors: {
          background?: string;
          accent?: string;
          messageBackground?: string;
          accentText?: string;
          text?: string;
          secondaryText?: string;
        };
        title: string;
        cta: string;
        start: string;
        end: string;
        placeholder: string;
        /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
        avatar: string | null;
        termsEnabled: boolean;
        termsUrl: string | null;
      };
    };
    publishedAt: string;
  } | null;
  available: boolean;
};
export type WidgetControllerPublishApiArg = {
  id: string;
  body: {
    revision: number;
  };
};
export type WidgetControllerDisableApiResponse = /** status 200  */ {
  id: string;
  campaignId: string;
  agentId: string;
  revision: number;
  configuration: {
    enabled: boolean;
    allowedOrigins: string[];
    budget: {
      /** Positive exact decimal in native credit precision; no commercial default. */
      creditsPerSession: string;
      /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
      creditsPerDay: string;
      maxConcurrentSessions: number;
      /** Hard duration of this anonymous session; separate from Mission drain budgets. */
      maxSessionSeconds: number;
    };
    appearance: {
      mode: 'chat' | 'voice';
      size: 'full' | 'compact' | 'tiny';
      placement: 'bottom-right' | 'bottom-left';
      colors: {
        background?: string;
        accent?: string;
        messageBackground?: string;
        accentText?: string;
        text?: string;
        secondaryText?: string;
      };
      title: string;
      cta: string;
      start: string;
      end: string;
      placeholder: string;
      /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
      avatar: string | null;
      termsEnabled: boolean;
      termsUrl: string | null;
    };
  };
  published: {
    versionId: string;
    configuration: {
      enabled: boolean;
      allowedOrigins: string[];
      budget: {
        /** Positive exact decimal in native credit precision; no commercial default. */
        creditsPerSession: string;
        /** First session freezes the UTC-day ceiling; publication cannot replenish it. Changes apply next UTC day. */
        creditsPerDay: string;
        maxConcurrentSessions: number;
        /** Hard duration of this anonymous session; separate from Mission drain budgets. */
        maxSessionSeconds: number;
      };
      appearance: {
        mode: 'chat' | 'voice';
        size: 'full' | 'compact' | 'tiny';
        placement: 'bottom-right' | 'bottom-left';
        colors: {
          background?: string;
          accent?: string;
          messageBackground?: string;
          accentText?: string;
          text?: string;
          secondaryText?: string;
        };
        title: string;
        cta: string;
        start: string;
        end: string;
        placeholder: string;
        /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
        avatar: string | null;
        termsEnabled: boolean;
        termsUrl: string | null;
      };
    };
    publishedAt: string;
  } | null;
  available: boolean;
};
export type WidgetControllerDisableApiArg = {
  id: string;
  body: {
    revision: number;
  };
};
export type PublicWidgetControllerConfigApiResponse = /** status 200  */ {
  id: string;
  available: boolean;
  appearance: {
    mode: 'chat' | 'voice';
    size: 'full' | 'compact' | 'tiny';
    placement: 'bottom-right' | 'bottom-left';
    colors: {
      background?: string;
      accent?: string;
      messageBackground?: string;
      accentText?: string;
      text?: string;
      secondaryText?: string;
    };
    title: string;
    cta: string;
    start: string;
    end: string;
    placeholder: string;
    /** HTTPS image or bounded PNG/JPEG/WebP data URL. */
    avatar: string | null;
    termsEnabled: boolean;
    termsUrl: string | null;
  } | null;
  versionId: string | null;
  websocketUrl: string | null;
};
export type PublicWidgetControllerConfigApiArg = {
  id: string;
};
export type PublicWidgetControllerSessionApiResponse = /** status 200  */ {
  sessionId: string;
  token: string;
  expiresAt: string;
  websocketUrl: string;
};
export type PublicWidgetControllerSessionApiArg = {
  id: string;
  body: {
    requestId: string;
    versionId: string;
    mode: 'chat' | 'voice';
    termsAccepted: boolean;
  };
};
export type WorkspaceControllerAcknowledgeReviewApiResponse =
  /** status 200  */ WorkspaceRuntimeBudgetUsageDto;
export type WorkspaceControllerAcknowledgeReviewApiArg = {
  id: string;
  workspaceRunDto: WorkspaceRunDto;
};
export type ConversationFinalizationControllerPublishApiResponse = /** status 200  */ {
  schemaVersion: 1;
  callId: string;
  executionAttemptId: string;
  acceptedAt: string;
  itemCount: number;
};
export type ConversationFinalizationControllerPublishApiArg = {
  id: string;
  body: {
    schemaVersion: 1;
    executionAttemptId: string;
    /** Exact UTF8 JSON array of customer/assistant role+text items. Maximum 262144 UTF8 bytes, 2000 items, 16384 UTF16 characters per item. No tools/provider configuration. */
    transcriptJson: string;
  };
};
export type PreCallContextControllerLookupApiResponse = /** status 200  */
  | {
      status: 'disabled' | 'unavailable';
    }
  | {
      status: 'available';
      /** Untrusted data-only reference context; maximum16384UTF8bytes. */
      context: string;
    };
export type PreCallContextControllerLookupApiArg = {
  id: string;
  'x-callevate-runtime-consumer': string;
  body: {
    executionAttemptId: string;
    runtimeConfigId: string;
  };
};
export type StripeTopUpControllerCatalogApiResponse = /** status 200  */ BillingTopUpsDto;
export type StripeTopUpControllerCatalogApiArg = {
  companyId: string;
  from?: string;
  to?: string;
  after?: string;
};
export type StripeTopUpControllerCheckoutApiResponse = /** status 201  */ StripeTopUpResultDto;
export type StripeTopUpControllerCheckoutApiArg = {
  companyId: string;
  stripeTopUpRequestDto: StripeTopUpRequestDto;
};
export type StripeAutoTopUpControllerReadApiResponse = /** status 200  */ AutoTopUpSettingsDto;
export type StripeAutoTopUpControllerReadApiArg = {
  companyId: string;
};
export type StripeAutoTopUpControllerSetupApiResponse = /** status 201  */ AutoTopUpSetupResultDto;
export type StripeAutoTopUpControllerSetupApiArg = {
  companyId: string;
  autoTopUpSetupDto: AutoTopUpSetupDto;
};
export type StripeAutoTopUpControllerEnableApiResponse = /** status 201  */ AutoTopUpSettingsDto;
export type StripeAutoTopUpControllerEnableApiArg = {
  companyId: string;
  autoTopUpConfirmDto: AutoTopUpConfirmDto;
};
export type StripeAutoTopUpControllerDisableApiResponse = /** status 201  */ AutoTopUpSettingsDto;
export type StripeAutoTopUpControllerDisableApiArg = {
  companyId: string;
  autoTopUpRequestDto: AutoTopUpRequestDto;
};
export type StripeAutoTopUpControllerPaymentApiResponse = /** status 201  */ AutoTopUpPaymentDto;
export type StripeAutoTopUpControllerPaymentApiArg = {
  companyId: string;
  purchaseId: string;
};
export type StripeAutoTopUpControllerCancelApiResponse = /** status 201  */ AutoTopUpPaymentDto;
export type StripeAutoTopUpControllerCancelApiArg = {
  companyId: string;
  purchaseId: string;
  autoTopUpRequestDto: AutoTopUpRequestDto;
};
export type StripeBillingHistoryControllerReadApiResponse = /** status 200  */ BillingHistoryDto;
export type StripeBillingHistoryControllerReadApiArg = {
  companyId: string;
  from?: string;
  to?: string;
  after?: string;
};
export type BillingUsageControllerReadApiResponse = /** status 200  */ BillingUsageDto;
export type BillingUsageControllerReadApiArg = {
  companyId: string;
  campaignId?: string;
  agentId?: string;
  /** Inclusive UTC date/time, at most 366 days before to */
  from?: string;
  /** Exclusive UTC date/time */
  to?: string;
};
export type StripeBillingHistoryControllerDocumentApiResponse =
  /** status 200  */ BillingPurchaseDocumentDto;
export type StripeBillingHistoryControllerDocumentApiArg = {
  companyId: string;
  purchaseId: string;
};
export type StripeAutoTopUpControllerUpdateApiResponse = /** status 201  */ AutoTopUpSettingsDto;
export type StripeAutoTopUpControllerUpdateApiArg = {
  companyId: string;
  autoTopUpUpdateDto: AutoTopUpUpdateDto;
};
export type BillingInsightsControllerReadApiResponse = /** status 200  */ BillingInsightsDto;
export type BillingInsightsControllerReadApiArg = {
  companyId: string;
};
export type BillingUsageControllerCallsApiResponse = /** status 200  */ BillingUsageCallsDto;
export type BillingUsageControllerCallsApiArg = {
  companyId: string;
  campaignId?: string;
  agentId?: string;
  /** Inclusive UTC date/time, at most 366 days before to */
  from?: string;
  /** Exclusive UTC date/time */
  to?: string;
  after?: string;
};
export type AccessTokenResponseDto = {
  accessToken: string;
};
export type SignInRequestDto = {
  login: string;
  password: string;
};
export type ApiKeyDto = {
  jti: string;
  subType: 'user' | 'refresh' | 'external';
  subId: string;
  issuedAt: string;
  expiresAt: string;
  isRevoked: boolean;
};
export type ForgotPasswordResponseDto = {
  message: string;
};
export type ForgotPasswordRequestDto = {
  email: string;
};
export type ResetPasswordResponseDto = {
  message: string;
};
export type ResetPasswordRequestDto = {
  token: string;
  password: string;
};
export type UserRoles = 'admin' | 'viewer';
export type Privilege =
  | 'call.recording.read'
  | 'call.test'
  | 'call.supervise'
  | 'call.hangup'
  | 'customer.read'
  | 'customer.manage'
  | 'campaign.manage'
  | 'campaign.run'
  | 'agent.manage'
  | 'sip-trunk.manage'
  | 'knowledge-base.read'
  | 'knowledge-base.manage'
  | 'structured-output.manage'
  | 'webhook.manage'
  | 'webhook.dispatch'
  | 'post-call-message.manage'
  | 'group.manage'
  | 'user.manage'
  | 'billing.manage';
export type MembershipSource = 'manual' | 'directory';
export type UserPermissionGroupDto = {
  id: string;
  name: string;
  builtIn: ('admin' | 'viewer') | null;
  privileges: Privilege[];
  source: MembershipSource;
};
export type UserMeResponseDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRoles;
  privileges: Privilege[];
  groups: UserPermissionGroupDto[];
  createdAt: string;
  updatedAt: string;
  companyId: string;
};
export type UserListItemResponseDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRoles;
  groups: UserPermissionGroupDto[];
  createdAt: string;
  updatedAt: string;
};
export type UserDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRoles;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  companyId: string;
};
export type UserCreateRequestDto = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: UserRoles;
  companyId: string;
  permissionGroupIds?: string[];
};
export type UserUpdateRequestDto = {
  firstName?: string;
  lastName?: string;
  role?: UserRoles;
  password?: string;
};
export type AdminRoles = 'manager';
export type AdminDto = {
  id: string;
  email: string;
  role: AdminRoles;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};
export type PermissionGroupDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  builtIn: ('admin' | 'viewer') | null;
  privileges: Privilege[];
  directoryGroups: string[];
};
export type PermissionGroupCreateRequestDto = {
  name: string;
  privileges: Privilege[];
};
export type PermissionGroupUpdateRequestDto = {
  name?: string;
  privileges?: Privilege[];
};
export type BaseOkResponseDto = {
  ok: boolean;
};
export type Analysis = {
  id: string;
  createdAt: string;
  updatedAt: string;
  summary: {
    [key: string]: any;
  } | null;
  detailedSummary: {
    [key: string]: any;
  } | null;
  status: 'queued' | 'failed' | 'completed';
  callId: string;
};
export type CallAnalysisCreateRequestDto = {
  /** PII-enabled completed callbacks only: original operational summary, encrypted separately and never returned in normal projections. Maximum262144 UTF8 bytes. */
  operationalSummary?: string;
  /** Final callback status from the analysis service. */
  status?: 'completed' | 'failed';
  /** Analysis summary payload as stringified JSON or plain text. */
  summary?: string;
};
export type SentimentType = 'positive' | 'negative' | 'neutral';
export type SentimentScoreDto = {
  label: SentimentType;
  score: number;
};
export type SentimentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  callId: string;
  sentimentScores: SentimentScoreDto[];
};
export type SentimentScoreRequestDto = {
  label: SentimentType;
  score: number;
};
export type SentimentRequestDto = {
  id?: string;
  sentimentScores: SentimentScoreRequestDto[];
  createdAt: string;
};
export type CallType = 'web-call' | 'websocket-call' | 'outbound-phone-call' | 'inbound-phone-call';
export type CallStatus =
  | 'pending'
  | 'scheduled'
  | 'ended'
  | 'queued'
  | 'initializing'
  | 'ringing'
  | 'in-progress';
export type CallEndedReason =
  | 'agent-detected-end-call-phrase'
  | 'agent-join-timed-out'
  | 'customer-busy'
  | 'customer-unavailable'
  | 'customer-ended-call'
  | 'manually-canceled'
  | 'internal-error'
  | 'unknown-reason'
  | 'error-sip-telephony-provider-failed-to-connect-call'
  | 'error-sip-provider-declined'
  | 'usage-limits-exceeded'
  | 'concurrent-limit-reached'
  | 'agent-forwarded-call'
  | 'transfer-failed'
  | 'participant-removed'
  | 'customer-did-not-join'
  | 'worker-crashed'
  | 'stale-timeout';
export type CustomerDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  number?: string;
  name?: string | null;
  gender?: string | null;
  attributes?: object;
  metadata?: object;
  campaignId?: string;
};
export type LlmProviderDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  key: string;
  title: string;
  baseUrl?: string | null;
  apiKey?: string | null;
  /** Whether this provider allows user-defined/custom models */
  allowsCustomModels: boolean;
};
export type LlmModelDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  key: string;
  title: string;
};
export type ElevenLabsSettingsDto = {
  similarityBoost?: number;
  stability?: number;
  useSpeakerBoost?: boolean;
  style?: number;
  /** LiveKit streaming-latency option: 0 disables, 4 is maximum. Runtime default: 2. */
  streamingLatency?: number;
};
export type HamsaSettingsDto = {
  /** Required on write: Agency passes it explicitly, so a missing value is not defaulted. */
  speaker?: string;
  /** Dialect compatible with the selected speaker. Required on write: Agency passes it explicitly. */
  dialect?: string;
  /** Requests mu-law output. Runtime default: false. */
  mulaw?: boolean;
  /** Runtime default: 1.0. */
  speed?: number;
  /** Runtime default: 1.0. */
  expressiveness?: number;
  /** Output sample rate in Hz. Runtime default: 16000. */
  sampleRate?: 8000 | 16000;
  /** Local dynamic-range compression after synthesis. Runtime default: true. */
  normalizeAudio?: boolean;
};
export type DeepgramSettingsDto = {
  /** Appended to voiceId as model:preset on the non-Flux path only. */
  instructionsPreset?: string;
};
export type SonioxSettingsDto = {
  /** Output codec. Runtime default: pcm_s16le. Sample rate and bitrate depend on this format. */
  audioFormat?:
    | 'pcm_f32le'
    | 'pcm_s16le'
    | 'wav'
    | 'pcm_mulaw'
    | 'pcm_alaw'
    | 'flac'
    | 'mp3'
    | 'opus'
    | 'aac';
  /** Output sample rate in Hz. Allowed values depend on audioFormat. Runtime default: 24000. */
  sampleRate?: 8000 | 16000 | 24000 | 32000 | 44100 | 48000;
  /** Codec bitrate in bits/s for compressed formats; allowed values depend on audioFormat. */
  bitrate?: number;
};
export type Qwen3TtsSettingsDto = {
  /** Otherwise QWEN3_TTS_TASK_TYPE, then CustomVoice. */
  taskType?: 'CustomVoice' | 'VoiceDesign' | 'Base';
  /** Style/emotion instructions; voice description for VoiceDesign. Otherwise QWEN3_TTS_INSTRUCTIONS. */
  instructions?: string;
  /** Reference audio URL or data URI for Base voice cloning. Otherwise QWEN3_TTS_REF_AUDIO. */
  refAudio?: string;
  /** Reference transcript for Base voice cloning. Otherwise QWEN3_TTS_REF_TEXT. */
  refText?: string;
  /** Output format, otherwise QWEN3_TTS_RESPONSE_FORMAT, then pcm. */
  responseFormat?: 'wav' | 'mp3' | 'flac' | 'pcm' | 'opus';
};
export type OpenAittsSettingsDto = {
  /** Speech speed. Provider default: 1.0. */
  speed?: number;
  /** Per-call voice instructions, appended to OPENAI_TTS_INSTRUCTIONS. Not supported by tts-1 and tts-1-hd. */
  instructions?: string;
  /** Output audio format. */
  responseFormat?: 'mp3' | 'opus' | 'aac' | 'flac' | 'wav' | 'pcm';
};
export type VoiceDto = {
  id: string;
  /** Provider-specific voice identifier. Deepgram selects its model through this field. */
  voiceId?: string;
  /** Voice provider identifier. Can be a supported runtime provider or any custom string. */
  provider: string;
  /** Custom label for the provider when pseudonymization is required. Falls back to provider when unset. */
  providerDisplayName?: string;
  name: string;
  previewUrl?: string;
  gender?: string;
  accent?: string;
  model?: string | null;
  language?: string | null;
  /** Privileged projection only. */
  baseUrl?: string | null;
  /** Privileged projection only. */
  apiKey?: string | null;
  /** Privileged projection only. Stored flat settings JSON, including arbitrary keys and values. Provider schemas describe supported controls; values are returned without normalization or defaults. */
  voiceSettings?:
    | ElevenLabsSettingsDto
    | HamsaSettingsDto
    | DeepgramSettingsDto
    | SonioxSettingsDto
    | Qwen3TtsSettingsDto
    | OpenAittsSettingsDto
    | {
        [key: string]: any;
      };
  createdAt: string;
  updatedAt: string;
};
export type TaskFlowSchemaPropertyDto = {
  type: 'string' | 'integer' | 'number' | 'boolean';
  description?: string;
};
export type TaskFlowSchemaDto = {
  properties: {
    [key: string]: TaskFlowSchemaPropertyDto;
  };
  required?: string[];
};
export type CollectDataTaskDto = {
  id: string;
  description: string;
  instructions?: string | null;
  type: 'collect_data';
  schemaType?: 'json_schema';
  schema?: TaskFlowSchemaDto | null;
};
export type DtmfTaskDto = {
  id: string;
  description: string;
  instructions?: string | null;
  type: 'get_dtmf';
  /** Required integer number of DTMF digits */
  numDigits: number;
  /** Optional DTMF input timeout in seconds */
  dtmfInputTimeout?: number;
  /** DTMF terminator */
  dtmfStopEvent?: '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '*' | '#';
  askForConfirmation?: boolean;
};
export type SimpleTaskDto = {
  id: string;
  description: string;
  instructions?: string | null;
  type: 'get_email' | 'get_phone' | 'get_name' | 'get_dob' | 'get_address';
};
export type TaskFlowDto = {
  id: string;
  autoStart?: boolean;
  summarizeChatCtx?: boolean;
  returnExceptions?: boolean;
  tasks: (CollectDataTaskDto | DtmfTaskDto | SimpleTaskDto)[];
};
export type AgentProfileType = 'system' | 'custom' | 'customer-template';
export type AgentProfileResponseDto = {
  id: string;
  name: string;
  sector:
    | (
        | 'medical'
        | 'hospitality'
        | 'real-estate'
        | 'retail'
        | 'professional-services'
        | 'general'
        | null
      )
    | null;
  summary: string | null;
  prompt?: string;
  firstMessage?: string | null;
  taskFlow: (TaskFlowDto | (null | null)) | null;
  firstMessageInterruptionsEnabled: boolean;
  type: AgentProfileType;
};
export type TranscriberResponseDto = {
  id: string;
  kind: 'standard' | 'custom';
  /** Raw provider in private/system projections; providerDisplayName, falling back to provider, in public projections. */
  provider: string;
  /** Optional display label for the provider. */
  providerDisplayName?: string;
  language: string | null;
  model: string | null;
  baseUrl?: string | null;
  /** Private/system projection only. */
  apiKey?: string;
  /** Custom private/system projection only. */
  parameters?: {
    [key: string]: any;
  };
  createdAt: string;
  updatedAt: string;
};
export type ToolType =
  | 'end-call'
  | 'voice-mail-detection'
  | 'transfer-call'
  | 'mcp'
  | 'call-handoff-signal'
  | 'gender-detection'
  | 'request-callback'
  | 'whatsapp-message-send';
export type ToolDto = {
  id: string;
  campaignId?: string;
  agentId?: string;
  type: ToolType;
  isAsync: boolean;
  messageTemplate?: string;
  inputSchema?: object;
  avatarSettings?: object;
  phoneNumbers?: string[];
  genderSettings?: object;
  mcpName?: string;
  mcpServerConfig: object;
};
export type AgentIdleStateResponseDto = {
  enabled: boolean;
  delayMs: number;
  messages: string[];
  customerSilenceMessages: string[];
  customerEndCallMessages: string[];
  customerReplyTimeoutSec?: number | null;
  customerSilenceThresholdSec?: number | null;
  customerMaxAttempts?: number | null;
};
export type BackgroundSoundDto = {
  id?: string;
  source?: string;
};
export type AmbientSoundResponseDto = {
  sound: BackgroundSoundDto;
  volume: number;
};
export type ThinkingSoundResponseDto = {
  sound: BackgroundSoundDto;
  volume: number;
  probability: number;
};
export type AgentBackgroundSoundsResponseDto = {
  ambientSound?: AmbientSoundResponseDto;
  thinkingSounds?: ThinkingSoundResponseDto[];
};
export type SquadAgentResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  llmProviderId: string;
  llmProvider?: LlmProviderDto | null;
  llmModelId?: string | null;
  llmModel?: LlmModelDto | null;
  llmCustomModelKey?: string | null;
  voiceId: string;
  voice?: VoiceDto | null;
  profileId?: string | null;
  profile?: AgentProfileResponseDto | null;
  transcriberId: string;
  transcriber?: TranscriberResponseDto;
  languages?: string[];
  tools?: ToolDto[];
  avatarUrl?: string | null;
  metadata?: object | null;
  idleState?: AgentIdleStateResponseDto;
  backgroundSounds?: AgentBackgroundSoundsResponseDto | null;
  isDefault: boolean;
};
export type HandoffRuleMessagesResponseDto = {
  start?: string[];
  delayed?: string[];
  complete?: string[];
  failed?: string[];
};
export type ContextPropagationPlanType = 'lastNMessages' | 'all';
export type ContextPropagationPlanResponseDto = {
  type: ContextPropagationPlanType;
  maxMessages?: number;
};
export type HandoffRuleResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  squadId: string;
  name?: string | null;
  description?: string | null;
  fromAgentId: string;
  toAgentId: string;
  messages?: HandoffRuleMessagesResponseDto | null;
  contextPropagationPlan?: ContextPropagationPlanResponseDto | null;
  variableExtractionPlan?: object | null;
};
export type SquadDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  description?: string | null;
  companyId: string;
  agents: SquadAgentResponseDto[];
  handoffRules: HandoffRuleResponseDto[];
};
export type AgentRuntimePreCallDto =
  | {
      /** Enable a static read-only GET before conversation startup. */
      enabled: true;
      /** HTTP(S) URL without userinfo or fragment. No customer data or template interpolation. Required when enabled. */
      url: string;
    }
  | {
      /** Enable a static read-only GET before conversation startup. */
      enabled: false;
      /** HTTP(S) URL without userinfo or fragment. No customer data or template interpolation. Required when enabled. */
      url?: string;
    };
export type AgentRuntimeChannelSilenceDto = {
  chat?: number;
  webcall?: number;
  telephony?: number;
};
export type AgentRuntimeSessionDto = {
  /** Explicit IANA conversation timezone; does not alter campaign dialing schedules. */
  timezone?: string;
  maxDurationSeconds?: number;
  /** Silence prompts within one conversation, never redial attempts. */
  silenceRetries?: number;
  silenceSeconds?: AgentRuntimeChannelSilenceDto;
  /** Apply standard Callevate guidance: concise natural replies, one question at a time, no spoken formatting. Job and business rules remain authoritative. */
  styleGuide?: boolean;
};
export type PronunciationEntryDto = {
  word: string;
  pronunciation: string;
};
export type AgentRuntimeSpeechDto = {
  /** Phone-only prearmed voicemail screening. True requires a private outbound call with standard Deepgram/native VAD and a supported ordinary LLM; false disables legacy screening, omission preserves native behavior. Browser/chat effective configuration disables screening without changing the saved intent. */
  voicemail?: boolean;
  redactPii?: boolean;
  /** Sparse ambient choice; campaign audio override remains authoritative. None disables ambient only. */
  background?: 'none' | 'office-ambience';
  /** Clarify an accepted spoken turn with no recognized text; requires an explicit response. */
  unrecognised?: boolean;
  /** Literal clarification response; no default message is inserted. */
  response?: string;
  numberLanguage?: 'auto' | 'eng' | 'arb' | 'deu' | 'rus';
  waitForUser?: boolean;
  muteUntilGreeting?: boolean;
  /** Normalized PCM RMS input floor; zero disables the floor. */
  volume?: number;
  /** Seconds after an accepted interruption; supported VAD ownership only. */
  backoff?: number;
  speed?: number;
  formatting?: boolean;
  dictionary?: PronunciationEntryDto[];
  interruptions?: boolean;
  waitTime?: number;
  confidence?: number;
  trigger?: number;
  release?: number;
  smartTurn?: boolean;
  denoising?: boolean;
};
export type AgentRuntimeSettingsDto = {
  schemaVersion: 1;
  preCall?: AgentRuntimePreCallDto;
  session?: AgentRuntimeSessionDto;
  speech?: AgentRuntimeSpeechDto;
};
export type AgentDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  runtimeSettings?: (AgentRuntimeSettingsDto | (null | null)) | null;
  name: string;
  llmProviderId: string;
  llmProvider?: LlmProviderDto | null;
  llmModelId?: string | null;
  llmModel?: LlmModelDto | null;
  llmCustomModelKey?: string | null;
  voiceId: string;
  voice?: VoiceDto | null;
  profileId?: string | null;
  profile?: AgentProfileResponseDto | null;
  transcriberId: string;
  transcriber?: TranscriberResponseDto;
  languages?: string[];
  tools?: ToolDto[];
  avatarUrl?: string | null;
  metadata?: object | null;
  idleState?: AgentIdleStateResponseDto;
  backgroundSounds?: AgentBackgroundSoundsResponseDto | null;
};
export type CallDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  name?: string;
  type: CallType;
  roomName: string;
  status: CallStatus;
  endedReason?: CallEndedReason;
  startedAt?: string;
  endedAt?: string;
  customerId?: string;
  agentId?: string;
  squadId?: string;
  companyId: string;
  sentiments?: SentimentDto[];
  customer?: CustomerDto;
  recordingUrl?: string;
  agentProfileName?: string | null;
  squad?: SquadDto;
  agent?: AgentDto;
  analysisStatus: ('queued' | 'failed' | 'completed') | null;
  analysis: {
    [key: string]: any;
  } | null;
};
export type CallRequestDto = {
  status: CallStatus;
  endedReason?: CallEndedReason;
  startedAt?: string;
  endedAt?: string;
  roomName?: string;
  name?: string;
  recordingUrl?: string;
};
export type CallSupervisorModeDto = {
  mode: 'listen' | 'barge';
  updatedAt: string;
};
export type CallSupervisorModeRequestDto = {
  mode: 'listen' | 'barge';
  identity: string;
};
export type CampaignTestCallCreateResponseDto = {
  call: CallDto;
  token: string;
};
export type CampaignTestCallCreateRequestDto = {
  callType: CallType;
  agentId?: string;
  squadId?: string;
  phoneNumber?: string;
  name?: string;
  gender?: 'male' | 'female';
  attributes?: {
    [key: string]: any;
  };
  /** just ignor that field */
  _dummyProperty?: object;
};
export type CallCreateExternalCustomerDto = {
  number?: string;
  name?: string | null;
  gender?: ('male' | 'female') | null;
  attributes?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
  /** ISO8601 datetime. When to dial the customer. If the value has no timezone offset (e.g. "2026-06-10T15:00:00"), it is interpreted in the campaign schedule timezone; otherwise the embedded offset is used. */
  timeToDial?: string;
};
export type CallCreateExternalRequestDto = {
  customers: CallCreateExternalCustomerDto[];
};
export type CampaignCloneRequestDto = {
  title?: string;
};
export type CampaignStatus = 'active' | 'inactive';
export type CampaignType = 'inbound' | 'outbound';
export type CallScheduleDto = {
  mondayStart?: string | null;
  mondayEnd?: string | null;
  tuesdayStart?: string | null;
  tuesdayEnd?: string | null;
  wednesdayStart?: string | null;
  wednesdayEnd?: string | null;
  thursdayStart?: string | null;
  thursdayEnd?: string | null;
  fridayStart?: string | null;
  fridayEnd?: string | null;
  saturdayStart?: string | null;
  saturdayEnd?: string | null;
  sundayStart?: string | null;
  sundayEnd?: string | null;
  timezone?: string;
};
export type SipTrunkDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: object;
  campaignId: string;
  sipTrunkId?: string | null;
  fromHost?: string | null;
  dialCountry?: string | null;
  dialPrefix?: string | null;
};
export type AnalysisPlanDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  summaryPrompt: string;
  analysisTemplate?: string;
};
export type StructuredOutputDriver = 'baml' | 'custom';
export type StructuredOutputDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  companyId?: string | null;
  driver: StructuredOutputDriver;
  name: string;
  description: string;
  instructions?: string | null;
  schema: string;
};
export type AnalysisTriggerType = 'call-end' | 'scheduled';
export type NoiseGuardResponseDto = {
  enabled: boolean;
  shadowMode: boolean;
  hangupEnabled: boolean;
  triggers?: {
    [key: string]: any;
  };
};
export type NoiseCancellationSettingsResponseDto = {
  enabled: boolean;
  provider: string;
  strength?: number;
  recordAudio?: boolean;
  noiseDetection?: {
    [key: string]: any;
  };
};
export type CampaignNoiseProcessingResponseDto = {
  noiseGuard: NoiseGuardResponseDto | null;
  noiseCancellationSettings: NoiseCancellationSettingsResponseDto | null;
};
export type PreemptiveGenerationResponseDto = {
  enabled?: boolean;
  preemptiveTts?: boolean;
  maxSpeechDuration?: number;
  maxRetries?: number;
};
export type TurnHandlingResponseDto = {
  minEndpointingDelay?: number;
  maxEndpointingDelay?: number;
  turnDetection?: string;
  endpointingMode?: 'fixed' | 'dynamic';
  interruptionEnabled?: boolean;
  interruptionMode?: 'vad' | 'adaptive';
  minInterruptionWords?: number;
  minInterruptionDuration?: number;
  falseInterruptionTimeout?: number;
  resumeFalseInterruption?: boolean;
  preemptiveGeneration?: PreemptiveGenerationResponseDto;
};
export type SpeechPacingResponseDto = {
  enabled?: boolean;
  phraseBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  sentenceBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  seed?: string;
};
export type CampaignBackgroundSoundsResponseDto = {
  overrideAmbientSound: boolean;
  overrideThinkingSounds: boolean;
  ambientSound?: AmbientSoundResponseDto;
  thinkingSounds?: ThinkingSoundResponseDto[];
};
export type CampaignFileResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: 'parsing' | 'vectorizing' | 'ready' | 'failed';
  fileName: string;
  size: number;
  isEnabled: boolean;
  agentScope: 'all' | 'selected';
  agentIds: string[];
  hasOriginal: boolean;
  indexedChunksCount: number;
  pageCount: number;
  error: string | null;
  errorAt: string | null;
};
export type CampaignDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  companyId: string;
  status: CampaignStatus;
  title: string;
  type: CampaignType;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  callSchedule?: CallScheduleDto;
  sipTrunks?: SipTrunkDto[];
  analysisPlan?: AnalysisPlanDto;
  structuredOutputs?: StructuredOutputDto[];
  tools?: ToolDto[];
  reservedLimit: number;
  analysisTriggerType: AnalysisTriggerType;
  agentsCount: number;
  customersTotal?: number;
  squadId?: string;
  noiseProcessing: CampaignNoiseProcessingResponseDto;
  turnHandling: TurnHandlingResponseDto | null;
  speechPacing: SpeechPacingResponseDto | null;
  backgroundSounds?: CampaignBackgroundSoundsResponseDto | null;
  squad?: SquadDto | null;
  files?: CampaignFileResponseDto[];
};
export type NoiseGuardRequestDto = {
  enabled: boolean;
  shadowMode: boolean;
  hangupEnabled: boolean;
  triggers?: {
    [key: string]: any;
  };
};
export type NoiseCancellationSettingsRequestDto = {
  enabled: boolean;
  provider: string;
  strength?: number;
  recordAudio?: boolean;
  noiseDetection?: {
    [key: string]: any;
  };
};
export type CampaignNoiseProcessingRequestDto = {
  noiseGuard?: NoiseGuardRequestDto | null;
  noiseCancellationSettings?: NoiseCancellationSettingsRequestDto | null;
};
export type CustomerRequestDto = {
  id?: string;
  number?: string;
  name?: string | null;
  gender?: ('male' | 'female') | null;
  attributes?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
};
export type CallScheduleRequestDto = {
  mondayStart?: string | null;
  mondayEnd?: string | null;
  tuesdayStart?: string | null;
  tuesdayEnd?: string | null;
  wednesdayStart?: string | null;
  wednesdayEnd?: string | null;
  thursdayStart?: string | null;
  thursdayEnd?: string | null;
  fridayStart?: string | null;
  fridayEnd?: string | null;
  saturdayStart?: string | null;
  saturdayEnd?: string | null;
  sundayStart?: string | null;
  sundayEnd?: string | null;
  timezone?: string;
};
export type CampaignCreateRequestDto = {
  title: string;
  type: CampaignType;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  reservedLimit?: number;
  analysisTriggerType?: AnalysisTriggerType;
  noiseProcessing?: CampaignNoiseProcessingRequestDto | null;
  customers?: CustomerRequestDto[];
  callSchedule?: CallScheduleRequestDto;
};
export type AnalysisPlanRequestDto = {
  summaryPrompt: string;
  analysisTemplate?: string;
};
export type ToolRequestDto = {
  id?: string;
  /** Agent ID to attach tool to agent instead of campaign */
  agentId?: string;
  type: ToolType;
  isAsync: boolean;
  messageTemplate?: string | null;
  phoneNumbers?: string[] | null;
  mcpName?: string | null;
  mcpServerConfig?: object;
  genderSettings?: object | null;
};
export type AmbientSoundRequestDto = {
  soundId: string;
  volume: number;
};
export type ThinkingSoundRequestDto = {
  soundId: string;
  volume: number;
  probability: number;
};
export type CampaignBackgroundSoundsRequestDto = {
  overrideAmbientSound?: boolean;
  overrideThinkingSounds?: boolean;
  ambientSound?: AmbientSoundRequestDto | null;
  thinkingSounds?: ThinkingSoundRequestDto[];
};
export type PreemptiveGenerationRequestDto = {
  enabled?: boolean;
  preemptiveTts?: boolean;
  maxSpeechDuration?: number;
  maxRetries?: number;
};
export type TurnHandlingRequestDto = {
  minEndpointingDelay?: number;
  maxEndpointingDelay?: number;
  turnDetection?: string;
  endpointingMode?: 'fixed' | 'dynamic';
  interruptionEnabled?: boolean;
  interruptionMode?: 'vad' | 'adaptive';
  minInterruptionWords?: number;
  minInterruptionDuration?: number;
  falseInterruptionTimeout?: number;
  resumeFalseInterruption?: boolean;
  preemptiveGeneration?: PreemptiveGenerationRequestDto;
};
export type SpeechPacingRequestDto = {
  enabled?: boolean;
  phraseBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  sentenceBoundaryDelayMs?:
    | number
    | {
        minMs: number;
        maxMs: number;
      };
  seed?: string;
};
export type CampaignUpdateRequestDto = {
  title?: string;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  reservedLimit?: number;
  analysisTriggerType?: AnalysisTriggerType;
  noiseProcessing?: CampaignNoiseProcessingRequestDto | null;
  customers?: CustomerRequestDto[];
  callSchedule?: CallScheduleRequestDto;
  analysisPlan?: AnalysisPlanRequestDto | null;
  tools?: ToolRequestDto[];
  backgroundSounds?: CampaignBackgroundSoundsRequestDto;
  turnHandling?: TurnHandlingRequestDto | null;
  speechPacing?: SpeechPacingRequestDto | null;
};
export type CampaignAnalysisBatchRunResponseDto = {
  status: 'success' | 'failure';
  campaignId: string;
  scheduledCallIds: string[];
  batchId?: string;
  taskIds?: string[];
  error?: 'campaign_not_found' | 'analysis_plan_missing' | 'structured_output_missing';
};
export type CampaignStructuredOutputGenerateResponseDto = {
  /** Generated structured output template name. */
  name: string;
  /** Generated structured output template description. */
  description: string;
  /** Generated structured output schema serialized as a string. */
  schema: string;
  /** Generated analysis instructions for the structured output. */
  instructions: string;
  /** Generation timestamp returned by the analysis service. */
  createdAt: string;
};
export type TrunkType = 'inbound' | 'outbound';
export type SipTransport = 'auto' | 'udp' | 'tcp' | 'tls';
export type CampaignSipTrunkCreateRequestDto = {
  type: TrunkType;
  authUsername?: string | null;
  authPassword?: string | null;
  numbers: string[];
  allowedNumbers?: string[] | null;
  allowedAddresses?: string[] | null;
  address?: string | null;
  transport?: SipTransport;
  /** Host of the 'From' SIP header for outbound calls (e.g. the PBX SIP domain) */
  fromHost?: string | null;
  /** ISO 3166-1 alpha-2 country of the PBX. When set, numbers are dialed in local format instead of E.164 */
  dialCountry?: string | null;
  /** PBX outside-line prefix prepended to the dialed number. Requires dialCountry */
  dialPrefix?: string | null;
};
export type SipTrunkResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: TrunkType;
  campaignId: string;
  sipTrunkId?: string | null;
  numbers: string[];
  address?: string | null;
  allowedAddresses?: string[] | null;
  transport: SipTransport;
  fromHost?: string | null;
  dialCountry?: string | null;
  dialPrefix?: string | null;
};
export type CampaignsStopExceededLimitsResponseDto = {
  stoppedCampaignIds: string[];
  processedCompanies: number;
};
export type CustomerUpdateRequestDto = {
  number?: string;
  name?: string | null;
  gender?: ('male' | 'female') | null;
  attributes?: {
    [key: string]: any;
  };
  metadata?: {
    [key: string]: any;
  };
};
export type AgentIdleStateRequestDto = {
  enabled: boolean;
  delayMs: number;
  messages: string[];
  customerSilenceMessages?: string[];
  customerEndCallMessages?: string[];
  customerReplyTimeoutSec?: number | null;
  customerSilenceThresholdSec?: number | null;
  customerMaxAttempts?: number | null;
};
export type AgentRequestDto = {
  runtimeSettings?: (AgentRuntimeSettingsDto | (null | null)) | null;
  llmProviderId: string;
  llmModelId?: string | null;
  llmCustomModelKey?: string | null;
  name: string;
  profileId?: string | null;
  languages: string[];
  voiceId: string;
  transcriberId: string;
  idleState?: (AgentIdleStateRequestDto | (null | null)) | null;
};
export type CallActionStatus = 'pending' | 'in-progress' | 'succeeded' | 'failed' | 'skipped';
export type CallActionDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  callId: string;
  status: CallActionStatus;
  toolId: string;
  rejectionReason?: string;
};
export type CallActionRuntimePermitDto = {
  permitId: string;
  dispatchAttemptId: string;
  executionAttemptId: string;
  /** Native tool-setting assignment identity */
  toolId: string;
};
export type CallActionToolType = 'request-callback' | 'whatsapp-message-send';
export type CallActionRequestDto = {
  runtimePermit?: CallActionRuntimePermitDto;
  toolType: CallActionToolType;
  scheduledCallbackAt?: string;
  agentId?: string;
  input?: {
    [key: string]: string;
  };
  resend?: boolean;
};
export type CallCreateSystemRequestDto = {
  status: CallStatus;
  startedAt?: string;
  roomName?: string;
  recordingUrl?: string;
  /** Optional client-provided call id. When set, the call is created with this id instead of a generated one (e.g. websocket session_id used as the call id). */
  id?: string;
  customer: CustomerRequestDto;
  /** Either agentId or squadId must be provided */
  agentId?: string;
  /** Either agentId or squadId must be provided */
  squadId?: string;
  type: CallType;
};
export type SystemCampaignFileResponseDto = {
  id: string;
  status: 'parsing' | 'vectorizing' | 'ready' | 'failed';
  isEnabled: boolean;
  agentScope: 'all' | 'selected';
  agentIds: string[];
};
export type SystemCampaignDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  companyId: string;
  status: CampaignStatus;
  title: string;
  type: CampaignType;
  description?: string | null;
  retryIntervalInMinutes?: number | null;
  retryMaxNumber?: number | null;
  retriesPerDay?: number | null;
  productDetails?: string | null;
  callSchedule?: CallScheduleDto;
  sipTrunks?: SipTrunkDto[];
  analysisPlan?: AnalysisPlanDto;
  structuredOutputs?: StructuredOutputDto[];
  tools?: ToolDto[];
  reservedLimit: number;
  analysisTriggerType: AnalysisTriggerType;
  agentsCount: number;
  customersTotal?: number;
  squadId?: string;
  noiseProcessing: CampaignNoiseProcessingResponseDto;
  turnHandling: TurnHandlingResponseDto | null;
  speechPacing: SpeechPacingResponseDto | null;
  backgroundSounds?: CampaignBackgroundSoundsResponseDto | null;
  squad?: SquadDto | null;
  agents?: AgentDto[] | null;
  files?: SystemCampaignFileResponseDto[];
};
export type CampaignCallListMetaDto = {
  hasMore: boolean;
  cursor: string | null;
  totalItems?: number;
};
export type CampaignCallListPaginatedDto = {
  data: CallDto[];
  meta: CampaignCallListMetaDto;
};
export type ExternalAgentDto = {
  id: string;
  name: string;
};
export type ExternalSquadDto = {
  id: string;
  name: string;
  agents: ExternalAgentDto[];
};
export type ExternalCampaignDto = {
  id: string;
  title: string;
  status: CampaignStatus;
  type: CampaignType;
  description: string | null;
  agents: ExternalAgentDto[];
  squad: ExternalSquadDto | null;
};
export type CampaignListItemDto = {
  id: string;
  title: string;
  status: CampaignStatus;
  type: CampaignType;
  createdAt: string;
  updatedAt: string;
  customersTotal: number;
  customersLeft: number;
  agentsCount: number;
  /** Whether a SIP trunk of the campaign type exists with at least one number. Lets the list apply the same start rules as the campaign editor without fetching a trunk per row. */
  hasSipTrunks: boolean;
};
export type CampaignListMetaDto = {
  hasMore: boolean;
  cursor: string | null;
  totalItems?: number;
};
export type CampaignListPaginatedDto = {
  data: CampaignListItemDto[];
  meta: CampaignListMetaDto;
};
export type CampaignMetricCallDurationResponseDto = {};
export type CallAccessTokenDto = {
  token: string;
  expiredAt: string;
  callId: string;
};
export type CallRecordingDto = {
  url: string;
  expiresAt: string;
  callId: string;
};
export type CustomerShortDto = {
  id: string;
  number?: string;
  name?: string | null;
  attributes?: object;
  campaignId?: string;
};
export type CallNotAnalyzedListDto = {
  id: string;
  analysisPrompt?: string;
  customer?: CustomerShortDto;
};
export type CustomerListItemDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  number?: string;
  name?: string | null;
  gender?: string | null;
  attributes?: object;
  metadata?: object;
  campaignId?: string;
  /** Whether the customer has at least one call */
  hasCalls: boolean;
};
export type CursorPaginationMetaDto = {
  hasMore: boolean;
  cursor: string | null;
};
export type CustomerListPaginatedDto = {
  data: CustomerListItemDto[];
  meta: CursorPaginationMetaDto;
};
export type CustomerListExportResponseDto = {
  data: CustomerListItemDto[];
};
export type AgentBackgroundSoundsRequestDto = {
  ambientSound?: AmbientSoundRequestDto | null;
  thinkingSounds?: ThinkingSoundRequestDto[];
};
export type BackgroundSoundType = 'ambient' | 'thinking';
export type BackgroundSoundResponseDto = {
  id: string;
  type: BackgroundSoundType;
  name: string;
  defaultVolume: number;
  isDefault: boolean;
  fileUrl: string;
};
export type BackgroundSoundCreateRequestDto = {
  uploadKey: string;
  name: string;
  type: BackgroundSoundType;
  defaultVolume: number;
};
export type BackgroundSoundUpdateRequestDto = {
  uploadKey?: string;
  name?: string;
  defaultVolume?: number;
};
export type BackgroundSoundUploadUrlResponseDto = {
  uploadUrl: string;
  uploadKey: string;
  expiresAt: string;
};
export type BackgroundSoundUploadUrlRequestDto = {
  type: BackgroundSoundType;
  mimeType: string;
  originalFilename: string;
  size: number;
};
export type ElevenLabsSettingsRequestDto = {
  similarityBoost?: number;
  stability?: number;
  useSpeakerBoost?: boolean;
  style?: number;
  /** LiveKit streaming-latency option: 0 disables, 4 is maximum. Runtime default: 2. */
  streamingLatency?: number;
};
export type HamsaSettingsRequestDto = {
  /** Required on write: Agency passes it explicitly, so a missing value is not defaulted. */
  speaker: string;
  /** Dialect compatible with the selected speaker. Required on write: Agency passes it explicitly. */
  dialect: string;
  /** Requests mu-law output. Runtime default: false. */
  mulaw?: boolean;
  /** Runtime default: 1.0. */
  speed?: number;
  /** Runtime default: 1.0. */
  expressiveness?: number;
  /** Output sample rate in Hz. Runtime default: 16000. */
  sampleRate?: 8000 | 16000;
  /** Local dynamic-range compression after synthesis. Runtime default: true. */
  normalizeAudio?: boolean;
};
export type DeepgramSettingsRequestDto = {
  /** Appended to voiceId as model:preset on the non-Flux path only. */
  instructionsPreset?: string;
};
export type SonioxSettingsRequestDto = {
  /** Output codec. Runtime default: pcm_s16le. Sample rate and bitrate depend on this format. */
  audioFormat?:
    | 'pcm_f32le'
    | 'pcm_s16le'
    | 'wav'
    | 'pcm_mulaw'
    | 'pcm_alaw'
    | 'flac'
    | 'mp3'
    | 'opus'
    | 'aac';
  /** Output sample rate in Hz. Allowed values depend on audioFormat. Runtime default: 24000. */
  sampleRate?: 8000 | 16000 | 24000 | 32000 | 44100 | 48000;
  /** Codec bitrate in bits/s for compressed formats; allowed values depend on audioFormat. */
  bitrate?: number;
};
export type Qwen3TtsSettingsRequestDto = {
  /** Otherwise QWEN3_TTS_TASK_TYPE, then CustomVoice. */
  taskType?: 'CustomVoice' | 'VoiceDesign' | 'Base';
  /** Style/emotion instructions; voice description for VoiceDesign. Otherwise QWEN3_TTS_INSTRUCTIONS. */
  instructions?: string;
  /** Reference audio URL or data URI for Base voice cloning. Otherwise QWEN3_TTS_REF_AUDIO. */
  refAudio?: string;
  /** Reference transcript for Base voice cloning. Otherwise QWEN3_TTS_REF_TEXT. */
  refText?: string;
  /** Output format, otherwise QWEN3_TTS_RESPONSE_FORMAT, then pcm. */
  responseFormat?: 'wav' | 'mp3' | 'flac' | 'pcm' | 'opus';
};
export type OpenAittsSettingsRequestDto = {
  /** Speech speed. Provider default: 1.0. */
  speed?: number;
  /** Per-call voice instructions, appended to OPENAI_TTS_INSTRUCTIONS. Not supported by tts-1 and tts-1-hd. */
  instructions?: string;
  /** Output audio format. */
  responseFormat?: 'mp3' | 'opus' | 'aac' | 'flac' | 'wav' | 'pcm';
};
export type CustomVoiceSettingsRequestDto = {
  /** Optional runtime provider override; it also selects advanced validation. */
  provider?: string | null;
  /** Optional runtime voice ID override. */
  voiceId?: string;
};
export type VoiceRequestDto = {
  name: string;
  previewUrl: string;
  /** Voice provider identifier. Can be a supported runtime provider or any custom string. */
  provider: string;
  /** Optional pseudonym shown to end-users instead of the real provider name (e.g. "1punch" instead of "11labs"). */
  providerDisplayName?: string;
  /** Provider-specific voice identifier. Deepgram selects its model through this field. */
  voiceId?: string;
  gender?: string;
  accent?: string;
  /** Provider model stored in its dedicated column. Settings JSON is stored independently. */
  model?: string | null;
  /** Provider language identifier stored in its dedicated column. No universal language vocabulary is enforced; settings JSON is stored independently. */
  language?: string | null;
  /** Provider API key, stored only in its column. Omit to keep the stored key, send null or an empty string to clear it, a string to replace it. When omitted, a root voiceSettings.apiKey string or null is used instead; the key is always removed from settings JSON. */
  apiKey?: string | null;
  /** Provider base URL, stored only in its column. Omit to keep the stored URL, send null or an empty string to clear it, a string to replace it. When omitted, a root voiceSettings.baseUrl string or null is used instead; the key is always removed from settings JSON. */
  baseUrl?: string | null;
  /** Flat settings JSON. Known advanced fields are validated using the runtime provider: voiceSettings.provider when present, otherwise the top-level provider (case-insensitive, empty means 11labs). Root apiKey/baseUrl (string or null) move to their columns. Additional keys and values are preserved without stripping, coercion or defaults. */
  voiceSettings:
    | ElevenLabsSettingsRequestDto
    | HamsaSettingsRequestDto
    | DeepgramSettingsRequestDto
    | SonioxSettingsRequestDto
    | Qwen3TtsSettingsRequestDto
    | OpenAittsSettingsRequestDto
    | CustomVoiceSettingsRequestDto
    | {
        [key: string]: any;
      };
};
export type CustomTranscriberRequestDto = {
  /** Arbitrary provider identifier passed to the runtime as is. */
  provider: string;
  /** Optional nonempty display label; null clears it; omitted keeps it on edit. */
  providerDisplayName?: string | null;
  /** Provider model; null when not set. */
  model: string | null;
  /** Provider language; null when not set. */
  language: string | null;
  /** Provider-specific JSON object. Replaces the stored value entirely; null clears it; omitted keeps it. */
  parameters?: {
    [key: string]: any;
  } | null;
};
export type ProviderType = 'azure' | 'deepgram' | 'hamsa' | 'openai';
export type LanguageType = 'ar-SA' | 'en-US' | 'fr-FR' | 'ch-CN';
export type TranscriberRequestDto = {
  id?: string;
  provider: ProviderType;
  /** Optional pseudonym shown to end-users instead of the real provider name (e.g. "1punch" instead of "deepgram"). */
  providerDisplayName?: string;
  language: LanguageType;
};
export type DefaultSipSettingsDto = {
  type: TrunkType;
  authUsername?: string;
  authPassword?: string;
  numbers: string[];
  allowedNumbers?: string[] | null;
  allowedAddresses?: string[] | null;
  address?: string | null;
  transport?: SipTransport;
  /** Host of the 'From' SIP header for outbound calls (e.g. the PBX SIP domain) */
  fromHost?: string | null;
  /** ISO 3166-1 alpha-2 country of the PBX. When set, numbers are dialed in local format instead of E.164 */
  dialCountry?: string | null;
  /** PBX outside-line prefix prepended to the dialed number. Requires dialCountry */
  dialPrefix?: string | null;
};
export type CompanyDto = {
  id: string;
  name: string;
  logo?: string | null;
  description?: string | null;
  industryType?: string | null;
  address?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  users?: UserDto[];
  defaultOutboundSettings?: DefaultSipSettingsDto;
  defaultInboundSettings?: DefaultSipSettingsDto;
  voices?: VoiceDto[];
  transcribers?: TranscriberResponseDto[];
  llmProviders?: LlmProviderDto[];
};
export type UserRequestDto = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: UserRoles;
};
export type UsageUnitLimit = 'call-second' | 'llm-total-tokens' | 'stt-second' | 'tts-character';
export type UsageLimitSetItemDto = {
  unit: UsageUnitLimit;
  /** Monthly limit as stringified integer */
  limitPerMonth: string;
};
export type CreateCompanyRequestDto = {
  name: string;
  description?: string | null;
  logo?: string | null;
  users: UserRequestDto[];
  defaultOutboundSettings?: DefaultSipSettingsDto;
  defaultInboundSettings?: DefaultSipSettingsDto;
  limits?: UsageLimitSetItemDto[];
  /** Company-wide concurrent call limit */
  companyConcurrentLimit?: number;
  voiceIds?: string[];
  transcriberIds?: string[];
  llmProviderIds?: string[];
};
export type EditCompanyRequestDto = {
  name: string;
  description: string | null;
  logo: string | null;
  industryType?: string;
  address?: string;
  defaultOutboundSettings?: DefaultSipSettingsDto;
  defaultInboundSettings?: DefaultSipSettingsDto;
  voiceIds?: string[];
  transcriberIds?: string[];
  llmProviderIds?: string[];
};
export type CompanyApiKeyCreateResponseDto = {
  ok: boolean;
  apiKey: string;
};
export type AgentProfileCreateRequestDto = {
  sector?:
    | (
        | 'medical'
        | 'hospitality'
        | 'real-estate'
        | 'retail'
        | 'professional-services'
        | 'general'
        | null
      )
    | null;
  summary?: string | null;
  name: string;
  prompt: string;
  firstMessage?: string | null;
  firstMessageInterruptionsEnabled?: boolean;
};
export type AgentProfileCreateAdminRequestDto = {
  sector?:
    | (
        | 'medical'
        | 'hospitality'
        | 'real-estate'
        | 'retail'
        | 'professional-services'
        | 'general'
        | null
      )
    | null;
  summary?: string | null;
  name: string;
  prompt: string;
  firstMessage?: string | null;
  firstMessageInterruptionsEnabled?: boolean;
  type?: AgentProfileType;
};
export type AgentProfileEditRequestDto = {
  sector?:
    | (
        | 'medical'
        | 'hospitality'
        | 'real-estate'
        | 'retail'
        | 'professional-services'
        | 'general'
        | null
      )
    | null;
  summary?: string | null;
  name?: string;
  prompt?: string;
  firstMessage?: string | null;
  firstMessageInterruptionsEnabled?: boolean;
  taskFlow?: (TaskFlowDto | (null | null)) | null;
};
export type CompanyOverviewResponseDto = {
  ongoingCalls: number | null;
  runningCampaigns: number | null;
  inactiveCampaigns: number | null;
  totalCampaigns: number | null;
};
export type UsageLimitDetailDto = {
  unit: UsageUnitLimit;
  allowed: boolean;
  limit: string;
  used: string;
  remaining: string;
  delta: number;
};
export type ConcurrentLimitResponseDto = {
  limit: number;
  activeCalls: number;
};
export type RemainingLimitResponseDto = {
  allowed: boolean;
  companyId: string;
  limits: UsageLimitDetailDto[];
  concurrent?: ConcurrentLimitResponseDto | null;
};
export type UsageLimitResponseDto = {
  unit: object;
  limitPerMonth: string;
};
export type UsageLimitSetRequestDto = {
  limits: UsageLimitSetItemDto[];
};
export type CompanyVoicesSetRequestDto = {
  voiceIds: string[];
};
export type CompanyTranscribersSetRequestDto = {
  transcriberIds: string[];
};
export type CompanyLlmProvidersSetRequestDto = {
  llmProviderIds: string[];
};
export type ConcurrentLimitSetResponseDto = {
  companyConcurrentLimit: number;
};
export type ConcurrentLimitSetRequestDto = {
  /** Company-wide concurrent call limit */
  companyConcurrentLimit: number;
};
export type UnitWeightsResponseDto = {
  id: string;
  sourceUnit: object;
  limitUnit: object;
  weight: number;
};
export type UnitWeightSetItemDto = {
  /** UUID of the unit weight record */
  id: string;
  /** Weight multiplier */
  weight: number;
};
export type UnitWeightsSetRequestDto = {
  weights: UnitWeightSetItemDto[];
};
export type PostCallMessageConditionDto = {
  /** Analysis-summary field name to test. */
  field: string;
  operator: 'equals' | 'not_equals' | 'contains' | 'exists' | 'not_exists';
  /** Compared as a string. Required for equals/not_equals/contains; ignored otherwise. */
  value?: string;
};
export type CampaignPostCallMessageResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  campaignId: string;
  isEnabled: boolean;
  order: number;
  channel: 'whatsapp';
  conditions: PostCallMessageConditionDto[];
  template: string;
};
export type CampaignPostCallMessageCreateRequestDto = {
  /** Defaults to true. */
  isEnabled?: boolean;
  /** Send order among matched rules; lower runs first. Default 0. */
  order?: number;
  /** Defaults to whatsapp. */
  channel?: 'whatsapp';
  /** AND-joined; empty = always send. */
  conditions: PostCallMessageConditionDto[];
  /** Message body with {{path}} placeholders (e.g. {{customer.name}}). */
  template: string;
};
export type CampaignPostCallMessageUpdateRequestDto = {
  isEnabled?: boolean;
  order?: number;
  channel?: 'whatsapp';
  conditions?: PostCallMessageConditionDto[];
  template?: string;
};
export type FileResponseDto = {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: object;
  fileName: string;
  size: number;
  hasOriginal: boolean;
  indexedChunksCount: number;
  pageCount: number;
  error: string | null;
  errorAt: string | null;
};
export type FileCreateRequestDto = {
  fileName: string;
  campaignId: string;
};
export type CampaignFileAvailabilityUpdateRequestDto = {
  isEnabled: boolean;
};
export type CampaignFileAgentsSetRequestDto = {
  agentScope: 'all' | 'selected';
  /** Required for selected scope; an empty list selects no agents. Must be omitted or empty for all scope. */
  agentIds?: string[];
};
export type FileOriginalResponseDto = {
  url: string;
  expiresAt: string;
};
export type CampaignFileSearchResponseDto = {
  score: number;
  page: number | null;
  chunkIndex: number;
  fragment: string;
};
export type SquadCreateRequestDto = {
  name: string;
  description?: string;
};
export type SquadAgentUpdateRequestDto = {
  llmProviderId: string;
  llmModelId?: string | null;
  llmCustomModelKey?: string | null;
  name: string;
  profileId?: string | null;
  languages: string[];
  voiceId: string;
  transcriberId: string;
  idleState?: AgentIdleStateRequestDto | null;
  isDefault?: boolean;
};
export type SquadAgentDeleteResponseDto = {
  ok: boolean;
  defaultAgentId?: string;
};
export type HandoffRuleMessagesRequestDto = {
  start?: string[];
  delayed?: string[];
  complete?: string[];
  failed?: string[];
};
export type ContextPropagationPlanRequestDto = {
  type: ContextPropagationPlanType;
  maxMessages?: number;
};
export type HandoffRuleRequestDto = {
  name?: string;
  description?: string;
  fromAgentId: string;
  toAgentId: string;
  messages?: HandoffRuleMessagesRequestDto;
  contextPropagationPlan?: ContextPropagationPlanRequestDto;
  variableExtractionPlan?: object;
};
export type StructuredOutputCreateRequestDto = {
  name: string;
  description: string;
  instructions?: string | null;
  schema: object;
};
export type StructuredOutputUpdateRequestDto = {
  name?: string;
  description?: string;
  instructions?: string | null;
  schema?: object;
};
export type CampaignStructuredOutputAttachRequestDto = {
  structuredOutputId: string;
};
export type ToolUpdateRequestDto = {
  /** Agent ID to attach tool to agent instead of campaign */
  agentId?: string;
  isAsync: boolean;
  messageTemplate?: string | null;
  phoneNumbers?: string[] | null;
  mcpName?: string | null;
  mcpServerConfig?: object;
  genderSettings?: object | null;
};
export type WebhookEventFailureDto = {
  deliveryId: string;
  callId: string;
  event: 'call.started' | 'call.ended' | 'analysis.completed' | 'conversation.completed';
  code: 'event_snapshot_unavailable';
  createdAt: string;
};
export type WebhookHeaderItemDto = {
  key: string;
  value: string;
};
export type WebhookAuthConfigMaskedDto = {
  masked: boolean;
};
export type WebhookSuccessCriteriaItemDto = {
  path: string;
  equals: string;
  errorPath?: string;
};
export type CampaignWebhookResponseDto = {
  lastEventFailure?: (WebhookEventFailureDto | (null | null)) | null;
  id: string;
  campaignId: string;
  name: string;
  isEnabled: boolean;
  triggerOn: 'call_ended';
  events?:
    | ('call.started' | 'call.ended' | 'analysis.completed' | 'conversation.completed')[]
    | null;
  url: string;
  httpMethod: 'POST' | 'GET';
  headers?: WebhookHeaderItemDto[] | null;
  bodyTemplate?: object | null;
  authType: 'none' | 'basic' | 'bearer';
  authConfig?: WebhookAuthConfigMaskedDto | null;
  timeoutMs: number;
  maxRetries: number;
  ignoreSslErrors: boolean;
  successCriteria?: WebhookSuccessCriteriaItemDto | null;
  createdAt: string;
  updatedAt: string;
};
export type WebhookHeaderDto = {
  key: string;
  value: string;
};
export type WebhookSuccessCriteriaDto = {
  /** Dot-path into the JSON response body, e.g. "AckMessage.Status". */
  path: string;
  /** Value at `path` that marks an application-level success (compared as a string). */
  equals: string;
  /** Dot-path to a human-readable error detail, surfaced into the delivery log. */
  errorPath?: string;
};
export type CampaignWebhookCreateRequestDto = {
  /** Explicit lifecycle events. Null retains legacy call_ended timing/defaults. conversation.completed requires an authoritative final transcript receipt and established terminal call. */
  events?:
    | ('call.started' | 'call.ended' | 'analysis.completed' | 'conversation.completed')[]
    | null;
  name: string;
  isEnabled?: boolean;
  url: string;
  httpMethod?: 'POST' | 'GET';
  headers?: WebhookHeaderDto[];
  bodyTemplate?: object;
  authType?: 'none' | 'basic' | 'bearer';
  authConfig?: object;
  /** Skip TLS certificate validation for the target (self-signed / internal hosts). */
  ignoreSslErrors?: boolean;
  /** Retries after the first attempt (0 = single attempt). Default 3. */
  maxRetries?: number;
  /** Application-level success rule against the JSON response body. Omit → success is decided by the HTTP status code only. */
  successCriteria?: WebhookSuccessCriteriaDto;
};
export type CampaignWebhookUpdateRequestDto = {
  /** Explicit lifecycle events. Null retains legacy call_ended timing/defaults. conversation.completed requires an authoritative final transcript receipt and established terminal call. */
  events?:
    | ('call.started' | 'call.ended' | 'analysis.completed' | 'conversation.completed')[]
    | null;
  name?: string;
  isEnabled?: boolean;
  url?: string;
  httpMethod?: 'POST' | 'GET';
  headers?: WebhookHeaderDto[];
  bodyTemplate?: object;
  authType?: 'none' | 'basic' | 'bearer';
  authConfig?: object;
  /** Skip TLS certificate validation for the target (self-signed / internal hosts). */
  ignoreSslErrors?: boolean;
  /** Retries after the first attempt (0 = single attempt). */
  maxRetries?: number;
  /** Application-level success rule against the JSON response body. Pass null to clear it (revert to HTTP-status-only). */
  successCriteria?: WebhookSuccessCriteriaDto | null;
};
export type PeriodDto = {
  start: string;
  end: string;
};
export type UsageProviderDto = {
  provider: string;
  period?: PeriodDto;
  result: object;
};
export type UsageResponseDto = {
  providers: UsageProviderDto[];
};
export type BillingPlanOfferDto = {
  id: string;
  key: string;
  version: number;
  /** Exact integer units; never a JSON floating-point number */
  allowanceUnits: string;
  creditScale: number;
  concurrentLimit: number;
  features: string[];
  amountMinor: string;
  currency: string;
  currencyScale: number;
};
export type BillingPlanSummaryDto = {
  id: string;
  key: string;
  version: number;
  /** Exact integer units; never a JSON floating-point number */
  allowanceUnits: string;
  creditScale: number;
  concurrentLimit: number;
  features: string[];
};
export type BillingPendingChangeDto = {
  id: string;
  kind: 'checkout' | 'upgrade' | 'downgrade' | 'cancel' | 'schedule_release';
  state: 'prepared' | 'sending' | 'unknown' | 'pending' | 'review';
  errorCode: string | null;
  nextPlan: (BillingPlanSummaryDto | (null | null)) | null;
  effectiveAt: string | null;
};
export type BillingScheduledChangeDto = {
  kind: 'downgrade' | 'cancel';
  planVersionId: string | null;
  planKey: string | null;
  effectiveAt: string;
};
export type BillingCatalogDto = {
  version: 1;
  plans: BillingPlanOfferDto[];
  canCheckout: boolean;
  canOpenPortal: boolean;
  canChangePlan: boolean;
  changePlanUnavailableReason?: string | null;
  canReleaseSchedule: boolean;
  canSynchronize: boolean;
  pendingChange: (BillingPendingChangeDto | (null | null)) | null;
  scheduledChange: (BillingScheduledChangeDto | (null | null)) | null;
};
export type BillingBalanceDto = {
  periodId: string;
  grantedUnits: string;
  spentUnits: string;
  expiredUnits: string;
  heldUnits: string;
  availableUnits: string;
  overrunUnits: string;
};
export type BillingPreviousPeriodDto = {
  plan: BillingPlanSummaryDto;
  balance: BillingBalanceDto;
  startsAt: string;
  endsAt: string;
};
export type BillingOutstandingPeriodDto = {
  periodId: string;
  creditScale: number;
  heldUnits: string;
  overrunUnits: string;
  endsAt: string;
};
export type CompanyBillingSummaryDto = {
  version: 1;
  mode: 'legacy_manual' | 'credit_managed';
  status: 'legacy' | 'trial_pending' | 'trial' | 'paid' | 'expired' | 'review';
  asOf: string;
  admissionEnabled: boolean;
  canManage: boolean;
  plan: (BillingPlanSummaryDto | (null | null)) | null;
  balance: (BillingBalanceDto | (null | null)) | null;
  startsAt: string | null;
  endsAt: string | null;
  policyGates: string[];
  previousPeriod: (BillingPreviousPeriodDto | (null | null)) | null;
  outstandingPeriods: BillingOutstandingPeriodDto[];
  hasMoreOutstandingPeriods: boolean;
  /** Compatible non-expiring funds spendable in the active paid period */
  topUpAvailableUnits?: string;
  /** Monthly plus compatible top-up funds; monthly balance retains its original meaning */
  totalAvailableUnits?: string;
};
export type BillingPolicyResultDto = {
  id: string;
};
export type BillingPolicyApprovalDto = {
  policy: 'POL-01' | 'POL-02' | 'POL-03' | 'POL-04' | 'POL-05';
  version: string;
  approvedBy: string;
  approvedAt: string;
  evidenceReference: string;
};
export type PublishEnrollmentPolicyDto = {
  policyKey: string;
  environment: 'test' | 'live';
  connectionKey: string;
  cohortStartsAt: string;
  trialPlanVersionId: string;
  trialDurationSeconds: number;
  policyApprovals: BillingPolicyApprovalDto[];
};
export type BillingEnrollmentResultDto = {
  accountId: string;
};
export type BillingEnrollmentDto = {
  policyId: string;
  requestKey: string;
  reason: string;
};
export type BillingAdmissionControlResultDto = {
  enabled: boolean;
};
export type BillingAdmissionControlDto = {
  enabled: boolean;
  requestKey: string;
  reason: string;
};
export type BillingAdjustmentResultDto = {
  ledgerId: string;
};
export type BillingAdjustmentDto = {
  targetLedgerId: string;
  /** Exact signed integer credit units, never a monetary refund */
  deltaUnits: string;
  requestKey: string;
  reason: string;
  supportReference: string;
};
export type StripeCheckoutResultDto = {
  version: 1;
  attemptId: string;
  state: 'open' | 'pending' | 'expired';
  url: string | null;
};
export type StripeCheckoutRequestDto = {
  /** Approved local immutable plan version, never a Stripe price ID */
  planVersionId: string;
  requestKey: string;
};
export type StripePortalResultDto = {
  version: 1;
  url: string;
};
export type StripeSynchronizationDto = {
  version: 1;
  state: 'idle' | 'queued' | 'processing';
  requestedAt: string | null;
  completedAt: string | null;
  nextAttemptAt: string | null;
  errorCode: string | null;
};
export type StripeUpgradeOutcomeDto = {
  version: 1;
  intentId: string;
  state: 'pending' | 'succeeded' | 'failed' | 'review';
};
export type StripeUpgradeApplyRequestDto = {
  previewId: string;
  requestKey: string;
};
export type StripeUpgradePreviewDto = {
  version: 1;
  previewId: string;
  currentPlanVersionId: string;
  nextPlanVersionId: string;
  /** Exact integer provider minor units */
  amountDueMinor: string;
  currency: string;
  currencyScale: number;
  upgradeUnits: string;
  creditScale: number;
  prorationAt: string;
  expiresAt: string;
};
export type StripeUpgradePreviewRequestDto = {
  /** Approved local immutable plan version */
  planVersionId: string;
};
export type StripeUpgradePaymentDto = {
  version: 1;
  intentId: string;
  state: 'available' | 'pending' | 'not_required';
  url: string | null;
};
export type StripeScheduledChangeOutcomeDto = {
  version: 1;
  intentId: string;
  state: 'pending' | 'succeeded' | 'review' | 'failed';
  effectiveAt: string;
};
export type StripeScheduledChangeRequestDto = {
  action: 'downgrade' | 'cancel' | 'release_schedule';
  planVersionId?: string;
  requestKey: string;
};
export type BillingEnrollmentPolicyOptionDto = {
  id: string;
  key: string;
  environment: 'test' | 'live';
  trialPlanKey: string;
  trialDurationSeconds: number;
  cohortStartsAt: string;
  policyGates: string[];
};
export type BillingEnrollmentOptionsDto = {
  version: 1;
  enrollmentEnabled: boolean;
  policies: BillingEnrollmentPolicyOptionDto[];
  hasMore: boolean;
};
export type BillingPaymentExceptionDto = {
  id: string;
  kind: 'refund' | 'dispute';
  createdAt: string;
  resolvedAt: string | null;
};
export type BillingPaymentExceptionsDto = {
  version: 1;
  exceptions: BillingPaymentExceptionDto[];
  hasMore: boolean;
};
export type BillingPaymentExceptionResolutionDto = {
  resolutionId: string;
};
export type ResolveBillingPaymentExceptionDto = {
  requestKey: string;
  reason: string;
  supportReference: string;
};
export type WorkspaceRuntimeLimitsDto = {
  /** Exact native credit units expressed as a decimal; requires enrolled pricing. */
  credits?: string | null;
  tools?: number | null;
  seconds?: number | null;
};
export type WorkspaceCallEventConditionDto = {
  field: 'campaignId' | 'type' | 'direction' | 'status' | 'endedReason' | 'agentId' | 'squadId';
  operator: 'equals' | 'not-equals' | 'contains' | 'exists';
  /** May be empty only for exists. */
  value: string;
};
export type WorkspaceCallEventFiltersDto = {
  mode: 'all' | 'any';
  conditions: WorkspaceCallEventConditionDto[];
};
export type WorkspaceTriggerDto = {
  kind: 'manual' | 'schedule' | 'call-ended';
  cron?: string;
  timezone?: string;
  /** Only for call-ended; evaluates native scalar call metadata. */
  filters?: WorkspaceCallEventFiltersDto;
};
export type WorkspaceActionDto = {
  kind:
    | 'campaign-summary'
    | 'campaign-start'
    | 'campaign-stop'
    | 'campaign-rename'
    | 'webhook-dispatch';
  campaignId: string;
  callId?: string;
  /** Required only for campaign-rename */
  title?: string;
};
export type WorkspaceMissionSpecDto = {
  name: string;
  brief: string;
  limits?: WorkspaceRuntimeLimitsDto;
  trigger: WorkspaceTriggerDto;
  actions: WorkspaceActionDto[];
};
export type WorkspaceMissionDto = {
  id: string;
  draft: WorkspaceMissionSpecDto;
  revision: number;
  paused: boolean;
  active_version_id: string | null;
  next_due_at: string | null;
  created_at: string;
};
export type WorkspaceCreateMissionDto = {
  id: string;
  spec: WorkspaceMissionSpecDto;
};
export type WorkspaceVersionDto = {
  id: string;
  number: number;
  spec: WorkspaceMissionSpecDto;
  created_at: string;
};
export type WorkspaceMissionDetailDto = {
  mission: WorkspaceMissionDto;
  versions: WorkspaceVersionDto[];
};
export type WorkspaceSaveMissionDto = {
  revision: number;
  spec: WorkspaceMissionSpecDto;
};
export type WorkspaceRevisionDto = {
  revision: number;
};
export type WorkspacePauseDto = {
  revision: number;
  paused: boolean;
};
export type WorkspaceRuntimeBudgetUsageDto = {
  id: string;
  companyId: string;
  ownerKind: 'mission' | 'widget';
  ownerId: string;
  requestId: string;
  parentExecutionId: string | null;
  utcDay: string | null;
  missionVersionId: string | null;
  limits: WorkspaceRuntimeLimitsDto;
  creditScale: number | null;
  limitUnits: string | null;
  state: 'prepared' | 'running' | 'draining' | 'settling' | 'completed' | 'review';
  exhaustionReason: string | null;
  startedAt: string | null;
  deadlineAt: string | null;
  commandsFinished: boolean;
  acknowledgedAt: string | null;
  acknowledgedBy: string | null;
  acknowledgementRequestId: string | null;
  financialState: 'known' | 'unavailable' | 'review';
  spentUnits: string | null;
  accruedUnits: string | null;
  heldUnits: string | null;
  overrunUnits: string | null;
  toolInvocations: number;
  activeCalls: number;
  pendingCalls: number;
  unsettledCalls: number;
  unknownDispatches: number;
  pendingDispatches: number;
};
export type WorkspaceOperationDto = {
  runtimeBudget?: WorkspaceRuntimeBudgetUsageDto;
  id: string;
  mission_id: string | null;
  version_id: string | null;
  state:
    | 'planning'
    | 'prepared'
    | 'queued'
    | 'running'
    | 'succeeded'
    | 'failed'
    | 'review'
    | 'canceled';
  actions: WorkspaceActionDto[];
  snapshots: {
    [key: string]: any;
  }[];
  result: {
    [key: string]: any;
  }[];
  error_code: string | null;
  created_at: string;
  expires_at: string | null;
};
export type WorkspaceRunDto = {
  requestId: string;
};
export type WorkspaceModelDto = {
  id: string;
  title: string;
};
export type WorkspaceProviderDto = {
  id: string;
  title: string;
  models: WorkspaceModelDto[];
};
export type WorkspaceAskResponseDto = {
  answer: string;
  operation: WorkspaceOperationDto | null;
};
export type WorkspaceAskDto = {
  requestId: string;
  providerId: string;
  modelId: string;
  campaignId: string;
  messages: {
    role: 'user' | 'assistant';
    content: string;
  }[];
};
export type WorkspaceConfigurationActionDto = {
  kind:
    | 'campaign-summary'
    | 'campaign-start'
    | 'campaign-stop'
    | 'campaign-rename'
    | 'webhook-dispatch';
  campaignId: string;
  status: 'checked' | 'blocked' | 'deferred';
  message: string;
};
export type WorkspaceConfigurationCheckDto = {
  nextOccurrence: string | null;
  actions: WorkspaceConfigurationActionDto[];
};
export type WorkspaceCheckConfigurationDto = {
  spec: WorkspaceMissionSpecDto;
};
export type WorkspaceJobUsageDto = {
  profileId: string;
  agentCount: number;
  campaignCount: number;
};
export type WorkspaceJobUsageCampaignDto = {
  id: string;
  title: string;
  status: string;
};
export type WorkspaceJobUsageAgentDto = {
  id: string;
  name: string;
  campaigns: WorkspaceJobUsageCampaignDto[];
};
export type WorkspaceJobUsagePageDto = {
  agents: WorkspaceJobUsageAgentDto[];
  next: string | null;
  total: number;
};
export type StudioJobValuesDto = {
  sector?:
    | ('medical' | 'hospitality' | 'real-estate' | 'retail' | 'professional-services' | 'general')
    | null;
  summary?: string | null;
  name: string;
  prompt: string;
  firstMessage: string | null;
  firstMessageInterruptionsEnabled: boolean;
  taskFlow: TaskFlowDto | null;
};
export type StudioJobDto = {
  id: string;
  values: StudioJobValuesDto;
};
export type StudioDraftDto = {
  agent: AgentRequestDto;
  job: StudioJobDto | null;
};
export type StudioBranchDto = {
  id: string;
  name: string;
  draft: StudioDraftDto;
  baseFingerprint: string;
};
export type StudioNativeDto = {
  draft: StudioDraftDto;
  jobType: ('custom' | 'system' | 'customer-template') | null;
  fingerprint: string;
};
export type StudioDetailDto = {
  id: string;
  revision: number;
  activeBranchId: string;
  activeVersionId: string | null;
  branches: StudioBranchDto[];
  native: StudioNativeDto;
  staleBranchIds: string[];
};
export type StudioVersionDto = {
  id: string;
  number: number;
  branchId: string;
  spec: StudioDraftDto;
  createdAt: string;
  createdBy: string;
};
export type StudioVersionsDto = {
  items: StudioVersionDto[];
  next: string | null;
};
export type StudioCreateBranchDto = {
  revision: number;
  name: string;
  sourceBranchId: string;
};
export type StudioSaveDto = {
  revision: number;
  draft: StudioDraftDto;
};
export type StudioRevisionDto = {
  revision: number;
};
export type StudioRestoreDto = {
  revision: number;
  versionId: string;
};
export type StudioPublishResultDto = {
  studio: StudioDetailDto;
  version: StudioVersionDto;
};
export type StudioPublishDto = {
  revision: number;
  /** Retain this ID when retrying an uncertain publication outcome. */
  requestId: string;
};
export type WorkspaceConfigurationCheckRecordDto = {
  id: string;
  missionId: string;
  versionId: string;
  versionNumber: number;
  actorId: string;
  retryOf: string | null;
  createdAt: string;
  result: WorkspaceConfigurationCheckDto;
};
export type WorkspaceRecordConfigurationCheckDto = {
  versionId: string;
  /** Original check of this same mission/version; this repeats only readonly configuration checks. */
  retryOf?: string;
};
export type WorkspaceConfigurationChecksDto = {
  items: WorkspaceConfigurationCheckRecordDto[];
  next: string | null;
};
export type WorkspaceCallEventMetadataDto = {
  campaignId: string;
  type: string;
  status: string;
  direction: ('inbound' | 'outbound') | null;
  endedReason: string | null;
  agentId: string | null;
  squadId: string | null;
};
export type WorkspaceEventPreviewDto = {
  metadata: WorkspaceCallEventMetadataDto;
  matches: boolean;
};
export type WorkspacePreviewEventDto = {
  spec: WorkspaceMissionSpecDto;
  callId: string;
};
export type BillingTopUpOfferDto = {
  id: string;
  title: string;
  units: string;
  creditScale: number;
  currency: string;
  currencyScale: number;
  amountMinor: string;
};
export type BillingTopUpBalanceDto = {
  creditScale: number;
  chargingPolicyVersion: string;
  grantedUnits: string;
  spentUnits: string;
  heldUnits: string;
  availableUnits: string;
};
export type BillingTopUpPurchaseDto = {
  kind: 'manual' | 'automatic';
  id: string;
  offerId: string;
  title: string;
  units: string;
  creditScale: number;
  currency: string;
  currencyScale: number;
  amountMinor: string;
  state:
    | 'prepared'
    | 'sending'
    | 'unknown'
    | 'open'
    | 'pending'
    | 'succeeded'
    | 'expired'
    | 'review';
  createdAt: string;
};
export type BillingTopUpsDto = {
  version: 1;
  canPurchase: boolean;
  activePaidPeriod: boolean;
  checkoutEnabled: boolean;
  offers: BillingTopUpOfferDto[];
  balances: BillingTopUpBalanceDto[];
  purchases: BillingTopUpPurchaseDto[];
  hasMorePurchases: boolean;
  nextPurchaseCursor?: string | null;
};
export type StripeTopUpResultDto = {
  version: 1;
  purchaseId: string;
  state: 'open' | 'pending' | 'expired' | 'succeeded';
  url: string | null;
};
export type StripeTopUpRequestDto = {
  offerId: string;
  requestKey: string;
};
export type AutoTopUpPendingDto = {
  purchaseId: string;
  state: string;
  needsAttention: boolean;
};
export type AutoTopUpSettingsDto = {
  version: 1;
  enabled: boolean;
  configId?: string | null;
  readySetupConsentText?: string | null;
  canManage: boolean;
  canEnable: boolean;
  paused: boolean;
  thresholdCredits: string;
  budgetMinor: string;
  currency: string;
  currencyScale: number;
  spentMinor: string;
  reservedMinor: string;
  remainingMinor: string;
  periodEndsAt: string | null;
  offer: (BillingTopUpOfferDto | (null | null)) | null;
  pending: (AutoTopUpPendingDto | (null | null)) | null;
  readySetupId: string | null;
  termsVersion: string;
  consentText: string;
};
export type AutoTopUpSetupResultDto = {
  setupId: string;
  state: 'open' | 'ready' | 'expired';
  url: string | null;
};
export type AutoTopUpSetupDto = {
  requestKey: string;
  thresholdCredits?: string;
  budgetMinor?: string;
  offerId: string;
  acceptTerms: true;
};
export type AutoTopUpConfirmDto = {
  requestKey: string;
  setupId: string;
  acceptTerms: true;
};
export type AutoTopUpRequestDto = {
  requestKey: string;
};
export type AutoTopUpPaymentDto = {
  automaticEnabled?: boolean;
  state: 'pending' | 'succeeded' | 'expired';
  url: string | null;
};
export type BillingSubscriptionDetailsDto = {
  planVersionId: string;
  status: string;
  amountMinor: string;
  currency: string;
  currencyScale: number;
  interval: string;
  intervalCount: number;
  cancelAtPeriodEnd: boolean;
  startsAt: string | null;
  endsAt: string | null;
};
export type BillingSubscriptionInvoiceDto = {
  id: string;
  number: string | null;
  createdAt: string;
  description: string;
  planName: string;
  status: 'draft' | 'open' | 'paid' | 'uncollectible' | 'void' | 'unknown';
  amountMinor: string;
  currency: string;
  currencyScale: number | null;
  startsAt: string | null;
  endsAt: string | null;
  creditUnits: string | null;
  creditScale: number | null;
  invoicePdfUrl: string | null;
};
export type BillingHistoryDto = {
  version: 1;
  subscription: (BillingSubscriptionDetailsDto | (null | null)) | null;
  invoices: BillingSubscriptionInvoiceDto[];
  hasMoreInvoices: boolean;
  nextInvoiceCursor: string | null;
};
export type BillingUsageDayDto = {
  date: string;
  planUnits: string;
  topUpUnits: string;
  totalUnits: string;
};
export type BillingUsageResourceDto = {
  campaignId: string | null;
  campaignName: string;
  agentId: string | null;
  agentName: string;
  calls: number;
  totalUnits: string;
};
export type BillingUsageDto = {
  version: 1;
  asOf: string;
  from: string;
  to: string;
  creditScale: number;
  chargingPolicyVersion: string;
  planUnits: string;
  topUpUnits: string;
  totalUnits: string;
  calls: number;
  days: BillingUsageDayDto[];
  resources: BillingUsageResourceDto[];
};
export type BillingPurchaseDocumentDto = {
  url: string | null;
  kind: string | null;
};
export type AutoTopUpUpdateDto = {
  requestKey: string;
  configId: string;
  thresholdCredits: string;
  budgetMinor: string;
  acceptTerms: true;
};
export type BillingMoneyGroupDto = {
  currency: string;
  currencyScale: number;
  subscriptionMinor: string;
  manualMinor: string;
  automaticMinor: string;
  totalMinor: string;
};
export type BillingPublicRateDto = {
  id: string;
  profile: string;
  scope: string;
  unitsPerMinute: string;
  multiplierNumerator: string;
  multiplierDenominator: string;
  minimumUnits: string;
};
export type BillingInsightsDto = {
  billingAddress: string | null;
  taxStatus: string | null;
  periodId: string | null;
  payments: BillingMoneyGroupDto[];
  rates: BillingPublicRateDto[];
  paymentBrand: string | null;
  paymentLast4: string | null;
  billingName: string | null;
  billingEmail: string | null;
  billingCountry: string | null;
};
export type BillingUsageCallDto = {
  callId: string;
  date: string;
  campaignId: string | null;
  campaignName: string;
  agentId: string | null;
  agentName: string;
  planUnits: string;
  topUpUnits: string;
  totalUnits: string;
};
export type BillingUsageCallsDto = {
  chargingPolicyVersion: string;
  from: string;
  to: string;
  creditScale: number;
  calls: BillingUsageCallDto[];
  nextCursor: string | null;
};
export const {
  useAppControllerGetHelloQuery,
  useMetricsControllerWebhookQuery,
  useRefreshTokensControllerRefreshTokenUserMutation,
  useRefreshTokensControllerRefreshTokenAdminMutation,
  useSignInControllerSignInUserMutation,
  useSignInControllerSignInAdminMutation,
  useSignOutControllerSignOutUserMutation,
  useSignOutControllerSignOutAdminMutation,
  useApiKeyControllerGetSystemApiKeyInfoQuery,
  useOidcLoginStartControllerAuthorizeQuery,
  useOidcLoginCompleteControllerCallbackQuery,
  useForgotPasswordControllerForgotPasswordMutation,
  useResetPasswordControllerResetPasswordMutation,
  useUserMeControllerUserMeQuery,
  useUserListControllerListQuery,
  useUserListControllerListForManagerQuery,
  useUserCreateControllerCreateUserMutation,
  useUserUpdateControllerUpdateMutation,
  useAdminMeControllerAdminMeQuery,
  usePermissionGroupCreateControllerCreateMutation,
  usePermissionGroupListControllerListQuery,
  usePermissionGroupCreateControllerCreateForManagerMutation,
  usePermissionGroupListControllerListForManagerQuery,
  usePermissionGroupUpdateControllerUpdateMutation,
  usePermissionGroupDeleteControllerDeleteMutation,
  usePermissionGroupUpdateControllerUpdateForManagerMutation,
  usePermissionGroupDeleteControllerDeleteForManagerMutation,
  useUserPermissionGroupAttachControllerAttachMutation,
  useUserPermissionGroupDetachControllerDetachMutation,
  useUserPermissionGroupAttachControllerAttachForManagerMutation,
  useUserPermissionGroupDetachControllerDetachForManagerMutation,
  useUserPermissionGroupListControllerListQuery,
  useUserPermissionGroupListControllerListForManagerQuery,
  useAnalysisStaleSweepControllerSystemAnalysisStaleSweepMutation,
  useCallAnalysisCreateControllerSystemCreateCallAnalysisMutation,
  useCallSentimentCreateControllerCreateCallSentimentMutation,
  useCallUpdateControllerSystemCallUpdateMutation,
  useCallControllerSystemGetCallByIdQuery,
  useCallSupervisorModeControllerSetSupervisorModeMutation,
  useCallStaleSweepControllerSystemStaleSweepMutation,
  useCampaignTestCallCreateControllerTestCallCreateMutation,
  useCampaignCallListControllerCallListQuery,
  useCampaignTestCallCreateControllerExternalTestCallCreateMutation,
  useCallCreateExternalControllerCampaignOutboundCallMutation,
  useCampaignCallHangupControllerCampaignCallHangupMutation,
  useCampaignCallHangupControllerExternalCampaignCallHangupMutation,
  useCampaignCloneSystemControllerCloneCampaignMutation,
  useCampaignCreateControllerCampaignCreateMutation,
  useCampaignListControllerCampaignListQuery,
  useCampaignDeleteControllerDeleteCampaignMutation,
  useCampaignUpdateControllerCampaignUpdateMutation,
  useCampaignControllerCampaignQuery,
  useCampaignIntegrationSchedulerRunControllerSystemRunIntegrationSchedulerMutation,
  useCampaignAnalysisBatchRunControllerSystemRunAnalysisBatchMutation,
  useCampaignStructuredOutputGenerateControllerGenerateMutation,
  useCampaignOutboundCallsProcessControllerSystemOutboundCallsProcessMutation,
  useCampaignRunControllerCampaignRunMutation,
  useCampaignSipTrunkCreateControllerCampaignCreateMutation,
  useCampaignSipTrunkControllerGetSipTrunkQuery,
  useCampaignStopControllerCampaignStopMutation,
  useCampaignsStopExceededLimitsControllerStopExceededLimitsMutation,
  useCustomerUpdateControllerUpdateCustomerMutation,
  useCampaignAgentCreateControllerExecuteMutation,
  useCampaignAgentListControllerListQuery,
  useCampaignAgentUpdateControllerExecuteMutation,
  useCampaignAgentDeleteControllerExecuteMutation,
  useCallActionCreateControllerSystemCallActionCreateMutation,
  useCallCreateSystemControllerSystemCampaignCallCreateMutation,
  useCallControllerGetCallByIdQuery,
  useCampaignControllerSystemCampaignQuery,
  useCampaignCallControllerCallQuery,
  useCampaignCallListPaginatedControllerCallListPaginatedQuery,
  useCampaignFileListControllerListQuery,
  useCampaignListControllerExternalCampaignListQuery,
  useCampaignListPaginatedControllerGetCampaignListPaginatedQuery,
  useCampaignMetricCallDurationControllerCalculateCallDurationIqrQuery,
  useCampaignReportControllerUserCampaignsReportQuery,
  useCampaignReportControllerUserCampaignReportQuery,
  useCampaignReportControllerAdminCampaignsReportQuery,
  useCampaignReportControllerAdminCampaignReportQuery,
  useCallAccessTokenControllerGetCallAccessTokenQuery,
  useCallAccessTokenControllerGetExternalCallAccessTokenQuery,
  useCallRecordingControllerGetCallRecordingQuery,
  useCampaignActiveCallPollControllerExternalCampaignActiveCallPollQuery,
  useCallNotAnalyzedListControllerSystemGetNotAnalyzedCallsQuery,
  useCustomerListPaginatedControllerGetCustomerListPaginatedQuery,
  useCustomerListExportControllerGetCustomerListForExportQuery,
  useBackgroundSoundAgentSettingsUpdateControllerExecuteMutation,
  useBackgroundSoundCreateControllerCreateMutation,
  useBackgroundSoundListControllerAdminListQuery,
  useBackgroundSoundDeleteControllerDeleteMutation,
  useBackgroundSoundUpdateControllerUpdateMutation,
  useBackgroundSoundUploadUrlControllerCreateUploadUrlMutation,
  useBackgroundSoundListControllerListQuery,
  useVoiceListControllerVoiceListQuery,
  useVoiceListSystemControllerGetAllVoicesQuery,
  useVoiceControllerGetVoiceQuery,
  useVoiceDeleteControllerDeleteVoiceMutation,
  useVoiceEditControllerEditVoiceMutation,
  useVoiceSystemControllerGetVoiceQuery,
  useVoiceEditSystemControllerEditVoiceMutation,
  useVoiceCreateControllerCreateVoiceMutation,
  useVoiceCreateSystemControllerCreateVoiceMutation,
  useVoiceDeleteSystemControllerDeleteVoiceMutation,
  useCustomTranscriberEditControllerEditTranscriberMutation,
  useCustomTranscriberCreateControllerCreateTranscriberMutation,
  useTranscriberListControllerTranscriberListQuery,
  useTranscriberListControllerGetTranscriberQuery,
  useTranscriberListControllerAdminTranscriberListQuery,
  useTranscriberCreateControllerCreateTranscriberMutation,
  useTranscriberControllerGetTranscriberQuery,
  useTranscriberDeleteControllerDeleteTranscriberMutation,
  useTranscriberEditControllerEditTranscriberMutation,
  useCreateCompanyControllerCreateCompanyMutation,
  useCompanyControllerGetCompanyQuery,
  useCompanyControllerGetCompanyAsAdminQuery,
  useEditCompanyControllerEditCompanyMutation,
  useGetAllCompanyIdsControllerGetAllCompanyIdsQuery,
  useCompanyApiKeyCreateControllerApiKeyCreateMutation,
  useCompanyApiKeyRevokeControllerApiKeyRevokeMutation,
  useAgentProfileCreateControllerAgentProfileCreateForUsersMutation,
  useAgentProfileListControllerAgentProfileListForUsersQuery,
  useAgentProfileCreateControllerAgentProfileCreateForManagersMutation,
  useAgentProfileListControllerAgentProfileListForAdminsQuery,
  useAgentProfileEditControllerAgentProfileEditForUsersMutation,
  useAgentProfileDeleteControllerAgentProfileDeleteForUsersMutation,
  useAgentProfileEditControllerAgentProfileEditForManagersMutation,
  useAgentProfileDeleteControllerAgentProfileDeleteForManagersMutation,
  useCompanyOverviewControllerGetCompanyOverviewQuery,
  useCompanyListControllerCompanyListQuery,
  useUsageLimitControllerUsageLimitsQuery,
  useUsageLimitControllerAdminUsageLimitsQuery,
  useUsageLimitSetControllerSetLimitsMutation,
  useUsageLimitControllerSystemUsageLimitsQuery,
  useCompanyVoicesSetControllerSetCompanyVoicesMutation,
  useCompanyTranscribersSetControllerSetCompanyTranscribersMutation,
  useCompanyLlmProvidersSetControllerSetCompanyLlmProvidersMutation,
  useConcurrentLimitSetControllerSetConcurrentLimitMutation,
  useUnitWeightsControllerGetUnitWeightsQuery,
  useUnitWeightsSetControllerSetUnitWeightsMutation,
  useLivekitControllerWebhookMutation,
  useCampaignPostCallMessageCreateControllerCreateMutation,
  useCampaignPostCallMessagesControllerListQuery,
  useCampaignPostCallMessageUpdateControllerUpdateMutation,
  useCampaignPostCallMessageDeleteControllerDeleteMutation,
  useMessageDeliverySweepControllerSystemDeliverySweepMutation,
  useMessageDeliveryUpdateControllerWebhookMutation,
  useFileCreateControllerCreateMutation,
  useFileListControllerListQuery,
  useFileDeleteControllerDeleteMutation,
  useFileControllerGetQuery,
  useCampaignFileAvailabilityUpdateControllerUpdateMutation,
  useCampaignFileAgentsSetControllerReplaceMutation,
  useCampaignFileDeleteControllerRemoveMutation,
  useFileOriginalControllerGetQuery,
  useCampaignFileSearchControllerSearchQuery,
  useFileReindexControllerReindexMutation,
  useSquadCreateControllerExecuteMutation,
  useSquadDeleteControllerExecuteMutation,
  useSquadAgentCreateControllerExecuteMutation,
  useSquadAgentUpdateControllerExecuteMutation,
  useSquadAgentDeleteControllerExecuteMutation,
  useHandoffRuleCreateControllerExecuteMutation,
  useStructuredOutputCreateControllerCreateMutation,
  useStructuredOutputListControllerListQuery,
  useStructuredOutputUpdateControllerUpdateMutation,
  useStructuredOutputDeleteControllerDeleteMutation,
  useStructuredOutputControllerGetQuery,
  useStructuredOutputTemplateListControllerListQuery,
  useStructuredOutputTemplateControllerGetQuery,
  useCampaignStructuredOutputAttachControllerAttachMutation,
  useCampaignStructuredOutputListControllerListQuery,
  useCampaignStructuredOutputDetachControllerDetachMutation,
  useToolCreateControllerCreateCampaignToolMutation,
  useToolListControllerCampaignToolListQuery,
  useToolCreateControllerCreateAgentToolMutation,
  useToolListControllerAgentTollListQuery,
  useToolUpdateControllerCreateCampaignToolMutation,
  useToolDeleteControllerCreateCampaignToolMutation,
  useToolUpdateControllerCreateAgentToolMutation,
  useToolDeleteControllerCreateAgentToolMutation,
  useLlmProviderListControllerProviderListQuery,
  useLlmProviderListControllerAdminProviderListQuery,
  useLlmModelListControllerModelListQuery,
  useLlmModelListControllerAdminModelListQuery,
  useCampaignWebhookCreateControllerCreateMutation,
  useCampaignWebhooksControllerListQuery,
  useCampaignWebhookUpdateControllerUpdateMutation,
  useCampaignWebhookDeleteControllerDeleteMutation,
  useCampaignWebhookDispatchControllerManualDispatchMutation,
  useCampaignWebhookDispatchControllerSystemDispatchMutation,
  useWebhookDeliverySweepControllerSystemDeliverySweepMutation,
  useHealthControllerCheckQuery,
  useUsageMonitoringControllerGetUsageQuery,
  useBillingControllerOffersQuery,
  useBillingControllerCompanyQuery,
  useBillingControllerManagerQuery,
  useBillingControllerPublishPolicyMutation,
  useBillingControllerEnrollMutation,
  useBillingControllerAdmissionMutation,
  useBillingControllerAdjustMutation,
  useStripeBillingControllerStartCheckoutMutation,
  useStripePortalControllerOpenMutation,
  useStripeSynchronizationControllerReadQuery,
  useStripeSynchronizationControllerRequestMutation,
  useStripeSynchronizationControllerRequestManagerMutation,
  useStripeUpgradeControllerApplyMutation,
  useStripeUpgradeControllerPreviewMutation,
  useStripeUpgradeControllerPaymentQuery,
  useStripeScheduledChangeControllerRequestMutation,
  useBillingControllerOptionsQuery,
  useBillingControllerPaymentExceptionsQuery,
  useBillingControllerResolvePaymentExceptionMutation,
  useWorkspaceControllerListQuery,
  useWorkspaceControllerCreateMutation,
  useWorkspaceControllerDetailQuery,
  useWorkspaceControllerSaveMutation,
  useWorkspaceControllerRemoveMutation,
  useWorkspaceControllerPublishMutation,
  useWorkspaceControllerPauseMutation,
  useWorkspaceControllerRunMutation,
  useWorkspaceControllerRunsQuery,
  useWorkspaceControllerConfirmMutation,
  useWorkspaceControllerCancelMutation,
  useWorkspaceControllerModelsQuery,
  useWorkspaceControllerAskMutation,
  useWorkspaceControllerCheckConfigurationMutation,
  useWorkspaceControllerJobsUsageQuery,
  useWorkspaceControllerJobUsageDetailQuery,
  useWorkspaceStudioControllerDetailQuery,
  useWorkspaceStudioControllerInitializeMutation,
  useWorkspaceStudioControllerVersionsQuery,
  useWorkspaceStudioControllerBranchMutation,
  useWorkspaceStudioControllerSaveMutation,
  useWorkspaceStudioControllerRemoveMutation,
  useWorkspaceStudioControllerSyncMutation,
  useWorkspaceStudioControllerRestoreMutation,
  useWorkspaceStudioControllerPublishMutation,
  useWorkspaceControllerRecordConfigurationCheckMutation,
  useWorkspaceControllerConfigurationChecksQuery,
  useWorkspaceControllerPreviewEventMutation,
  usePrivateRuntimeConfigControllerPublishMutation,
  usePrivateRuntimeConfigControllerResolveQuery,
  useWidgetControllerGetQuery,
  useWidgetControllerSaveMutation,
  useWidgetControllerPublishMutation,
  useWidgetControllerDisableMutation,
  usePublicWidgetControllerConfigQuery,
  usePublicWidgetControllerSessionMutation,
  useWorkspaceControllerAcknowledgeReviewMutation,
  useConversationFinalizationControllerPublishMutation,
  usePreCallContextControllerLookupMutation,
  useStripeTopUpControllerCatalogQuery,
  useStripeTopUpControllerCheckoutMutation,
  useStripeAutoTopUpControllerReadQuery,
  useStripeAutoTopUpControllerSetupMutation,
  useStripeAutoTopUpControllerEnableMutation,
  useStripeAutoTopUpControllerDisableMutation,
  useStripeAutoTopUpControllerPaymentMutation,
  useStripeAutoTopUpControllerCancelMutation,
  useStripeBillingHistoryControllerReadQuery,
  useBillingUsageControllerReadQuery,
  useStripeBillingHistoryControllerDocumentQuery,
  useStripeAutoTopUpControllerUpdateMutation,
  useBillingInsightsControllerReadQuery,
  useBillingUsageControllerCallsQuery,
} = injectedRtkApi;
